import React, { useState, useEffect, useCallback, useMemo, Suspense, useRef, Fragment } from 'react';
import { Transition, Menu, Listbox, Switch, Disclosure } from '@headlessui/react';
import ReactTooltip from 'react-tooltip';
import dayjs from 'dayjs';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["className", "color", "id", "as"];
var defaultProps = {
  as: 'div',
  id: 'color-el'
};
var Color = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    color = _ref.color,
    id = _ref.id,
    Component = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(Component, Object.assign({
    className: className + " text-primary font-semibold p-4",
    "data-testid": id,
    ref: ref
  }, rest), React.createElement("p", null, color == null ? void 0 : color.title), React.createElement("br", null), React.createElement("div", {
    className: "grid gap-x-8 gap-y-4 grid-cols-3 mb-4"
  }, color && Object.keys(color.codes).map(function (code) {
    return React.createElement("div", {
      className: "p-4 rounded-lg shadow-broad " + code + " flex justify-between",
      key: code
    }, React.createElement("small", null, code), React.createElement("small", null, color.codes[code]));
  })));
});
Color.displayName = 'Color';
Color.defaultProps = defaultProps;

var GridContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    role = _ref.role,
    Component = _ref.as,
    is_always_mobile = _ref.is_always_mobile;
  var classes = "grid grid-cols-4 " + (is_always_mobile ? '' : 'md:grid-cols-12') + " " + className;
  return React.createElement(Component, {
    className: classes,
    "data-testid": id,
    ref: ref,
    role: role
  }, children);
});
GridContainer.displayName = 'Grid';
GridContainer.defaultProps = {
  as: 'div'
};
var GridItem = function GridItem(_ref2) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    role = _ref2.role,
    Component = _ref2.as;
  return React.createElement(Component, {
    className: "self-center " + className,
    role: role
  }, children);
};
GridItem.displayName = 'GridItem';
GridItem.defaultProps = {
  as: 'div'
};
var Grid = /*#__PURE__*/Object.assign(GridContainer, {
  Item: GridItem
});

var SVGS = {
  'arrow-left': function arrowLeft(_ref) {
    var id = _ref.id,
      className = _ref.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.62117 0.292893C9.23065 -0.0976311 8.59748 -0.0976311 8.20696 0.292893L-0.000150681 8.5L8.20696 16.7071C8.59748 17.0976 9.23065 17.0976 9.62117 16.7071C10.0117 16.3166 10.0117 15.6834 9.62117 15.2929L3.82828 9.5H16.9141C17.4663 9.5 17.9141 9.05229 17.9141 8.5C17.9141 7.94772 17.4663 7.5 16.9141 7.5H3.82828L9.62117 1.70711C10.0117 1.31658 10.0117 0.683417 9.62117 0.292893Z",
      fill: "#F3EEFC"
    }));
  },
  events: function events(_ref2) {
    var id = _ref2.id,
      className = _ref2.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "62",
      height: "64",
      viewBox: "0 0 62 64",
      fill: "none"
    }, React.createElement("path", {
      d: "M15 9.63333C15 5.14141 18.5817 1.49999 23 1.49999H53C57.4183 1.49999 61 5.14141 61 9.63333V40.1333C61 44.6253 57.4183 48.2667 53 48.2667H23C18.5817 48.2667 15 44.6253 15 40.1333V9.63333Z",
      stroke: "url(#paint0_linear_4188_182)",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M46 55.3833H16C11.5817 55.3833 8 51.8016 8 47.3833V16.75",
      stroke: "url(#paint1_linear_4188_182)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M39 62.5H9C4.58172 62.5 1 58.9183 1 54.5V23.8667",
      stroke: "url(#paint2_linear_4188_182)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M25 26.6514L33.1818 35.05L52 15.7333",
      stroke: "url(#paint3_linear_4188_182)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_4188_182",
      x1: "15",
      y1: "24.8833",
      x2: "61",
      y2: "24.8833",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint1_linear_4188_182",
      x1: "8",
      y1: "36.0667",
      x2: "46",
      y2: "36.0667",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint2_linear_4188_182",
      x1: "1",
      y1: "43.1833",
      x2: "39",
      y2: "43.1833",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint3_linear_4188_182",
      x1: "25",
      y1: "25.3917",
      x2: "52",
      y2: "25.3917",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    }))));
  },
  invested: function invested(_ref3) {
    var id = _ref3.id,
      className = _ref3.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "62",
      height: "64",
      viewBox: "0 0 62 64",
      fill: "none"
    }, React.createElement("path", {
      d: "M49 19.0882C49 20.0248 48.4375 20.9207 47.4113 21.7457M25 26.5C11.7452 26.5 1 23.1817 1 19.0882",
      stroke: "url(#paint0_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M1 31.0882C1 34.5418 8.64864 37.4437 19 38.2665",
      stroke: "url(#paint1_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M1 43.0882C1 46.7608 9.64915 49.8094 21 50.3975",
      stroke: "url(#paint2_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M1 55.0882C1 59.1817 11.7452 62.5 25 62.5C28.3746 62.5 31.5866 62.2849 34.5 61.8967",
      stroke: "url(#paint3_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("ellipse", {
      cx: "25",
      cy: "8.99999",
      rx: "24",
      ry: "7.5",
      stroke: "url(#paint4_linear_4188_165)",
      strokeWidth: "2"
    }), React.createElement("circle", {
      cx: "40",
      cy: "41.5",
      r: "21",
      stroke: "url(#paint5_linear_4188_165)",
      strokeWidth: "2"
    }), React.createElement("rect", {
      x: "33.1567",
      y: "37.5808",
      width: "10.108",
      height: "4.1351",
      transform: "rotate(-45 33.1567 37.5808)",
      fill: "url(#paint6_linear_4188_165)"
    }), React.createElement("rect", {
      x: "28.9333",
      y: "41.8043",
      width: "4.1351",
      height: "4.1351",
      transform: "rotate(-45 28.9333 41.8043)",
      fill: "url(#paint7_linear_4188_165)"
    }), React.createElement("rect", {
      x: "33.3191",
      y: "46.1902",
      width: "16.0809",
      height: "4.1351",
      transform: "rotate(-45 33.3191 46.1902)",
      fill: "url(#paint8_linear_4188_165)"
    }), React.createElement("rect", {
      x: "37.7051",
      y: "50.5761",
      width: "16.0809",
      height: "4.1351",
      transform: "rotate(-45 37.7051 50.5761)",
      fill: "url(#paint9_linear_4188_165)"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_4188_165",
      x1: "1",
      y1: "22.7941",
      x2: "49",
      y2: "22.7941",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint1_linear_4188_165",
      x1: "1",
      y1: "34.6774",
      x2: "19",
      y2: "34.6774",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint2_linear_4188_165",
      x1: "1",
      y1: "46.7429",
      x2: "21",
      y2: "46.7429",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint3_linear_4188_165",
      x1: "1",
      y1: "58.7941",
      x2: "34.5",
      y2: "58.7941",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint4_linear_4188_165",
      x1: "1",
      y1: "8.99999",
      x2: "49",
      y2: "8.99999",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint5_linear_4188_165",
      x1: "19",
      y1: "41.5",
      x2: "61",
      y2: "41.5",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint6_linear_4188_165",
      x1: "33.1567",
      y1: "39.6483",
      x2: "43.2647",
      y2: "39.6483",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint7_linear_4188_165",
      x1: "28.9333",
      y1: "43.8718",
      x2: "33.0684",
      y2: "43.8718",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint8_linear_4188_165",
      x1: "33.3191",
      y1: "48.2577",
      x2: "49.4",
      y2: "48.2577",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    })), React.createElement("linearGradient", {
      id: "paint9_linear_4188_165",
      x1: "37.7051",
      y1: "52.6436",
      x2: "53.786",
      y2: "52.6436",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#E61A67"
    }))));
  },
  'farms-loader': function farmsLoader(_ref4) {
    var id = _ref4.id,
      className = _ref4.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: "animate-spin " + className,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 328 328",
      fill: "none"
    }, React.createElement("circle", {
      cx: "164",
      cy: "164",
      r: "160",
      stroke: "url(#paint0_linear_3495_15230)",
      strokeWidth: "8"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_3495_15230",
      x1: "48.4444",
      y1: "279.556",
      x2: "301.778",
      y2: "26.2223",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#AE1E55",
      stopOpacity: "0"
    }))));
  },
  'client-portal-icon': function clientPortalIcon(_ref5) {
    var id = _ref5.id,
      className = _ref5.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "22",
      height: "22",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 22 22",
      fill: "none"
    }, React.createElement("rect", {
      x: "1",
      y: "1",
      width: "20",
      height: "20",
      rx: "2",
      stroke: "#AE1E55",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M12 5L8.10365 10.8445C8.05934 10.911 8.10698 11 8.18685 11H13.8131C13.893 11 13.9407 11.089 13.8964 11.1555L10 17",
      stroke: "#AE1E55",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  'copy-btn': function copyBtn(_ref6) {
    var id = _ref6.id,
      className = _ref6.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      id: id,
      "data-testid": id,
      className: className,
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9211 10.1826C10.2611 10.1826 9.726 10.7177 9.726 11.3777V21.2558C9.726 21.9158 10.2611 22.4509 10.9211 22.4509H20.7992C21.4592 22.4509 21.9943 21.9158 21.9943 21.2558V11.3777C21.9943 10.7177 21.4592 10.1826 20.7992 10.1826H10.9211ZM7.726 11.3777C7.726 9.61312 9.1565 8.18262 10.9211 8.18262H20.7992C22.5638 8.18262 23.9943 9.61312 23.9943 11.3777V21.2558C23.9943 23.0204 22.5638 24.4509 20.7992 24.4509H10.9211C9.1565 24.4509 7.726 23.0204 7.726 21.2558V11.3777Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.23801 2.5C2.92105 2.5 2.61706 2.62591 2.39294 2.85004C2.16881 3.07417 2.04289 3.37816 2.04289 3.69512V13.5732C2.04289 13.8901 2.16881 14.1941 2.39294 14.4182C2.61706 14.6424 2.92105 14.7683 3.23801 14.7683H4.33558C4.88786 14.7683 5.33558 15.216 5.33558 15.7683C5.33558 16.3206 4.88786 16.7683 4.33558 16.7683H3.23801C2.39061 16.7683 1.57792 16.4317 0.978722 15.8325C0.37952 15.2333 0.0428925 14.4206 0.0428925 13.5732V3.69512C0.0428925 2.84772 0.37952 2.03503 0.978722 1.43583C1.57792 0.836628 2.39062 0.5 3.23801 0.5H13.1161C13.9635 0.5 14.7762 0.836628 15.3754 1.43583C15.9746 2.03503 16.3112 2.84772 16.3112 3.69512V4.79268C16.3112 5.34497 15.8635 5.79268 15.3112 5.79268C14.7589 5.79268 14.3112 5.34497 14.3112 4.79268V3.69512C14.3112 3.37816 14.1853 3.07417 13.9611 2.85004C13.737 2.62591 13.433 2.5 13.1161 2.5H3.23801Z",
      fill: "currentColor"
    }));
  },
  loader: function loader(_ref7) {
    var id = _ref7.id,
      className = _ref7.className;
    return React.createElement("svg", {
      id: id,
      role: "status",
      "data-testid": id,
      className: "animate-spin " + className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none"
    }, React.createElement("circle", {
      cx: "11",
      cy: "11",
      r: "10",
      stroke: "url(#paint0_linear_3714_88)",
      strokeWidth: "2"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_3714_88",
      x1: "-5.31579",
      y1: "26",
      x2: "21.0017",
      y2: "1.00178",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#F3EEFC"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#F3EEFC",
      stopOpacity: "0"
    }))));
  },
  vesting: function vesting(_ref8) {
    var className = _ref8.className,
      id = _ref8.id;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 32 32",
      fill: "none"
    }, React.createElement("path", {
      d: "M16.8429 19.6371C16.4512 20.2638 15.5385 20.2638 15.1469 19.6371L11.9526 14.5262C11.5363 13.8602 12.0151 12.9962 12.8005 12.9962L19.1892 12.9962C19.9746 12.9962 20.4534 13.8602 20.0372 14.5262L16.8429 19.6371Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M25.9924 2.50366C23.2549 4.69606 19.7811 6.00728 16.0011 6.00728C12.2211 6.00728 8.74728 4.69607 6.00977 2.50366",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M25.9924 29.4963C23.2549 27.3039 19.7811 25.9927 16.0011 25.9927C12.2211 25.9927 8.74728 27.3039 6.00977 29.4963",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M29.4961 25.9914C27.3037 23.2539 25.9925 19.7802 25.9925 16.0001C25.9925 12.2201 27.3037 8.7463 29.4961 6.00879",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M2.5042 25.9914C4.6966 23.2539 6.00781 19.7802 6.00781 16.0001C6.00781 12.2201 4.6966 8.7463 2.5042 6.00879",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  staking: function staking(_ref9) {
    var className = _ref9.className,
      id = _ref9.id;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 34 34",
      fill: "none"
    }, React.createElement("path", {
      d: "M8 3.90974C10.5642 2.16208 13.6628 1.14038 17 1.14038C20.3372 1.14038 23.4358 2.16208 26 3.90974M3.76936 8.14038C2.0217 10.7046 1 13.8032 1 17.1404C1 24.9515 6.59742 31.4554 14 32.8596M30.2306 8.14038C31.9783 10.7046 33 13.8032 33 17.1404C33 24.9516 27.4026 31.4554 20 32.8596",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M16.1362 11.6211C16.5221 10.9596 17.4779 10.9596 17.8638 11.6211L23.1227 20.6365C23.5116 21.3032 23.0308 22.1404 22.259 22.1404H11.741C10.9692 22.1404 10.4884 21.3032 10.8773 20.6365L16.1362 11.6211Z",
      fill: "currentColor"
    }));
  },
  farm: function farm(_ref10) {
    var className = _ref10.className,
      id = _ref10.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 32 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      d: "M14.9896 1.41122C15.6149 1.0501 16.3851 1.0501 17.0104 1.41122L28.9896 8.33025C29.6149 8.69136 30 9.35873 30 10.081V23.919C30 24.6412 29.6148 25.3086 28.9896 25.6697L17.0104 32.5888C16.3851 32.9499 15.6149 32.9499 14.9896 32.5888L3.01036 25.6697C2.38515 25.3086 2 24.6412 2 23.919V10.081C2 9.35873 2.38515 8.69136 3.01036 8.33025L14.9896 1.41122Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M15.6392 11.1542C15.8624 11.0188 16.1376 11.0188 16.3608 11.1542L20.6392 13.7488C20.8624 13.8842 21 14.1345 21 14.4053V19.5946C21 19.8654 20.8624 20.1157 20.6392 20.2511L16.3608 22.8458C16.1376 22.9812 15.8624 22.9812 15.6392 22.8458L11.3608 20.2511C11.1376 20.1157 11 19.8654 11 19.5946V14.4053C11 14.1345 11.1376 13.8842 11.3608 13.7488L15.6392 11.1542Z",
      fill: "currentColor"
    }));
  },
  'chevron-down': function chevronDown(_ref11) {
    var className = _ref11.className,
      id = _ref11.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 12"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.04289 1.0858C1.43342 0.695277 2.06658 0.695277 2.45711 1.0858L9.75 8.37869L17.0429 1.0858C17.4334 0.695277 18.0666 0.695277 18.4571 1.0858C18.8476 1.47633 18.8476 2.10949 18.4571 2.50001L9.75 11.2071L1.04289 2.50001C0.652369 2.10949 0.652369 1.47633 1.04289 1.0858Z",
      fill: "currentColor"
    }));
  },
  'chevron-left': function chevronLeft(_ref12) {
    var className = _ref12.className,
      id = _ref12.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 13 20"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0391 19.7071C11.6486 20.0976 11.0154 20.0976 10.6249 19.7071L0.917819 10L10.6249 0.292892C11.0155 -0.0976316 11.6486 -0.0976315 12.0391 0.292892C12.4297 0.683418 12.4297 1.31658 12.0391 1.70711L3.74625 10L12.0391 18.2929C12.4297 18.6834 12.4297 19.3166 12.0391 19.7071Z",
      fill: "currentColor"
    }));
  },
  'chevron-right': function chevronRight(_ref13) {
    var className = _ref13.className,
      id = _ref13.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 11 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.721604 17.7071C0.33108 17.3166 0.33108 16.6834 0.721604 16.2929L8.0145 9L0.721603 1.70711C0.331079 1.31658 0.331079 0.683418 0.721603 0.292892C1.11213 -0.0976315 1.74529 -0.0976315 2.13582 0.292892L10.8429 9L2.13582 17.7071C1.74529 18.0976 1.11213 18.0976 0.721604 17.7071Z",
      fill: "currentColor"
    }));
  },
  'chevron-up': function chevronUp(_ref14) {
    var className = _ref14.className,
      id = _ref14.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 12"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.292893 10.9142C0.683417 11.3047 1.31658 11.3047 1.70711 10.9142L9 3.62131L16.2929 10.9142C16.6834 11.3047 17.3166 11.3047 17.7071 10.9142C18.0976 10.5237 18.0976 9.89051 17.7071 9.49999L9 0.792879L0.292893 9.49999C-0.0976311 9.89051 -0.0976311 10.5237 0.292893 10.9142Z",
      fill: "currentColor"
    }));
  },
  burger: function burger(_ref15) {
    var className = _ref15.className,
      id = _ref15.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 14"
    }, React.createElement("path", {
      d: "M1 13H17M1 1H17H1ZM1 5H17H1ZM1 9H17H1Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  'four-squares': function fourSquares(_ref16) {
    var className = _ref16.className,
      id = _ref16.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14 14"
    }, React.createElement("path", {
      d: "M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V4C0 4.53043 0.210714 5.03914 0.585786 5.41421C0.960859 5.78929 1.46957 6 2 6H4C4.53043 6 5.03914 5.78929 5.41421 5.41421C5.78929 5.03914 6 4.53043 6 4V2C6 1.46957 5.78929 0.960859 5.41421 0.585786C5.03914 0.210714 4.53043 0 4 0H2ZM2 8C1.46957 8 0.960859 8.21071 0.585786 8.58579C0.210714 8.96086 0 9.46957 0 10V12C0 12.5304 0.210714 13.0391 0.585786 13.4142C0.960859 13.7893 1.46957 14 2 14H4C4.53043 14 5.03914 13.7893 5.41421 13.4142C5.78929 13.0391 6 12.5304 6 12V10C6 9.46957 5.78929 8.96086 5.41421 8.58579C5.03914 8.21071 4.53043 8 4 8H2ZM8 2C8 1.46957 8.21071 0.960859 8.58579 0.585786C8.96086 0.210714 9.46957 0 10 0H12C12.5304 0 13.0391 0.210714 13.4142 0.585786C13.7893 0.960859 14 1.46957 14 2V4C14 4.53043 13.7893 5.03914 13.4142 5.41421C13.0391 5.78929 12.5304 6 12 6H10C9.46957 6 8.96086 5.78929 8.58579 5.41421C8.21071 5.03914 8 4.53043 8 4V2ZM8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8H12C12.5304 8 13.0391 8.21071 13.4142 8.58579C13.7893 8.96086 14 9.46957 14 10V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H10C9.46957 14 8.96086 13.7893 8.58579 13.4142C8.21071 13.0391 8 12.5304 8 12V10Z",
      fill: "currentColor"
    }));
  },
  copy: function copy(_ref17) {
    var className = _ref17.className,
      id = _ref17.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9268 9.70715C10.2668 9.70715 9.73169 10.2422 9.73169 10.9023V20.7803C9.73169 21.4404 10.2668 21.9754 10.9268 21.9754H20.8049C21.4649 21.9754 22 21.4404 22 20.7803V10.9023C22 10.2422 21.4649 9.70715 20.8049 9.70715H10.9268ZM7.73169 10.9023C7.73169 9.13766 9.16219 7.70715 10.9268 7.70715H20.8049C22.5695 7.70715 24 9.13766 24 10.9023V20.7803C24 22.5449 22.5695 23.9754 20.8049 23.9754H10.9268C9.16219 23.9754 7.73169 22.5449 7.73169 20.7803V10.9023Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.24371 2.02454C2.92674 2.02454 2.62276 2.15045 2.39863 2.37458C2.1745 2.59871 2.04858 2.90269 2.04858 3.21966V13.0977C2.04858 13.4147 2.1745 13.7187 2.39863 13.9428C2.62276 14.1669 2.92674 14.2928 3.24371 14.2928H4.34127C4.89355 14.2928 5.34127 14.7405 5.34127 15.2928C5.34127 15.8451 4.89355 16.2928 4.34127 16.2928H3.24371C2.39631 16.2928 1.58361 15.9562 0.984413 15.357C0.385212 14.7578 0.048584 13.9451 0.048584 13.0977V3.21966C0.048584 2.37226 0.385212 1.55957 0.984413 0.960366C1.58362 0.361164 2.39631 0.0245361 3.24371 0.0245361H13.1218C13.9692 0.0245361 14.7818 0.361164 15.381 0.960366C15.9802 1.55957 16.3169 2.37226 16.3169 3.21966V4.31722C16.3169 4.8695 15.8692 5.31722 15.3169 5.31722C14.7646 5.31722 14.3169 4.8695 14.3169 4.31722V3.21966C14.3169 2.90269 14.191 2.59871 13.9668 2.37458C13.7427 2.15045 13.4387 2.02454 13.1218 2.02454H3.24371Z",
      fill: "currentColor"
    }));
  },
  cross: function cross(_ref18) {
    var className = _ref18.className,
      id = _ref18.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17 18"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.292893 1.04289C0.683417 0.652369 1.31658 0.652369 1.70711 1.04289L8.25 7.58579L14.7929 1.04289C15.1834 0.652369 15.8166 0.652369 16.2071 1.04289C16.5976 1.43342 16.5976 2.06658 16.2071 2.45711L9.66421 9L16.2071 15.5429C16.5976 15.9334 16.5976 16.5666 16.2071 16.9571C15.8166 17.3476 15.1834 17.3476 14.7929 16.9571L8.25 10.4142L1.70711 16.9571C1.31658 17.3476 0.683417 17.3476 0.292893 16.9571C-0.0976311 16.5666 -0.0976311 15.9334 0.292893 15.5429L6.83579 9L0.292893 2.45711C-0.0976311 2.06658 -0.0976311 1.43342 0.292893 1.04289Z",
      fill: "currentColor"
    }));
  },
  discord: function discord(_ref19) {
    var className = _ref19.className,
      id = _ref19.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 18"
    }, React.createElement("path", {
      d: "M20.3303 1.50753C18.7767 0.80328 17.1156 0.291464 15.3789 3.05176e-05C15.1656 0.373637 14.9164 0.876147 14.7446 1.27589C12.8985 1.0069 11.0693 1.0069 9.25716 1.27589C9.08539 0.876147 8.83055 0.373637 8.61536 3.05176e-05C6.87681 0.291464 5.21376 0.805161 3.66019 1.51126C0.526643 6.09906 -0.322811 10.5729 0.101917 14.9832C2.18025 16.487 4.19441 17.4004 6.17458 17.9982C6.66349 17.3462 7.09953 16.6532 7.47518 15.9228C6.75975 15.6594 6.07453 15.3344 5.42707 14.9571C5.59884 14.8338 5.76686 14.7049 5.92918 14.5723C9.8782 16.3618 14.1689 16.3618 18.0707 14.5723C18.235 14.7049 18.403 14.8338 18.5728 14.9571C17.9235 15.3363 17.2364 15.6613 16.521 15.9247C16.8966 16.6532 17.3308 17.3481 17.8216 18C19.8036 17.4023 21.8197 16.4888 23.898 14.9832C24.3964 9.87054 23.0467 5.43778 20.3303 1.50753ZM8.01318 12.2709C6.82772 12.2709 5.85555 11.1987 5.85555 9.89295C5.85555 8.58722 6.80696 7.51313 8.01318 7.51313C9.21942 7.51313 10.1916 8.58534 10.1708 9.89295C10.1727 11.1987 9.21942 12.2709 8.01318 12.2709ZM15.9867 12.2709C14.8013 12.2709 13.8291 11.1987 13.8291 9.89295C13.8291 8.58722 14.7805 7.51313 15.9867 7.51313C17.193 7.51313 18.1651 8.58534 18.1444 9.89295C18.1444 11.1987 17.193 12.2709 15.9867 12.2709Z",
      fill: "currentColor"
    }));
  },
  edit: function edit(_ref20) {
    var className = _ref20.className,
      id = _ref20.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9799 2.58499C12.8709 2.58499 12.7629 2.60646 12.6622 2.64818C12.5615 2.6899 12.47 2.75105 12.3929 2.82813L3.84547 11.3755L3.40522 12.9898L5.01946 12.5495L13.5669 4.00212C13.6439 3.92504 13.7051 3.83352 13.7468 3.73281C13.7885 3.63209 13.81 3.52415 13.81 3.41513C13.81 3.30611 13.7885 3.19816 13.7468 3.09745C13.7051 2.99673 13.6439 2.90522 13.5669 2.82813C13.4898 2.75105 13.3983 2.6899 13.2975 2.64818C13.1968 2.60646 13.0889 2.58499 12.9799 2.58499ZM11.8968 0.800423C12.2402 0.658195 12.6082 0.584991 12.9799 0.584991C13.3515 0.584991 13.7195 0.658195 14.0629 0.800423C14.4063 0.94265 14.7183 1.15112 14.9811 1.41392C15.2439 1.67672 15.4523 1.98871 15.5946 2.33208C15.7368 2.67545 15.81 3.04347 15.81 3.41513C15.81 3.78678 15.7368 4.1548 15.5946 4.49817C15.4523 4.84154 15.2439 5.15353 14.9811 5.41634L6.24589 14.1515C6.12283 14.2746 5.9698 14.3634 5.8019 14.4092L2.24312 15.3798C1.89691 15.4742 1.52665 15.3758 1.2729 15.1221C1.01915 14.8683 0.920818 14.4981 1.01524 14.1519L1.98582 10.5931C2.03161 10.4252 2.12042 10.2722 2.24347 10.1491L10.9787 1.41392C11.2415 1.15112 11.5535 0.94265 11.8968 0.800423Z",
      fill: "currentColor"
    }));
  },
  email: function email(_ref21) {
    var className = _ref21.className,
      id = _ref21.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 23 18"
    }, React.createElement("path", {
      d: "M3.25 1H19.25C20.35 1 21.25 1.9 21.25 3V15C21.25 16.1 20.35 17 19.25 17H3.25C2.15 17 1.25 16.1 1.25 15V3C1.25 1.9 2.15 1 3.25 1Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M21.25 3L11.25 10L1.25 3",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  gitbook: function gitbook(_ref22) {
    var className = _ref22.className,
      id = _ref22.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 18"
    }, React.createElement("path", {
      d: "M11.5331 15.0016C11.908 15.0016 12.2454 15.3131 12.2454 15.7415C12.2454 16.1309 11.9455 16.4814 11.5331 16.4814C11.1581 16.4814 10.8207 16.1698 10.8207 15.7415C10.8207 15.3131 11.1581 15.0016 11.5331 15.0016ZM22.5558 10.4846C22.1809 10.4846 21.8434 10.1731 21.8434 9.74472C21.8434 9.35532 22.1434 9.00485 22.5558 9.00485C22.9307 9.00485 23.2681 9.31638 23.2681 9.74472C23.2681 10.1341 22.9307 10.4846 22.5558 10.4846ZM22.5558 7.48619C21.356 7.48619 20.3812 8.49863 20.3812 9.74472C20.3812 9.97836 20.4187 10.212 20.4937 10.4456L13.3327 14.4175C12.9203 13.7945 12.2454 13.444 11.5331 13.444C10.7082 13.444 9.95838 13.9502 9.58346 14.6901L3.13479 11.1855C2.45993 10.7961 1.93503 9.66683 2.01002 8.57651C2.04751 8.03135 2.23497 7.60301 2.49742 7.44725C2.68488 7.33043 2.87234 7.36937 3.13479 7.48619L3.17228 7.52513C4.89692 8.45969 10.4833 11.497 10.7082 11.6138C11.0832 11.7696 11.2706 11.8475 11.908 11.536L23.4556 5.30554C23.6431 5.22766 23.8305 5.0719 23.8305 4.79932C23.8305 4.44886 23.4931 4.2931 23.4931 4.2931C22.8182 3.98158 21.8059 3.47536 20.8311 3.00808C18.7316 1.99564 16.3321 0.827432 15.2823 0.24333C14.3825 -0.262891 13.6326 0.16545 13.5202 0.24333L13.2577 0.360151C8.49619 2.85232 2.19748 6.08435 1.82256 6.31799C1.18519 6.70739 0.772773 7.52513 0.735281 8.53757C0.660296 10.1341 1.44763 11.8085 2.5724 12.3926L9.396 16.053C9.54597 17.1433 10.4833 18 11.5331 18C12.7328 18 13.6701 17.0265 13.7076 15.7804L21.2061 11.5749C21.581 11.8864 22.0684 12.0422 22.5558 12.0422C23.7555 12.0422 24.7303 11.0297 24.7303 9.78366C24.7303 8.49863 23.7555 7.48619 22.5558 7.48619Z",
      fill: "currentColor"
    }));
  },
  github: function github(_ref23) {
    var className = _ref23.className,
      id = _ref23.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 22"
    }, React.createElement("path", {
      d: "M13.5701 20.1655V16.7917C13.6029 16.376 13.5467 15.9581 13.4054 15.5658C13.2641 15.1734 13.0409 14.8157 12.7507 14.5163C15.4881 14.2112 18.365 13.1737 18.365 8.41374C18.3648 7.19657 17.8966 6.02607 17.0573 5.14451C17.4547 4.07962 17.4266 2.90256 16.9789 1.85785C16.9789 1.85785 15.9501 1.55272 13.5701 3.1481C11.572 2.60656 9.46573 2.60656 7.46759 3.1481C5.08758 1.55272 4.05887 1.85785 4.05887 1.85785C3.61109 2.90256 3.58299 4.07962 3.98041 5.14451C3.13488 6.03261 2.66619 7.21369 2.67271 8.4399C2.67271 13.165 5.54964 14.2025 8.28707 14.5425C8.00025 14.8388 7.77905 15.1923 7.63785 15.5798C7.49666 15.9674 7.43865 16.3803 7.46759 16.7917V20.1655M7.46759 17.5502C3.10861 18.8578 3.10861 15.3707 1.36502 14.9348L7.46759 17.5502Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  info: function info(_ref24) {
    var className = _ref24.className,
      id = _ref24.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 22 22"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM12 6.00001L11.7607 13L10.2466 13L10 6L12 6.00001ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16Z",
      fill: "currentColor"
    }));
  },
  linkedin: function linkedin(_ref25) {
    var className = _ref25.className,
      id = _ref25.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17 16"
    }, React.createElement("path", {
      d: "M4.16726 15.8954V5.33289H0.881941V15.8954H4.16726ZM2.50694 3.91985C3.56672 3.91985 4.41454 3.0367 4.41454 1.97692C4.41454 0.952469 3.56672 0.104645 2.50694 0.104645C1.48248 0.104645 0.634659 0.952469 0.634659 1.97692C0.634659 3.0367 1.48248 3.91985 2.50694 3.91985ZM16.4254 15.8954H16.4607V10.1019C16.4607 7.27582 15.8248 5.08561 12.5042 5.08561C10.9145 5.08561 9.85475 5.96876 9.39551 6.78126H9.36018V5.33289H6.21617V15.8954H9.50149V10.6671C9.50149 9.28941 9.74877 7.98234 11.4444 7.98234C13.1401 7.98234 13.1754 9.53669 13.1754 10.7731V15.8954H16.4254Z",
      fill: "currentColor"
    }));
  },
  lock: function lock(_ref26) {
    var className = _ref26.className,
      id = _ref26.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 11 14"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.66663 5V4C1.66663 1.79086 3.45749 0 5.66663 0C7.87576 0 9.66663 1.79086 9.66663 4V5C10.2189 5 10.6666 5.44772 10.6666 6V13C10.6666 13.5523 10.2189 14 9.66663 14H1.66663C1.11434 14 0.666626 13.5523 0.666626 13V6C0.666626 5.44772 1.11434 5 1.66663 5ZM7.66663 4V5H3.66663V4C3.66663 2.89543 4.56206 2 5.66663 2C6.7712 2 7.66663 2.89543 7.66663 4Z",
      fill: "currentColor"
    }));
  },
  manage: function manage(_ref27) {
    var className = _ref27.className,
      id = _ref27.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 20"
    }, React.createElement("path", {
      d: "M4.26196 0C4.81425 0 5.26196 0.447715 5.26196 1V8C5.26196 8.55228 4.81425 9 4.26196 9C3.70968 9 3.26196 8.55228 3.26196 8V1C3.26196 0.447715 3.70968 0 4.26196 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M5.26196 13H7.26196C7.81425 13 8.26196 12.5523 8.26196 12C8.26196 11.4477 7.81425 11 7.26196 11H1.26196C0.709678 11 0.261963 11.4477 0.261963 12C0.261963 12.5523 0.709678 13 1.26196 13H3.26196V19C3.26196 19.5523 3.70968 20 4.26196 20C4.81425 20 5.26196 19.5523 5.26196 19V13Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M13.262 10C13.262 9.44771 12.8142 9 12.262 9C11.7097 9 11.262 9.44771 11.262 10V19C11.262 19.5523 11.7097 20 12.262 20C12.8142 20 13.262 19.5523 13.262 19V10Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M12.262 0C12.8142 0 13.262 0.447715 13.262 1V5H15.262C15.8142 5 16.262 5.44772 16.262 6C16.262 6.55228 15.8142 7 15.262 7H9.26196C8.70968 7 8.26196 6.55228 8.26196 6C8.26196 5.44772 8.70968 5 9.26196 5H11.262V1C11.262 0.447715 11.7097 0 12.262 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M23.262 13C23.8142 13 24.262 13.4477 24.262 14C24.262 14.5523 23.8142 15 23.262 15H21.262V19C21.262 19.5523 20.8142 20 20.262 20C19.7097 20 19.262 19.5523 19.262 19V15H17.262C16.7097 15 16.262 14.5523 16.262 14C16.262 13.4477 16.7097 13 17.262 13H23.262Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M20.262 0C20.8142 0 21.262 0.447715 21.262 1V10C21.262 10.5523 20.8142 11 20.262 11C19.7097 11 19.262 10.5523 19.262 10V1C19.262 0.447715 19.7097 0 20.262 0Z",
      fill: "currentColor"
    }));
  },
  medium: function medium(_ref28) {
    var className = _ref28.className,
      id = _ref28.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 21 16"
    }, React.createElement("path", {
      d: "M2.86025 3.29167V12.2083C2.90166 12.5 2.81884 12.8333 2.6118 13.0833L0.5 15.625V15.9583H6.46273V15.625L4.35093 13.0833C4.10248 12.8333 4.01967 12.5 4.06108 12.2083V4.5L9.27847 16H9.89959L14.413 4.5V13.625C14.413 13.875 14.413 13.9167 14.2474 14.0833L12.6325 15.6667V16H20.5V15.6667L18.9265 14.125C18.8023 14.0417 18.7195 13.8333 18.7609 13.6667V2.33333C18.7195 2.16667 18.8023 2 18.9265 1.91667L20.5 0.375V0H14.9928L11.0176 9.91667L6.54555 0H0.748447V0.375L2.6118 2.625C2.77743 2.79167 2.90166 3.04167 2.86025 3.29167Z",
      fill: "currentColor"
    }));
  },
  menu: function menu(_ref29) {
    var className = _ref29.className,
      id = _ref29.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8.00031C0 7.44802 0.447716 7.00031 1 7.00031H24C24.5523 7.00031 25 7.44802 25 8.00031C25 8.55259 24.5523 9.00031 24 9.00031H1C0.447715 9.00031 0 8.55259 0 8.00031Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 0C25 1.10457 24.1046 2 23 2L2 2C0.89543 2 7.8281e-08 1.10457 1.74846e-07 -2.18557e-06L25 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 16L0 16C9.65645e-08 14.8954 0.89543 14 2 14L23 14C24.1046 14 25 14.8954 25 16Z",
      fill: "currentColor"
    }));
  },
  minus: function minus(_ref30) {
    var className = _ref30.className,
      id = _ref30.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 2"
    }, React.createElement("path", {
      d: "M1 0C0.447716 0 0 0.447716 0 1C0 1.55229 0.447716 2 1 2L17 2C17.5523 2 18 1.55229 18 1C18 0.447716 17.5523 0 17 0H1Z",
      fill: "currentColor"
    }));
  },
  plus: function plus(_ref31) {
    var className = _ref31.className,
      id = _ref31.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 18"
    }, React.createElement("path", {
      d: "M10.25 1C10.25 0.447715 9.80229 0 9.25 0C8.69771 0 8.25 0.447715 8.25 1V8L1.25 8C0.697716 8 0.25 8.44771 0.25 9C0.25 9.55228 0.697716 10 1.25 10H8.25V17C8.25 17.5523 8.69771 18 9.25 18C9.80229 18 10.25 17.5523 10.25 17V10H17.25C17.8023 10 18.25 9.55229 18.25 9C18.25 8.44771 17.8023 8 17.25 8L10.25 8V1Z",
      fill: "currentColor"
    }));
  },
  selector: function selector(_ref32) {
    var className = _ref32.className,
      id = _ref32.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor"
    }, React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
    }));
  },
  settings: function settings(_ref33) {
    var className = _ref33.className,
      id = _ref33.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V3.17399C10.9979 3.6908 10.8448 4.19572 10.5594 4.62661C10.2741 5.0575 9.86895 5.39555 9.39393 5.59914C9.30938 5.63538 9.22042 5.65969 9.12961 5.67157C8.69798 5.82272 8.23333 5.85998 7.781 5.77796C7.26 5.68349 6.77925 5.43512 6.40073 5.06486L6.39285 5.05715L6.33289 4.99711C6.24002 4.90413 6.12934 4.82998 6.00794 4.77965C5.88654 4.72933 5.75642 4.70343 5.625 4.70343C5.49358 4.70343 5.36346 4.72933 5.24206 4.77965C5.12066 4.82998 5.01037 4.90374 4.9175 4.99671L4.91671 4.9975C4.82374 5.09037 4.74998 5.20066 4.69965 5.32206C4.64933 5.44346 4.62343 5.57358 4.62343 5.705C4.62343 5.83642 4.64933 5.96654 4.69965 6.08794C4.74998 6.20934 4.82374 6.31963 4.91671 6.4125L4.98491 6.48069C5.35516 6.85921 5.60349 7.34 5.69796 7.861C5.79055 8.37163 5.73113 8.89797 5.52745 9.37478C5.34189 9.86133 5.01698 10.2827 4.59305 10.5859C4.16054 10.8952 3.64498 11.0673 3.11338 11.0797L3.09 11.08H3C2.73478 11.08 2.48043 11.1854 2.29289 11.3729C2.10536 11.5604 2 11.8148 2 12.08C2 12.3452 2.10536 12.5996 2.29289 12.7871C2.48043 12.9746 2.73478 13.08 3 13.08H3.17399C3.6908 13.0821 4.19572 13.2352 4.62661 13.5206C5.05601 13.8049 5.3932 14.2082 5.59701 14.6811C5.80908 15.1643 5.87211 15.6998 5.77796 16.219C5.68349 16.74 5.43512 17.2207 5.06486 17.5993L5.05715 17.6072L4.9971 17.6671C4.90413 17.76 4.82998 17.8707 4.77965 17.9921C4.72933 18.1135 4.70343 18.2436 4.70343 18.375C4.70343 18.5064 4.72933 18.6365 4.77965 18.7579C4.82998 18.8793 4.90374 18.9896 4.99671 19.0825L4.9975 19.0833C5.09037 19.1763 5.20066 19.25 5.32206 19.3003C5.44346 19.3507 5.57359 19.3766 5.705 19.3766C5.83641 19.3766 5.96654 19.3507 6.08794 19.3003C6.20934 19.25 6.31963 19.1763 6.4125 19.0833L6.48069 19.0151C6.85921 18.6448 7.34 18.3965 7.861 18.302C8.37163 18.2095 8.89796 18.2689 9.37477 18.4725C9.86132 18.6581 10.2827 18.983 10.5859 19.407C10.8952 19.8395 11.0673 20.355 11.0797 20.8866L11.08 20.91V21C11.08 21.2652 11.1854 21.5196 11.3729 21.7071C11.5604 21.8946 11.8148 22 12.08 22C12.3452 22 12.5996 21.8946 12.7871 21.7071C12.9746 21.5196 13.08 21.2652 13.08 21V20.83L13.08 20.826C13.0821 20.3092 13.2352 19.8043 13.5206 19.3734C13.805 18.944 14.2083 18.6067 14.6812 18.4029C15.1643 18.1909 15.6998 18.1279 16.219 18.222C16.74 18.3165 17.2207 18.5649 17.5993 18.9351L17.6071 18.9429L17.6671 19.0029C17.76 19.0959 17.8707 19.17 17.9921 19.2203C18.1135 19.2707 18.2436 19.2966 18.375 19.2966C18.5064 19.2966 18.6365 19.2707 18.7579 19.2203C18.8793 19.17 18.9896 19.0963 19.0825 19.0033L19.0833 19.0025C19.1763 18.9096 19.25 18.7993 19.3003 18.6779C19.3507 18.5565 19.3766 18.4264 19.3766 18.295C19.3766 18.1636 19.3507 18.0335 19.3003 17.9121C19.25 17.7907 19.1763 17.6804 19.0833 17.5875L19.0151 17.5193C18.6448 17.1408 18.3965 16.66 18.302 16.139C18.2079 15.6198 18.2709 15.0843 18.4829 14.6012C18.6867 14.1283 19.024 13.725 19.4534 13.4406C19.8843 13.1552 20.3892 13.0021 20.906 13L20.91 13L21 13C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11H20.83L20.826 11C20.3092 10.9979 19.8043 10.8448 19.3734 10.5594C18.9425 10.2741 18.6045 9.86896 18.4009 9.39393C18.3646 9.30938 18.3403 9.22042 18.3284 9.12961C18.1773 8.69798 18.14 8.23332 18.222 7.781C18.3165 7.26 18.5649 6.77925 18.9351 6.40073L18.9428 6.39285L19.0029 6.3329C19.0959 6.24002 19.17 6.12934 19.2203 6.00794C19.2707 5.88654 19.2966 5.75641 19.2966 5.625C19.2966 5.49359 19.2707 5.36346 19.2203 5.24206C19.17 5.12066 19.0963 5.01037 19.0033 4.9175L19.0025 4.91671C18.9096 4.82374 18.7993 4.74998 18.6779 4.69965C18.5565 4.64933 18.4264 4.62343 18.295 4.62343C18.1636 4.62343 18.0335 4.64933 17.9121 4.69965C17.7907 4.74998 17.6804 4.82374 17.5875 4.91671L17.5193 4.98491C17.1408 5.35516 16.66 5.60349 16.139 5.69796C15.6198 5.79211 15.0843 5.72908 14.6011 5.51701C14.1282 5.3132 13.7249 4.97601 13.4406 4.54661C13.1552 4.11572 13.0021 3.6108 13 3.09399L13 3.09V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2ZM19.4 15L20.3149 15.4038C20.2624 15.5226 20.2468 15.6544 20.27 15.7822C20.2929 15.9086 20.3527 16.0253 20.4419 16.1177L20.4967 16.1725C20.7755 16.451 20.997 16.7822 21.1479 17.1462C21.2989 17.5104 21.3766 17.9008 21.3766 18.295C21.3766 18.6892 21.2989 19.0796 21.1479 19.4438C20.9969 19.808 20.7756 20.1389 20.4967 20.4175L19.79 19.71L20.4975 20.4167C20.2189 20.6956 19.888 20.9169 19.5238 21.0679C19.1596 21.2189 18.7692 21.2966 18.375 21.2966C17.9808 21.2966 17.5904 21.2189 17.2262 21.0679C16.8622 20.917 16.5314 20.6959 16.2529 20.4171L16.1977 20.3619C16.1053 20.2727 15.9886 20.2129 15.8622 20.19C15.7344 20.1668 15.6026 20.1824 15.4838 20.2349L15.474 20.2392C15.3574 20.2891 15.258 20.372 15.1881 20.4777C15.1183 20.583 15.0808 20.7063 15.08 20.8325V21C15.08 21.7957 14.7639 22.5587 14.2013 23.1213C13.6387 23.6839 12.8757 24 12.08 24C11.2843 24 10.5213 23.6839 9.95868 23.1213C9.39607 22.5587 9.08 21.7957 9.08 21V20.9244C9.07526 20.7972 9.03327 20.6741 8.95914 20.5704C8.88326 20.4644 8.77723 20.3836 8.65482 20.3385C8.63505 20.3313 8.61551 20.3234 8.59624 20.3149C8.47742 20.2624 8.34561 20.2468 8.21782 20.27C8.09142 20.2929 7.97467 20.3527 7.8823 20.4419L7.8275 20.4967C7.54896 20.7755 7.21784 20.997 6.85382 21.1479C6.48963 21.2989 6.09925 21.3766 5.705 21.3766C5.31075 21.3766 4.92037 21.2989 4.55618 21.1479C4.19233 20.9971 3.86174 20.7761 3.58329 20.4975C3.30436 20.2189 3.08308 19.888 2.93211 19.5238C2.78113 19.1596 2.70343 18.7692 2.70343 18.375C2.70343 17.9808 2.78113 17.5904 2.93211 17.2262C3.08308 16.862 3.30436 16.5311 3.58329 16.2525L3.63811 16.1977C3.72728 16.1053 3.78713 15.9886 3.81005 15.8622C3.83322 15.7344 3.81758 15.6026 3.76514 15.4838L3.76081 15.474C3.71087 15.3574 3.62801 15.258 3.52232 15.1881C3.41704 15.1183 3.29374 15.0808 3.1675 15.08H3C2.20435 15.08 1.44129 14.7639 0.87868 14.2013C0.316071 13.6387 0 12.8756 0 12.08C0 11.2844 0.316071 10.5213 0.87868 9.95868C1.44129 9.39607 2.20435 9.08 3 9.08H3.07564C3.20283 9.07526 3.32591 9.03327 3.42955 8.95914C3.53564 8.88326 3.61644 8.77723 3.66146 8.65482C3.66874 8.63505 3.67663 8.61551 3.68514 8.59624C3.73758 8.47742 3.75322 8.34561 3.73005 8.21782C3.70713 8.09142 3.64728 7.97468 3.5581 7.88231L3.50329 7.8275C3.22436 7.54888 3.00308 7.21802 2.85211 6.85382C2.70113 6.48963 2.62343 6.09925 2.62343 5.705C2.62343 5.31075 2.70113 4.92037 2.85211 4.55618C3.00301 4.19216 3.22415 3.86143 3.50289 3.58289C3.78143 3.30415 4.11216 3.08301 4.47618 2.93211C4.84037 2.78113 5.23075 2.70343 5.625 2.70343C6.01925 2.70343 6.40963 2.78113 6.77382 2.93211C7.13802 3.08308 7.46888 3.30436 7.7475 3.58329L7.80231 3.6381C7.89468 3.72728 8.01142 3.78713 8.13782 3.81005C8.26561 3.83322 8.39742 3.81758 8.51624 3.76514C8.58027 3.73687 8.64693 3.71549 8.71507 3.70122C8.78479 3.6539 8.84498 3.59323 8.89195 3.52232C8.96167 3.41704 8.99921 3.29374 9 3.1675V3C9 2.20435 9.31607 1.44129 9.87868 0.87868C10.4413 0.316071 11.2044 0 12 0C12.7956 0 13.5587 0.316071 14.1213 0.87868C14.6839 1.44129 15 2.20435 15 3V3.0875C15.0008 3.21374 15.0383 3.33704 15.1081 3.44232C15.178 3.54801 15.2774 3.63092 15.3939 3.68086L15.4038 3.68508C15.5226 3.73752 15.6544 3.75322 15.7822 3.73005C15.9086 3.70713 16.0253 3.64728 16.1177 3.55811L16.1725 3.50329C16.4511 3.22436 16.782 3.00308 17.1462 2.85211C17.5104 2.70113 17.9008 2.62343 18.295 2.62343C18.6892 2.62343 19.0796 2.70113 19.4438 2.85211C19.808 3.00308 20.1389 3.22436 20.4175 3.50329C20.6961 3.78174 20.9171 4.11233 21.0679 4.47618C21.2189 4.84037 21.2966 5.23075 21.2966 5.625C21.2966 6.01925 21.2189 6.40963 21.0679 6.77382C20.917 7.13784 20.6959 7.46857 20.4171 7.7471L20.3619 7.80231C20.2727 7.89468 20.2129 8.01142 20.19 8.13782C20.1668 8.26561 20.1824 8.39742 20.2349 8.51624C20.2631 8.58027 20.2845 8.64692 20.2988 8.71507C20.3461 8.78479 20.4068 8.84498 20.4777 8.89195C20.583 8.96167 20.7063 8.99921 20.8325 9H21C21.7957 9 22.5587 9.31607 23.1213 9.87868C23.6839 10.4413 24 11.2043 24 12C24 12.7957 23.6839 13.5587 23.1213 14.1213C22.5587 14.6839 21.7957 15 21 15H20.9125C20.7863 15.0008 20.663 15.0383 20.5577 15.1081C20.452 15.178 20.3691 15.2774 20.3191 15.3939L19.4 15Z",
      fill: "currentColor"
    }));
  },
  telegram: function telegram(_ref34) {
    var className = _ref34.className,
      id = _ref34.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 18"
    }, React.createElement("path", {
      d: "M19.9427 2.04182C20.2107 0.773917 19.4959 0.27581 18.6918 0.592787L0.911028 7.521C-0.295203 8.0191 -0.250528 8.69834 0.732327 9.01532L5.24452 10.4191L15.7879 3.71727C16.2793 3.35501 16.7707 3.58143 16.3686 3.8984L7.83568 11.687L7.52296 16.4416C8.01439 16.4416 8.19309 16.2605 8.46114 15.9888L10.6502 13.8153L15.2518 17.2567C16.1006 17.7548 16.7261 17.4831 16.9494 16.4869L19.9427 2.04182Z",
      fill: "currentColor"
    }));
  },
  twitch: function twitch(_ref35) {
    var className = _ref35.className,
      id = _ref35.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 20"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V11.8C18 12.0631 17.8963 12.3155 17.7115 12.5027L14.1559 16.1027C13.968 16.2929 13.7118 16.4 13.4444 16.4H9.41786L6.15593 19.7027C5.87092 19.9913 5.43983 20.0791 5.06463 19.9251C4.68943 19.771 4.44444 19.4056 4.44444 19V16.4H1C0.447715 16.4 0 15.9523 0 15.4V1ZM2 2V14.4H5.44444C5.99673 14.4 6.44444 14.8477 6.44444 15.4V16.5644L8.28852 14.6973C8.4764 14.5071 8.73263 14.4 9 14.4H13.0266L16 11.3894V2H2ZM8.11111 4.5C8.66339 4.5 9.11111 4.94771 9.11111 5.5V9.1C9.11111 9.65228 8.66339 10.1 8.11111 10.1C7.55883 10.1 7.11111 9.65228 7.11111 9.1V5.5C7.11111 4.94771 7.55883 4.5 8.11111 4.5ZM12.5556 4.5C13.1078 4.5 13.5556 4.94771 13.5556 5.5V9.1C13.5556 9.65228 13.1078 10.1 12.5556 10.1C12.0033 10.1 11.5556 9.65228 11.5556 9.1V5.5C11.5556 4.94771 12.0033 4.5 12.5556 4.5Z",
      fill: "currentColor"
    }));
  },
  'info-outline': function infoOutline(_ref36) {
    var className = _ref36.className,
      id = _ref36.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      d: "M11 8V15H9V8H11Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6Z",
      fill: "currentColor"
    }));
  },
  search: function search(_ref37) {
    var className = _ref37.className,
      id = _ref37.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5732 12.9874C10.3631 13.9021 8.85605 14.4446 7.22228 14.4446C3.23352 14.4446 0 11.211 0 7.22229C0 3.23354 3.23352 1.52588e-05 7.22228 1.52588e-05C11.211 1.52588e-05 14.4446 3.23354 14.4446 7.22229C14.4446 8.85608 13.9021 10.3632 12.9874 11.5732L15.707 14.2929C16.0976 14.6834 16.0976 15.3166 15.707 15.7071C15.3165 16.0976 14.6834 16.0976 14.2928 15.7071L11.5732 12.9874ZM2 7.22229C2 4.33811 4.33809 2.00002 7.22228 2.00002C10.1065 2.00002 12.4446 4.33811 12.4446 7.22229C12.4446 8.62308 11.893 9.89504 10.9953 10.8329C10.9656 10.8565 10.9369 10.882 10.9095 10.9095C10.882 10.937 10.8565 10.9657 10.8329 10.9954C9.89501 11.8931 8.62305 12.4446 7.22228 12.4446C4.33809 12.4446 2 10.1065 2 7.22229Z",
      fill: "currentColor"
    }));
  },
  twitter: function twitter(_ref38) {
    var className = _ref38.className,
      id = _ref38.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 23 18"
    }, React.createElement("path", {
      d: "M20.5113 4.46747C21.3723 3.81687 22.1473 3.03614 22.75 2.1253C21.975 2.47229 21.0709 2.73253 20.1668 2.81928C21.114 2.25542 21.8028 1.38795 22.1473 0.303614C21.2862 0.824096 20.296 1.21446 19.3058 1.43133C18.4447 0.520482 17.2823 0 15.9907 0C13.4936 0 11.4702 2.03855 11.4702 4.55422C11.4702 4.9012 11.5132 5.24819 11.5993 5.59518C7.85372 5.37831 4.4956 3.55663 2.25685 0.824096C1.86937 1.4747 1.65411 2.25542 1.65411 3.12289C1.65411 4.68434 2.42906 6.07229 3.67759 6.89639C2.94569 6.85301 2.2138 6.67952 1.61106 6.33253V6.3759C1.61106 8.58795 3.16096 10.4096 5.2275 10.8434C4.88307 10.9301 4.45254 11.0169 4.06507 11.0169C3.7637 11.0169 3.50538 10.9735 3.20401 10.9301C3.7637 12.7518 5.44276 14.053 7.42319 14.0964C5.87329 15.3108 3.93591 16.0482 1.82632 16.0482C1.43885 16.0482 1.09442 16.0048 0.75 15.9614C2.73043 17.2626 5.09834 18 7.68151 18C15.9907 18 20.5113 11.1036 20.5113 5.0747C20.5113 4.85783 20.5113 4.68434 20.5113 4.46747Z",
      fill: "currentColor"
    }));
  },
  user: function user(_ref39) {
    var className = _ref39.className,
      id = _ref39.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 18"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.78634 12.6665C6.80818 12.6665 3.74818 14.6485 2.72122 17.3547C2.52527 17.871 1.94783 18.1308 1.43148 17.9348C0.915126 17.7389 0.655388 17.1614 0.851339 16.6451C2.19794 13.0966 6.04973 10.6665 9.78634 10.6665C13.523 10.6665 17.3746 13.0966 18.7212 16.6451C18.9172 17.1614 18.6574 17.7389 18.1411 17.9348C17.6247 18.1308 17.0473 17.871 16.8513 17.3547C15.8244 14.6485 12.7645 12.6665 9.78634 12.6665Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.78628 1.99986C8.37489 1.99986 7.23073 3.14402 7.23073 4.55542C7.23073 5.96681 8.37489 7.11097 9.78628 7.11097C11.1977 7.11097 12.3418 5.96681 12.3418 4.55542C12.3418 3.14402 11.1977 1.99986 9.78628 1.99986ZM5.23073 4.55542C5.23073 2.03945 7.27032 -0.000137329 9.78628 -0.000137329C12.3022 -0.000137329 14.3418 2.03945 14.3418 4.55542C14.3418 7.07138 12.3022 9.11097 9.78628 9.11097C7.27032 9.11097 5.23073 7.07138 5.23073 4.55542Z",
      fill: "currentColor"
    }));
  },
  website: function website(_ref40) {
    var className = _ref40.className,
      id = _ref40.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0154 20C15.5312 19.9917 20 15.5177 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5177 4.46883 19.9917 9.9846 20C9.98973 20 9.99487 20 10 20M7.72462 2.32822C4.72373 3.2169 2.45864 5.81834 2.06189 9H5.45317C5.66143 6.61813 6.44435 4.32979 7.72462 2.32822ZM12.2754 2.32822C13.5557 4.32979 14.3386 6.61813 14.5468 9H17.9381C17.5414 5.81834 15.2763 3.2169 12.2754 2.32822ZM12.538 9C12.301 6.66007 11.4221 4.43113 10 2.55999C8.57787 4.43113 7.69896 6.66007 7.462 9H12.538ZM7.46198 11H12.538C12.3011 13.34 11.4222 15.569 10 17.4402C8.57783 15.569 7.69891 13.34 7.46198 11ZM5.45315 11H2.06189C2.45863 14.1816 4.72365 16.783 7.72445 17.6717C6.44425 15.6702 5.66137 13.3818 5.45315 11ZM12.2755 17.6717C13.5558 15.6702 14.3386 13.3818 14.5469 11H17.9381C17.5414 14.1816 15.2764 16.783 12.2755 17.6717Z",
      fill: "currentColor"
    }));
  },
  wallet: function wallet(_ref41) {
    var className = _ref41.className,
      id = _ref41.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 18"
    }, React.createElement("path", {
      d: "M16 1H3C1.89543 1 1 1.89543 1 3V5M1 5V15C1 16.1046 1.89543 17 3 17H17C18.1046 17 19 16.1046 19 15V7C19 5.89543 18.1046 5 17 5H1Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("ellipse", {
      cx: "14.6754",
      cy: "12.4286",
      rx: "1.05195",
      ry: "1.14286",
      fill: "currentColor"
    }));
  },
  'warning-outline': function warningOutline(_ref42) {
    var className = _ref42.className,
      id = _ref42.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 22"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.7011 17.7934L14.3889 2.06532C13.5479 0.644893 11.4521 0.644893 10.6111 2.06532L1.29887 17.7934C0.469012 19.195 1.47968 21 3.18777 21H21.8122C23.5203 21 24.531 19.195 23.7011 17.7934ZM15.2494 1.55585C14.0211 -0.518613 10.9789 -0.518618 9.75061 1.55584L0.438383 17.2839C-0.799424 19.3745 0.731179 22 3.18777 22H21.8122C24.2688 22 25.7994 19.3745 24.5616 17.2839L15.2494 1.55585Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M13.5475 7.41446L13.3082 14.6388H11.5675L11.3209 7.41446H13.5475ZM11.2629 16.8755C11.2629 16.5706 11.3693 16.3181 11.582 16.118C11.7996 15.9132 12.0849 15.8107 12.4378 15.8107C12.7957 15.8107 13.0809 15.9132 13.2937 16.118C13.5064 16.3181 13.6128 16.5706 13.6128 16.8755C13.6128 17.1708 13.5064 17.4209 13.2937 17.6258C13.0809 17.8306 12.7957 17.933 12.4378 17.933C12.0849 17.933 11.7996 17.8306 11.582 17.6258C11.3693 17.4209 11.2629 17.1708 11.2629 16.8755Z",
      fill: "currentColor"
    }));
  },
  warning: function warning(_ref43) {
    var className = _ref43.className,
      id = _ref43.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 22"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2494 1.55585C14.0211 -0.518613 10.9789 -0.518618 9.75061 1.55584L0.438383 17.2839C-0.799424 19.3745 0.731179 22 3.18777 22H21.8122C24.2688 22 25.7994 19.3745 24.5616 17.2839L15.2494 1.55585ZM13.3082 14.6388L13.5475 7.41446H11.3209L11.5675 14.6388H13.3082ZM11.582 16.118C11.3693 16.3181 11.2629 16.5706 11.2629 16.8755C11.2629 17.1708 11.3693 17.4209 11.582 17.6258C11.7996 17.8306 12.0849 17.933 12.4378 17.933C12.7957 17.933 13.0809 17.8306 13.2937 17.6258C13.5064 17.4209 13.6128 17.1708 13.6128 16.8755C13.6128 16.5706 13.5064 16.3181 13.2937 16.118C13.0809 15.9132 12.7957 15.8107 12.4378 15.8107C12.0849 15.8107 11.7996 15.9132 11.582 16.118Z",
      fill: "currentColor"
    }));
  },
  'arrow-narrow-right': function arrowNarrowRight(_ref44) {
    var className = _ref44.className,
      id = _ref44.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 14"
    }, React.createElement("path", {
      d: "M1.33325 7H23.3333M23.3333 7L17.74 1.5M23.3333 7L17.74 12.5",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  'arrow-right': function arrowRight(_ref45) {
    var className = _ref45.className,
      id = _ref45.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 18"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.37871 0.792893C8.76923 0.402369 9.4024 0.402369 9.79292 0.792893L18 9L9.79292 17.2071C9.4024 17.5976 8.76923 17.5976 8.37871 17.2071C7.98818 16.8166 7.98818 16.1834 8.37871 15.7929L14.1716 10H1.08582C0.533531 10 0.0858154 9.55229 0.0858154 9C0.0858154 8.44772 0.533531 8 1.08582 8H14.1716L8.37871 2.20711C7.98818 1.81658 7.98818 1.18342 8.37871 0.792893Z",
      fill: "currentColor"
    }));
  },
  youtube: function youtube(_ref46) {
    var className = _ref46.className,
      id = _ref46.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 22 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.8381 1.19993C21.1788 1.56336 21.4207 2.01339 21.5395 2.50456C21.8567 4.32469 22.0106 6.17127 21.9994 8.02073C22.0058 9.84255 21.8518 11.6612 21.5395 13.4541C21.4207 13.9453 21.1788 14.3953 20.8381 14.7587C20.4975 15.1222 20.0703 15.3861 19.5996 15.524C17.8796 16 11 16 11 16C11 16 4.12036 16 2.40045 15.524C1.93929 15.3934 1.51847 15.1419 1.17865 14.7938C0.838835 14.4457 0.5915 14.0128 0.460548 13.5369C0.143332 11.7168 -0.0106485 9.87019 0.000571615 8.02073C-0.008192 6.18509 0.145779 4.35248 0.460548 2.54596C0.57933 2.05479 0.821245 1.60476 1.16186 1.24133C1.50247 0.877899 1.92972 0.613935 2.40045 0.476098C4.12036 3.05176e-05 11 3.05176e-05 11 3.05176e-05C11 3.05176e-05 17.8796 3.05176e-05 19.5996 0.434701C20.0703 0.572537 20.4975 0.836502 20.8381 1.19993ZM14.4998 8.02071L8.75012 11.4049V4.63649L14.4998 8.02071Z",
      fill: "currentColor"
    }));
  },
  book: function book(_ref47) {
    var className = _ref47.className,
      id = _ref47.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 22 18"
    }, React.createElement("path", {
      d: "M19.8832 0.790288C17.8655 0.900342 13.8668 1.30387 11.409 2.80795C11.2255 2.91801 11.1155 3.10143 11.1155 3.28485V16.6381C11.1155 17.0783 11.5924 17.3351 11.9959 17.1517C14.5272 15.8677 18.1957 15.5009 19.9932 15.4275C20.6168 15.3908 21.0938 14.8772 21.0938 14.2903V1.89083C21.1304 1.26719 20.5435 0.753603 19.8832 0.790288ZM9.68478 2.80795C7.2269 1.30387 3.22826 0.900342 1.2106 0.790288C0.550272 0.753603 0 1.26719 0 1.89083V14.2903C0 14.8772 0.476902 15.3908 1.10054 15.4275C2.8981 15.5009 6.56658 15.8677 9.09783 17.1517C9.50136 17.3351 9.97826 17.0783 9.97826 16.6381V3.28485C9.97826 3.10143 9.86821 2.91801 9.68478 2.80795Z",
      fill: "currentColor"
    }));
  },
  calendar: function calendar(_ref48) {
    var className = _ref48.className,
      id = _ref48.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 15 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.29 0.999886C11.29 0.447601 10.8423 -0.000114441 10.29 -0.000114441C9.73769 -0.000114441 9.28998 0.447601 9.28998 0.999886V1.40028H5.69V0.999886C5.69 0.447601 5.24229 -0.000114441 4.69 -0.000114441C4.13772 -0.000114441 3.69 0.447601 3.69 0.999886V1.40028H2.59005C1.26457 1.40028 0.190063 2.47478 0.190063 3.80026V13.6001C0.190063 14.9256 1.26457 16.0001 2.59005 16.0001H12.3899C13.7154 16.0001 14.7899 14.9256 14.7899 13.6001V3.80026C14.7899 2.47478 13.7154 1.40028 12.3899 1.40028H11.29V0.999886ZM12.7899 5.59949V3.80026C12.7899 3.57935 12.6108 3.40028 12.3899 3.40028H11.29V3.79985C11.29 4.35213 10.8423 4.79985 10.29 4.79985C9.73769 4.79985 9.28998 4.35213 9.28998 3.79985V3.40028H5.69V3.79985C5.69 4.35213 5.24229 4.79985 4.69 4.79985C4.13772 4.79985 3.69 4.35213 3.69 3.79985V3.40028H2.59005C2.36914 3.40028 2.19006 3.57935 2.19006 3.80026V5.59949H12.7899ZM2.19006 7.59949H12.7899V13.6001C12.7899 13.821 12.6108 14.0001 12.3899 14.0001H2.59005C2.36914 14.0001 2.19006 13.821 2.19006 13.6001V7.59949Z",
      fill: "currentColor"
    }));
  },
  chart: function chart(_ref49) {
    var className = _ref49.className,
      id = _ref49.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 24"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.524 8.25C18.0763 8.25 18.524 8.69771 18.524 9.25V23C18.524 23.5523 18.0763 24 17.524 24C16.9718 24 16.524 23.5523 16.524 23V9.25C16.524 8.69771 16.9718 8.25 17.524 8.25Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.52405 0C10.0763 0 10.524 0.447715 10.524 1V23C10.524 23.5523 10.0763 24 9.52405 24C8.97176 24 8.52405 23.5523 8.52405 23V1C8.52405 0.447715 8.97176 0 9.52405 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.52405 13.75C2.07633 13.75 2.52405 14.1977 2.52405 14.75V23C2.52405 23.5523 2.07633 24 1.52405 24C0.971763 24 0.524048 23.5523 0.524048 23V14.75C0.524048 14.1977 0.971763 13.75 1.52405 13.75Z",
      fill: "currentColor"
    }));
  },
  tick: function tick(_ref50) {
    var className = _ref50.className,
      id = _ref50.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 12"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.3751 0.835801C15.7656 1.22633 15.7656 1.85949 15.3751 2.25001L6.16797 11.4571L0.460862 5.75001C0.0703377 5.35949 0.0703377 4.72633 0.460862 4.3358C0.851386 3.94528 1.48455 3.94528 1.87508 4.3358L6.16797 8.62869L13.9609 0.835801C14.3514 0.445277 14.9846 0.445277 15.3751 0.835801Z",
      fill: "currentColor"
    }));
  },
  signout: function signout(_ref51) {
    var className = _ref51.className,
      id = _ref51.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      d: "M11.9459 0.646161C11.1238 -0.215387 9.7908 -0.215387 8.96865 0.646161L6.7094 3.01367C6.29833 3.44444 6.29833 4.14287 6.7094 4.57364C7.12048 5.00441 7.78696 5.00441 8.19804 4.57364L10.4573 2.20613L17.8948 10L10.4573 17.7939L8.19804 15.4264C7.78696 14.9956 7.12048 14.9956 6.7094 15.4264C6.29833 15.8571 6.29833 16.5556 6.7094 16.9863L8.96865 19.3538C9.7908 20.2154 11.1238 20.2154 11.9459 19.3538L19.3834 11.56C20.2055 10.6984 20.2055 9.30158 19.3834 8.44003L11.9459 0.646161Z",
      fill: "#AE1E55"
    }), React.createElement("path", {
      d: "M3.71968 13.9424C4.13076 14.3732 4.79725 14.3732 5.20832 13.9424C5.6194 13.5116 5.6194 12.8132 5.20832 12.3824L4.0299 11.1475H11.0098C11.5912 11.1475 12.0624 10.6537 12.0624 10.0445C12.0624 9.43525 11.5912 8.94139 11.0098 8.94139H4.0299L5.20832 7.7065C5.6194 7.27573 5.6194 6.5773 5.20832 6.14653C4.79724 5.71575 4.13076 5.71575 3.71968 6.14653L0 10.0445L3.71968 13.9424Z",
      fill: "#AE1E55"
    }));
  },
  'outline-plus': function outlinePlus(_ref52) {
    var className = _ref52.className,
      id = _ref52.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none"
    }, React.createElement("path", {
      d: "M9 5C9.55229 5 10 5.44772 10 6V8H12C12.5523 8 13 8.44771 13 9C13 9.55229 12.5523 10 12 10H10V12C10 12.5523 9.55229 13 9 13C8.44771 13 8 12.5523 8 12V10H6C5.44772 10 5 9.55228 5 9C5 8.44771 5.44772 8 6 8H8V6C8 5.44772 8.44771 5 9 5Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2Z",
      fill: "currentColor"
    }));
  }
};

var defaultProps$1 = {
  className: 'text-primary',
  size: 10
};
var Media = function Media(_ref) {
  var className = _ref.className,
    size = _ref.size,
    variant = _ref.variant;
  var Icon = SVGS[variant];
  return React.createElement(Icon, {
    id: variant,
    className: className + " h-" + size + " w-" + size
  });
};
Media.displayName = 'Media';
Media.defaultProps = defaultProps$1;

var defaultProps$2 = {
  as: 'div',
  className: 'text-primary',
  id: 'steps-el',
  variant: 'primary'
};
var Steps = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    children = _ref.children,
    id = _ref.id,
    variant = _ref.variant;
  return React.createElement(Component, {
    id: id,
    className: [variant === 'primary' ? 'bg-surface-level-two low-border w-[25px] h-[25px]' : '', variant === 'secondary' ? 'bg-gradient-alpha w-5 h-5' : '', variant === 'light' ? 'bg-gradient-alpha-white w-5 h-5' : '', 'flex', 'rounded-full', 'items-center', 'justify-center', 'overflow-hidden', 'pb-[2px]', className].join(' '),
    "data-testid": id,
    ref: ref,
    role: "Steps"
  }, children);
});
Steps.displayName = 'Steps';
Steps.defaultProps = defaultProps$2;

function useBreakpoint() {
  var _useState = useState(0),
    breakpoint = _useState[0],
    setBreakpoint = _useState[1];
  useEffect(function () {
    setBreakpoint(window.innerWidth);
    var calcInnerWidth = function calcInnerWidth() {
      setBreakpoint(window.innerWidth);
    };
    window.addEventListener('resize', calcInnerWidth);
    return function () {
      return window.removeEventListener('resize', calcInnerWidth);
    };
  }, []);
  return breakpoint;
}

var _excluded$1 = ["className"];
function useClasses(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return useCallback(function (styles) {
    var classList = [styles.base];
    Object.keys(styles).map(function (key) {
      if (props[key] || props['variant'] === key || props['size'] === key || props['surface'] === key) {
        classList.push(styles[key]);
      }
    });
    classList.push(className);
    return classList.filter(function (l) {
      return !!l;
    }).join(' ');
  }, [className, props]);
}

function shortenHex(hex, length) {
  if (length === void 0) {
    length = 4;
  }
  return hex.substring(0, length + 2) + "\u2026" + hex.substring(hex.length - length);
}
var useIntitialised = function useIntitialised() {
  var _useState = useState(false),
    initialized = _useState[0],
    setInitalized = _useState[1];
  useEffect(function () {
    setInitalized(true);
  }, [setInitalized]);
  return initialized;
};

var styles = {
  grid: {
    '12': 'grid grid-cols-12',
    '11': 'grid grid-cols-11',
    '10': 'grid grid-cols-10',
    '9': 'grid grid-cols-9',
    '8': 'grid grid-cols-8',
    '7': 'grid grid-cols-7',
    '6': 'grid grid-cols-6',
    '5': 'grid grid-cols-5',
    '4': 'grid grid-cols-4',
    '3': 'grid grid-cols-3',
    '2': 'grid grid-cols-2',
    '1': 'grid grid-cols-1'
  },
  span: {
    '12': 'col-span-12',
    '11': 'col-span-11',
    '10': 'col-span-10',
    '9': 'col-span-9',
    '8': 'col-span-8',
    '7': 'col-span-7',
    '6': 'col-span-6',
    '5': 'col-span-5',
    '4': 'col-span-4',
    '3': 'col-span-3',
    '2': 'col-span-2',
    '1': 'col-span-1'
  },
  typography: {
    allBold: 'font-bold',
    allCaps: 'uppercase',
    allUnderline: 'underline',
    primary: 'text-primary',
    secondary: 'text-secondary',
    custom: '',
    '4xl': 'text-4xl',
    '3xl': 'text-3xl',
    '2xl': 'text-2xl',
    xl: 'text-xl',
    lg: 'text-lg',
    md: 'text-md',
    sm: 'text-sm',
    xs: 'text-xs'
  }
};

var _excluded$2 = ["as", "children", "className", "id", "allBold", "allCaps", "allUnderline", "size", "variant"];
var defaultProps$3 = {
  as: 'p',
  allBold: false,
  allCaps: false,
  allUnderline: false,
  size: 'md',
  variant: 'primary'
};
var Typography = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var Component = props.as,
    children = props.children,
    className = props.className,
    id = props.id,
    allBold = props.allBold,
    allCaps = props.allCaps,
    allUnderline = props.allUnderline,
    size = props.size,
    variant = props.variant,
    rest = _objectWithoutPropertiesLoose(props, _excluded$2);
  var classes = useClasses({
    className: className,
    allBold: allBold,
    allCaps: allCaps,
    allUnderline: allUnderline,
    size: size,
    variant: variant
  });
  var _classes = useMemo(function () {
    return classes(styles.typography);
  }, [classes]);
  return React.createElement(Component, Object.assign({
    className: _classes,
    "data-testid": id,
    ref: ref
  }, rest), children);
});
Typography.displayName = 'Typography';
Typography.defaultProps = defaultProps$3;

var BreakPoint;
(function (BreakPoint) {
  BreakPoint[BreakPoint["XS"] = 480] = "XS";
  BreakPoint[BreakPoint["SM"] = 768] = "SM";
  BreakPoint[BreakPoint["MD"] = 992] = "MD";
  BreakPoint[BreakPoint["LG"] = 1220] = "LG";
})(BreakPoint || (BreakPoint = {}));

var defaultProps$4 = {
  as: 'div',
  label: undefined
};
var Adjust = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    value = _ref.value,
    setValue = _ref.setValue,
    max = _ref.max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'adjust' : _ref$id;
  return React.createElement(Component, {
    ref: ref,
    className: "flex items-center space-x-2 " + className,
    "data-testid": id
  }, React.createElement("button", {
    "data-testid": id + "-minus",
    id: id + "-minus",
    onClick: function onClick() {
      return setValue(Math.max(1, value - 1));
    },
    className: "w-11 h-11 px-3 rounded-lg bg-surface-level-one low-border flex items-center justify-center"
  }, React.createElement(Media, {
    variant: "minus",
    className: "text-primary w-[18px] h-[18px]",
    size: 0
  })), React.createElement("input", {
    "data-testid": "input",
    value: value,
    min: min,
    max: max,
    onChange: function onChange(e) {
      setValue(Number(e.target.value));
    },
    type: "number",
    className: "text-primary text-sm leading-5 font-bold text-center h-[2.875rem] w-full rounded-lg bg-surface-level-one low-border bg-clip-padding outline-none",
    onBlur: function onBlur(e) {
      if (max && Number(e.target.value) < max) {
        setValue(Number(e.target.value));
      }
      if (max && Number(e.target.value) > max) {
        setValue(max);
      }
      if (min && Number(e.target.value) < min) {
        setValue(min);
      }
    }
  }), React.createElement("button", {
    id: id + "-add",
    "data-testid": id + "-add",
    onClick: function onClick() {
      return setValue(Math.min.apply(Math, max ? [value + 1, max] : [value + 1]));
    },
    className: "w-11 h-11 px-3 rounded-lg bg-surface-level-one low-border"
  }, React.createElement(Media, {
    variant: "plus",
    className: "text-primary mx-auto w-[18px] h-[18px]",
    size: 0
  })));
});
Adjust.displayName = 'Adjust';
Adjust.defaultProps = defaultProps$4;

var styles$1 = {
  toggle: {
    border_classes: 'disabled:opacity-50 border border-border border-opacity-[0.03] hover:border-opacity-[0.16] disabled:border-opacity-[0.03] focus:border-accent'
  },
  alert: {
    base: 'border gap-4 rounded-lg',
    error: 'border-error bg-transparent',
    warning: 'border-[#CC7E00] bg-transparent',
    note: 'border-secondary bg-transparent'
  },
  avatar: {
    base: 'overflow-hidden relative w-10 h-10 flex items-center justify-center rounded-full',
    primary: 'bg-gradient-alpha',
    secondary: 'bg-gradient-level-one-to-accent',
    light: 'bg-gradient-alpha-white'
  },
  button: {
    base: 'text-sm rounded-lg inline-flex items-center justify-center h-11 border border-border border-opacity-[0.03] focus:outline-none',
    custom: '',
    fullwidth: 'w-full',
    iconOnly: 'w-11',
    primary: 'font-bold text-button bg-gradient-button',
    secondary: 'text-secondary bg-surface-level-two hover:bg-surface-level-three',
    light: 'text-surface-level-zero bg-primary',
    disabled: 'disabled:opacity-50 pointer-events-none'
  },
  card: {
    base: 'rounded-lg',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two',
    custom: '',
    three: 'bg-surface-level-three',
    border: 'low-border'
  },
  chip: {
    base: 'rounded-lg inline-flex items-center',
    custom: '',
    primary: 'bg-gradient px-5 shadow-accent text-primary high-border text-sm',
    secondary: 'bg-surface-level-two px-3 text-secondary border border-border border-opacity-[0.03] text-sm',
    light: 'bg-gradient-purple px-5 shadow-purple text-primary high-border text-sm',
    lg: 'h-11',
    md: 'h-9',
    sm: 'h-8',
    xs: 'h-6'
  },
  dropdown: {
    lg: 'w-72',
    md: 'w-64',
    sm: 'w-56',
    xs: 'w-48',
    base: 'absolute low-border mt-1 origin-top-right rounded-lg shadow-tight focus:outline-none md:right-0',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two'
  },
  input: {
    base: 'date-picker block bg-clip-padding border border-border border-opacity-[0.03] h-[2.875rem] px-5 text-sm rounded-lg font-normal text-primary placeholder-secondary w-full focus:outline-none hover:border-opacity-[0.16] focus:border-opacity-[0.16]',
    disabled: 'disabled:opacity-50 pointer-events-none',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two',
    three: 'bg-surface-level-three'
  },
  progress: {
    base: 'overflow-hidden relative w-full',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two',
    three: 'bg-surface-level-three',
    rounded: 'rounded-full',
    border: 'bg-clip-padding low-border'
  }
};

var defaultProps$5 = {
  as: 'div',
  title: '',
  variant: 'error'
};
var Alert = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'alert' : _ref$id,
    title = _ref.title,
    variant = _ref.variant,
    Component = _ref.as;
  var classes = useClasses({
    className: className,
    variant: variant
  });
  return React.createElement(Component, {
    className: classes(styles$1.alert) + " " + (title ? 'p-5' : 'px-5 py-3'),
    id: id + "-" + variant,
    "data-testid": id,
    ref: ref
  }, title && React.createElement("div", {
    className: "flex gap-2 items-center mb-4"
  }, React.createElement(Media, {
    variant: variant === 'error' ? 'warning' : 'info',
    className: [variant === 'error' ? 'text-error' : '', variant === 'warning' ? 'text-[#CC7E00]' : '', variant === 'note' ? 'text-secondary' : ''].join(''),
    size: 5
  }), React.createElement(Typography, {
    variant: variant === 'note' ? 'secondary' : 'primary',
    allBold: true,
    size: "sm"
  }, title)), React.createElement(Typography, {
    "data-testid": "children",
    size: "sm",
    variant: variant === 'note' ? 'secondary' : 'primary'
  }, children));
});
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps$5;

var _excluded$3 = ["children", "className", "as"];
var defaultProps$6 = {
  as: 'div',
  variant: 'primary'
};
var Avatar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    Component = props.as,
    rest = _objectWithoutPropertiesLoose(props, _excluded$3);
  var classes = useClasses(_extends({
    className: className
  }, props));
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.avatar),
    ref: ref,
    role: "avatar"
  }, rest), React.createElement(Media, {
    size: 5,
    variant: "user",
    className: "text-button"
  }));
});
Avatar.displayName = 'Avatar';
Avatar.defaultProps = defaultProps$6;

var _excluded$4 = ["children", "className", "disabled", "fullwidth", "href", "id", "iconOnly", "loading", "type", "variant", "as"];
var defaultProps$7 = {
  as: 'button',
  fullwidth: false,
  iconOnly: false,
  loading: false,
  variant: 'primary'
};
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    fullwidth = _ref.fullwidth,
    href = _ref.href,
    id = _ref.id,
    iconOnly = _ref.iconOnly,
    loading = _ref.loading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    variant = _ref.variant,
    Component = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var classes = useClasses({
    className: className,
    disabled: disabled,
    fullwidth: fullwidth,
    iconOnly: iconOnly,
    loading: loading,
    variant: variant
  });
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.button),
    "data-testid": id,
    disabled: disabled,
    href: href,
    ref: ref,
    type: type
  }, rest), loading ? React.createElement(Media, {
    className: "text-button",
    size: 5,
    variant: "loader"
  }) : React.createElement("span", {
    className: "px-5"
  }, children));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps$7;

var _excluded$5 = ["as", "border", "children", "className", "id", "surface", "title"];
var defaultProps$8 = {
  as: 'div',
  border: true,
  className: '',
  surface: 'one',
  title: ''
};
var Card = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    border = _ref.border,
    children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    surface = _ref.surface,
    title = _ref.title,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var classes = useClasses(_extends({
    className: className,
    surface: surface,
    border: border
  }, rest));
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.card),
    "data-testid": id,
    ref: ref
  }, rest), title && React.createElement(Typography, {
    allBold: true,
    size: "4xl",
    className: "mb-2",
    as: "h1"
  }, title), children);
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps$8;

var ReactApexChart = /*#__PURE__*/React.lazy(function () {
  return import('react-apexcharts');
});
var defaultProps$9 = {
  as: 'div',
  className: '',
  colors: ['#ae1e55'],
  mode: 'dark',
  surface: 'two'
};
var formatNumberForAxis = function formatNumberForAxis(n) {
  if (n >= 1000000000000) {
    return (n / 1000000000000).toFixed(1) + 'T';
  }
  if (n >= 1000000000) {
    return (n / 1000000000).toFixed(1) + 'B';
  }
  if (n >= 1000000) {
    return (n / 1000000).toFixed(1) + 'M';
  }
  if (n >= 1000) {
    return (n / 1000).toFixed(1) + 'K';
  }
  return n.toFixed(1);
};
var Chart = function Chart(_ref) {
  var className = _ref.className,
    colors = _ref.colors,
    data = _ref.data,
    mode = _ref.mode,
    surface = _ref.surface,
    unit = _ref.unit;
  var options = {
    chart: {
      id: 'chart',
      type: 'area',
      zoom: {
        enabled: false
      },
      background: '#00000000'
    },
    theme: {
      mode: mode
    },
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shadeIntensity: 0,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 100]
      }
    },
    stroke: {
      curve: 'straight'
    },
    colors: colors,
    dataLabels: {
      enabled: false
    },
    xaxis: {
      type: 'datetime'
    },
    yaxis: {
      labels: {
        formatter: formatNumberForAxis
      }
    },
    tooltip: {
      y: {
        formatter: function formatter(n) {
          return formatNumberForAxis(n) + " " + unit;
        }
      }
    },
    grid: {
      borderColor: '#00000000'
    }
  };
  return React.createElement("div", {
    id: "chart",
    className: [className, 'flex', 'low-border', 'rounded-lg', 'items-center', 'justify-center', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : '', surface === 'three' ? 'bg-surface-level-three' : ''].join(' ')
  }, React.createElement(Suspense, {
    fallback: null
  }, React.createElement("div", {
    className: "w-full h-fit"
  }, typeof window !== 'undefined' ? React.createElement(ReactApexChart, {
    options: options,
    series: [{
      name: "" + unit,
      data: data
    }],
    type: "area"
  }) : null)));
};
Chart.displayName = 'Chart';
Chart.defaultProps = defaultProps$9;

var _excluded$6 = ["children", "className", "id", "size", "variant", "as"];
var defaultProps$a = {
  as: 'span',
  size: 'sm',
  variant: 'primary'
};
var Chip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    size = _ref.size,
    variant = _ref.variant,
    Component = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var classes = useClasses({
    className: className,
    size: size,
    variant: variant
  });
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.chip),
    "data-testid": id,
    ref: ref
  }, rest), children);
});
Chip.displayName = 'Chip';
Chip.defaultProps = defaultProps$a;

var DefaultDataLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    tooltip = _ref.tooltip,
    size = _ref.size,
    values = _ref.values,
    label = _ref.label,
    loaded = _ref.loaded,
    loading_surface_level = _ref.loading_surface_level,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'default-data-line' : _ref$id;
  return React.createElement(Component, {
    "data-testid": id,
    ref: ref,
    className: "flex space-x-4 items-start " + className,
    id: id
  }, React.createElement("div", {
    className: "flex min-w-max items-start space-x-4 flex-1 " + (values.length > 1 ? '' : 'items-center')
  }, React.createElement(Typography, {
    size: size,
    variant: "secondary"
  }, label), tooltip && React.createElement(Tooltip, {
    id: id,
    "data-testid": "tooltip",
    text: tooltip
  }, React.createElement(Media, {
    variant: "info-outline",
    className: "text-accent",
    size: 5
  }))), React.createElement("div", {
    className: "text-right space-y-3"
  }, values.map(function (_ref2, idx) {
    var value = _ref2.value,
      color = _ref2.color;
    return React.createElement(Typography, {
      className: (color ? color : '') + " " + (loaded ? '' : "h-5 animate-pulse " + loading_surface_level + " w-24 rounded-sm"),
      variant: color ? 'custom' : 'primary',
      key: idx + (value || ''),
      allBold: true,
      size: size
    }, loaded && value);
  })));
});
DefaultDataLine.displayName = 'DefaultDataLine';

var NumberedDataLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    values = _ref.values,
    label = _ref.label,
    tooltip = _ref.tooltip,
    number = _ref.number,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'numbered-data-line' : _ref$id;
  return React.createElement(Component, {
    ref: ref,
    className: "flex justify-between " + className,
    id: id,
    "data-testid": id
  }, React.createElement("div", {
    className: "flex items-center space-x-4"
  }, React.createElement(Steps, null, number || 0), React.createElement(Typography, {
    allBold: true,
    className: "flex-1"
  }, label), tooltip && React.createElement(Tooltip, {
    "data-testid": "tooltip",
    text: tooltip
  }, React.createElement(Media, {
    variant: "info-outline",
    className: "text-accent mt-[1px]",
    size: 5
  }))), values.map(function (_ref2, idx) {
    var value = _ref2.value,
      complete = _ref2.complete,
      color = _ref2.color;
    return React.createElement("div", {
      key: idx + (value || ''),
      className: "flex items-center"
    }, React.createElement(Typography, {
      allBold: true,
      size: "sm",
      className: "text-right flex items-center " + (color ? color : ''),
      variant: color ? 'custom' : 'primary'
    }, value), complete && React.createElement("div", {
      className: "pl-3"
    }, React.createElement(Steps, {
      variant: "secondary"
    }, React.createElement(Media, {
      size: 4,
      className: "pt-[2px]",
      variant: "tick"
    }))));
  }));
});
NumberedDataLine.displayName = 'NumberedDataLine';

var VerticleDataLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$top_size = _ref.top_size,
    top_size = _ref$top_size === void 0 ? 'sm' : _ref$top_size,
    _ref$bottom_size = _ref.bottom_size,
    bottom_size = _ref$bottom_size === void 0 ? 'xs' : _ref$bottom_size,
    is_top_bold = _ref.is_top_bold,
    is_bottom_bold = _ref.is_bottom_bold,
    values = _ref.values,
    label = _ref.label,
    label_color = _ref.label_color,
    _ref$float_right = _ref.float_right,
    float_right = _ref$float_right === void 0 ? false : _ref$float_right,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'verticle-data-line' : _ref$id;
  return React.createElement(Component, {
    ref: ref,
    className: className + " " + (float_right ? 'text-right' : ''),
    id: id
  }, values.map(function (_ref2, idx) {
    var value = _ref2.value,
      color = _ref2.color;
    return React.createElement(Typography, {
      className: color ? color : '',
      variant: color ? 'custom' : 'primary',
      key: idx + (value || ''),
      allBold: is_top_bold,
      size: top_size
    }, value);
  }), React.createElement(Typography, {
    allBold: is_bottom_bold,
    size: bottom_size,
    className: label_color ? label_color : '',
    variant: label_color ? 'custom' : 'secondary'
  }, label));
});
VerticleDataLine.displayName = 'VerticleDataLine';

var defaultProps$b = {
  as: 'div',
  label: undefined,
  variant: 'default',
  size: 'sm',
  is_top_bold: false,
  is_bottom_bold: false,
  loaded: true,
  loading_surface_level: 'bg-surface-level-two'
};
var renderSwitch = function renderSwitch(props, ref) {
  switch (props.variant) {
    case 'verticle':
      return React.createElement(VerticleDataLine, Object.assign({
        ref: ref
      }, props));
    case 'numbered':
      return React.createElement(NumberedDataLine, Object.assign({
        ref: ref
      }, props));
    default:
      return React.createElement(DefaultDataLine, Object.assign({
        ref: ref
      }, props));
  }
};
var DataLines = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(React.Fragment, null, renderSwitch(props, ref));
});
DataLines.displayName = 'DataLines';
DataLines.defaultProps = defaultProps$b;

var defaultProps$c = {
  as: 'div'
};
var Drawer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    as = _ref.as,
    show = _ref.show,
    className = _ref.className;
  return React.createElement(Transition, {
    show: show,
    as: as,
    ref: ref,
    className: "fixed inset-0 overflow-scroll " + className
  }, React.createElement(Transition.Child, {
    as: as,
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }), React.createElement(Transition.Child, {
    as: as,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "translate-x-full",
    className: "bg-surface-level-one"
  }, React.createElement("div", {
    className: "px-5 "
  }, children)));
});
Drawer.displayName = 'Drawer';
Drawer.defaultProps = defaultProps$c;

var _excluded$7 = ["as", "children", "className", "mediaClassName", "id", "options", "size", "surface", "title"];
var defaultProps$d = {
  as: 'div',
  size: 'md',
  surface: 'two',
  title: '',
  mediaClassName: ''
};
var Dropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    mediaClassName = _ref.mediaClassName,
    id = _ref.id,
    options = _ref.options,
    size = _ref.size,
    surface = _ref.surface,
    title = _ref.title,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var classes = useClasses({
    className: className,
    size: size,
    surface: surface
  });
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  return React.createElement(Menu, Object.assign({
    as: as,
    className: className + " relative inline-block text-left",
    ref: ref
  }, rest), React.createElement(Menu.Button, {
    className: ['h-11', 'border', 'rounded-lg', 'inline-flex', 'items-center', 'text-primary', 'border-border', 'border-opacity-[0.03]', surface === 'zero' ? 'bg-surface-level-zero hover:bg-surface-level-one' : '', surface === 'one' ? 'bg-surface-level-one hover:bg-surface-level-two' : '', surface === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : '', surface === 'three' ? 'bg-surface-level-three hover:bg-surface-level-one' : ''].join(' '),
    "data-testid": id,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, title, React.createElement(Media, {
    className: "mr-3",
    size: 4,
    variant: "chevron-down"
  })), React.createElement(Transition, {
    as: as,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, React.createElement(Menu.Items, {
    className: classes(styles$1.dropdown)
  }, options && options.map(function (_ref2) {
    var name = _ref2.name,
      icon = _ref2.icon,
      onOptionClick = _ref2.onOptionClick;
    return React.createElement(Menu.Item, {
      "data-testid": id + "-" + name,
      key: name
    }, function (_ref3) {
      var active = _ref3.active;
      return React.createElement("button", {
        className: ['p-4', 'flex', 'group', 'gap-4', 'w-full', 'text-sm', 'rounded-lg', 'inline-flex', 'items-center', 'text-primary', active && 'bg-surface-level-three'].join(' '),
        onClick: onOptionClick,
        type: "button"
      }, icon && React.createElement(Media, {
        size: 0,
        className: "h-[18px] " + mediaClassName,
        variant: icon
      }), name);
    });
  }))));
});
Dropdown.displayName = 'Dropdown';
Dropdown.defaultProps = defaultProps$d;

var defaultProps$e = {};
var HelperBox = function HelperBox(_ref) {
  var helper_text = _ref.helper_text,
    className = _ref.className;
  return React.createElement("div", {
    className: "flex flex-col " + className
  }, React.createElement("div", {
    className: "rounded-lg border border-border border-opacity-[0.03] bg-surface-level-three px-5 py-4 shadow-broad text-left text-xs text-secondary\n      "
  }, helper_text), React.createElement("div", {
    className: "ml-[45%] -mt-[1px] inline-block overflow-hidden"
  }, React.createElement("div", {
    className: "h-[14px] w-[14px] origin-top-left -rotate-45 transform border border-border border-opacity-[0.03] bg-surface-level-three rounded-sm"
  })));
};
HelperBox.displayName = 'HelperBox';
HelperBox.defaultProps = defaultProps$e;

var _excluded$8 = ["id", "children", "className", "text", "as"];
var defaultProps$f = {
  as: 'div',
  text: ''
};
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'tooltip' : _ref$id,
    children = _ref.children,
    text = _ref.text,
    Component = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return React.createElement(Component, Object.assign({
    "data-testid": id,
    ref: ref
  }, rest, {
    className: "tooltip-container"
  }), React.createElement("div", {
    "data-html": true,
    "data-tip": text,
    "data-for": id
  }, children), React.createElement(ReactTooltip, {
    html: true,
    className: "custom-tooltip bg-surface-level-three after:bg-surface-level-three",
    arrowColor: "bg-surface-level-three after:bg-surface-level-three",
    "data-testid": id,
    id: id
  }));
});
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = defaultProps$f;

var _excluded$9 = ["children", "className", "disabled", "error", "helperText", "id", "label", "is_initialized", "loading", "placeholder", "surface", "tooltip", "unit", "type", "handleMaxClick", "as", "containerClasses", "helper_box_text", "onBlur", "max_btn", "min_date_today"];
var defaultProps$g = {
  as: 'div',
  error: '',
  helperText: '',
  label: '',
  loading: false,
  surface: 'one',
  tooltip: '',
  unit: '',
  containerClasses: '',
  helper_text_arr: undefined,
  is_initialized: true,
  max_btn: true
};
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    helperText = _ref.helperText,
    id = _ref.id,
    label = _ref.label,
    is_initialized = _ref.is_initialized,
    loading = _ref.loading,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    surface = _ref.surface,
    tooltip = _ref.tooltip,
    unit = _ref.unit,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    handleMaxClick = _ref.handleMaxClick,
    Component = _ref.as,
    containerClasses = _ref.containerClasses,
    helper_box_text = _ref.helper_box_text,
    onBlur = _ref.onBlur,
    max_btn = _ref.max_btn,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var inputRef = useRef(null);
  var _useState = useState(false),
    focused = _useState[0],
    setFocused = _useState[1];
  var onFocus = function onFocus() {
    setFocused(true);
    if ((type === 'datetime-local' || type === 'date') && 'showPicker' in HTMLInputElement.prototype) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.showPicker();
    }
  };
  var handleBlur = function handleBlur(e) {
    setFocused(false);
    onBlur && onBlur(e);
  };
  var classes = useClasses({
    className: className,
    disabled: disabled,
    surface: surface
  });
  return React.createElement(Component, {
    className: containerClasses,
    ref: ref
  }, React.createElement("div", {
    className: "flex space-between items-center"
  }, React.createElement("label", {
    className: "mb-4 text-secondary text-sm",
    htmlFor: id
  }, label), tooltip && React.createElement(Tooltip, {
    text: tooltip,
    id: "tooltip-" + id
  }, React.createElement(Media, {
    className: "ml-2 mb-4 text-accent",
    size: 5,
    variant: "info-outline"
  })), is_initialized && error && React.createElement("div", {
    className: "flex-1 text-right text-xs mb-4 text-accent"
  }, error), !error && helperText && React.createElement("div", {
    className: "flex-1 text-right text-xs mb-4 text-secondary"
  }, helperText)), React.createElement("div", {
    className: "relative"
  }, focused && helper_box_text && React.createElement("div", {
    className: "absolute bottom-[43px] left-[28%] w-[194px]"
  }, React.createElement(HelperBox, {
    helper_text: helper_box_text
  })), React.createElement("input", Object.assign({
    ref: inputRef,
    id: id,
    className: classes(styles$1.input),
    "data-testid": id,
    onWheel: function onWheel(event) {
      return event.currentTarget.blur();
    },
    disabled: disabled,
    placeholder: placeholder,
    type: type,
    onFocus: onFocus,
    onBlur: handleBlur
  }, rest)), loading && React.createElement(Media, {
    className: "absolute right-5 bottom-2.5 text-button",
    size: 5,
    variant: "loader"
  }), !loading && React.createElement("div", null, unit && React.createElement("small", {
    className: (max_btn ? 'bottom-3 right-16' : 'bottom-[11px] right-5') + " absolute  text-primary text-sm font-bold"
  }, unit), max_btn && React.createElement("div", {
    className: "absolute bottom-[11px] right-5"
  }, handleMaxClick && React.createElement("button", {
    onClick: handleMaxClick
  }, React.createElement("small", {
    className: "text-accent text-sm pb-2"
  }, "MAX"))))));
});
Input.displayName = 'Input';
Input.defaultProps = defaultProps$g;

var defaultProps$h = {
  as: 'div',
  text: ''
};
var Loader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    text = _ref.text;
  return React.createElement(Component, {
    className: "relative",
    ref: ref
  }, React.createElement(Media, {
    size: 0,
    className: "w-[160px] md:w-[320px] text-accent",
    variant: "loader"
  }), React.createElement("img", {
    alt: "Decubate-logo.svg",
    className: "h-6 md:h-11 absolute top-[68px] md:top-[141px] left-[24px] md:left-[70px]",
    src: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/logo-light-theme.svg'
  }), React.createElement(Typography, {
    className: "pt-5 md:pt-8 text-center",
    size: "sm",
    variant: "secondary"
  }, text));
});
Loader.displayName = 'Loader';
Loader.defaultProps = defaultProps$h;

var defaultProps$i = {
  className: '',
  size: 'sm',
  surface: 'two',
  variant: 'staking'
};
var ProductBadge = function ProductBadge(_ref) {
  var variant = _ref.variant,
    surface = _ref.surface,
    size = _ref.size,
    className = _ref.className;
  return React.createElement("div", {
    className: ['low-border', 'rounded-full', size === 'md' ? 'p-[13px] h-[60px] w-[60px]' : 'p-[9px] h-[44px] w-[44px]', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : '', surface === 'three' ? 'bg-surface-level-three' : '', className].join(' ')
  }, React.createElement(Media, {
    size: size === 'md' ? 8 : 6,
    className: "text-secondary",
    variant: variant
  }));
};
ProductBadge.displayName = 'ProductBadge';
ProductBadge.defaultProps = defaultProps$i;

var _excluded$a = ["className", "id", "label", "marker", "percent", "surface", "as", "rounded", "height", "border", "progressClassName"];
var defaultProps$j = {
  as: 'div',
  label: false,
  marker: 0,
  percent: 0,
  surface: 'zero',
  rounded: true,
  border: true
};
var Progress = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    label = _ref.label,
    marker = _ref.marker,
    percent = _ref.percent,
    surface = _ref.surface,
    Component = _ref.as,
    rounded = _ref.rounded,
    height = _ref.height,
    border = _ref.border,
    _ref$progressClassNam = _ref.progressClassName,
    progressClassName = _ref$progressClassNam === void 0 ? '' : _ref$progressClassNam,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var classes = useClasses(_extends({
    className: className,
    surface: surface,
    rounded: rounded,
    border: border
  }, rest));
  var actual_height = height || (marker ? 'h-4' : 'h-2');
  return React.createElement("div", {
    className: label ? 'flex items-center space-x-2' : ''
  }, React.createElement(Component, Object.assign({
    ref: ref,
    className: classes(styles$1.progress)
  }, rest), marker && marker > 0 ? React.createElement("div", {
    className: "absolute bg-white w-1 " + actual_height,
    style: {
      left: marker + "%"
    }
  }, React.createElement("div", {
    className: "absolute flex h-full items-center right-4 text-primary text-xs"
  }, "MIN")) : null, React.createElement("div", {
    className: "bg-accent " + (rounded ? 'rounded-full' : '') + " " + actual_height + " " + progressClassName,
    "data-testid": id,
    style: {
      width: percent + "%"
    }
  })), label && React.createElement("div", {
    className: "text-accent text-xs"
  }, percent, "%"));
});
Progress.displayName = 'Progress';
Progress.defaultProps = defaultProps$j;

var defaultProps$k = {
  as: 'div',
  className: ''
};
var SortSearch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    mainTitle = _ref.mainTitle,
    selectedOption = _ref.selectedOption,
    sortOptions = _ref.sortOptions,
    handleSearch = _ref.handleSearch;
  return React.createElement(Component, {
    className: className + " grid grid-rows-1 md:grid-cols-2",
    ref: ref
  }, React.createElement("div", {
    className: "flex items-center"
  }, React.createElement(Typography, {
    allBold: true,
    as: "h1",
    size: "2xl"
  }, mainTitle)), React.createElement("div", {
    className: "flex gap-4 items-center mt-5 md:justify-end md:mt-0"
  }, React.createElement(Typography, {
    allBold: true,
    as: "label",
    className: "hidden md:block",
    size: "sm"
  }, "Sort by"), React.createElement(Dropdown, {
    options: sortOptions,
    size: "xs",
    surface: "one",
    title: React.createElement("span", {
      className: "mx-3"
    }, selectedOption)
  }), React.createElement("div", {
    className: "relative"
  }, React.createElement(Input, {
    className: "-mt-4 pr-10",
    placeholder: "Search your properties",
    surface: "one",
    type: "search",
    onChange: function onChange(ev) {
      return handleSearch(ev.target.value);
    }
  }), React.createElement("div", {
    className: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
  }, React.createElement(Media, {
    size: 4,
    variant: "search"
  })))));
});
SortSearch.displayName = 'SortSearch';
SortSearch.defaultProps = defaultProps$k;

var defaultProps$l = {
  as: Fragment,
  current: {
    label: '',
    id: ''
  },
  label: '',
  options: [],
  disabled: false,
  placeholder: '',
  surface: 'zero',
  setCurrent: function setCurrent() {}
};
var Select = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    tooltip = _ref.tooltip,
    current = _ref.current,
    label = _ref.label,
    options = _ref.options,
    placeholder = _ref.placeholder,
    surface = _ref.surface,
    disabled = _ref.disabled,
    setCurrent = _ref.setCurrent;
  return React.createElement("div", {
    className: className
  }, React.createElement("label", {
    className: "flex items-center mb-4 text-secondary text-sm"
  }, label, tooltip && React.createElement(Tooltip, {
    text: tooltip
  }, React.createElement(Media, {
    className: "ml-2 text-accent",
    size: 5,
    variant: "info-outline"
  }))), React.createElement(Listbox, {
    disabled: disabled,
    value: current,
    onChange: setCurrent
  }, React.createElement("div", {
    className: "relative"
  }, React.createElement(Listbox.Button, {
    "data-testid": "select",
    className: [disabled ? 'opacity-[0.6]' : '', 'h-11', 'bg-clip-padding', 'focus:border-opacity-[0.16]', disabled ? '' : 'hover:border-opacity-[0.16]', 'border', 'border-border', 'border-opacity-[0.03]', 'w-full', 'px-5', 'py-2', 'text-left', 'rounded-lg', 'text-primary', 'cursor-default', 'flex', 'justify-between', 'items-center', 'focus:outline-none', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : ''].join(' ')
  }, React.createElement(Typography, {
    className: "truncate",
    size: "sm",
    variant: current != null && current.label ? 'primary' : 'secondary'
  }, (current == null ? void 0 : current.label) || placeholder), React.createElement("span", {
    className: "pl-2 pointer-events-none flex items-center justify-center"
  }, React.createElement(Media, {
    className: "mt-[4px]",
    size: 5,
    variant: 'chevron-down'
  }))), React.createElement(Transition, {
    as: as,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    ref: ref
  }, React.createElement(Listbox.Options, {
    className: ['w-full', 'absolute', 'mt-1', 'z-50', 'max-h-40', 'low-border', 'overflow-auto', 'rounded-md', 'text-base', 'shadow-tight', 'focus:outline-none', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : ''].join(' ')
  }, options.map(function (option, idx) {
    return React.createElement(Listbox.Option, {
      key: option.label + idx,
      className: function className(_ref2) {
        var active = _ref2.active;
        return ['w-full', 'relative', 'cursor-default', 'select-none', 'p-3', active ? 'bg-surface-level-two' : 'bg-surface-level-zero'].join(' ');
      },
      value: option
    }, function (_ref3) {
      var active = _ref3.active,
        selected = _ref3.selected;
      return React.createElement(Typography, {
        className: "truncate",
        variant: active || selected ? 'primary' : 'secondary',
        "data-testid": option.label,
        size: "sm"
      }, option.label);
    });
  }))))));
});
Select.displayName = 'Select';
Select.defaultProps = defaultProps$l;

var defaultProps$m = {};
var SingleButton = function SingleButton(_ref) {
  var label = _ref.label,
    sub_label = _ref.sub_label,
    title = _ref.title,
    value = _ref.value,
    disabled = _ref.disabled,
    helper_text = _ref.helper_text,
    is_mobile = _ref.is_mobile,
    idx = _ref.idx,
    selected = _ref.selected,
    setSelected = _ref.setSelected;
  var _useState = useState(false),
    hover = _useState[0],
    setHover = _useState[1];
  useEffect(function () {
    if (disabled && selected === idx) {
      setSelected();
    }
  }, [disabled, selected, idx]);
  return React.createElement("div", {
    className: "relative",
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }, disabled && helper_text && hover && React.createElement("div", {
    className: "text-xs absolute z-50 w-[198px] " + (is_mobile ? 'bottom-[128px] left-[55px]' : 'bottom-[180px] left-[24px]')
  }, React.createElement(HelperBox, {
    className: "",
    helper_text: helper_text
  })), React.createElement(Card, {
    as: "button",
    onClick: function onClick() {
      return disabled ? null : setSelected(idx);
    },
    surface: "custom",
    className: "text-left w-full focus:outline-none " + (is_mobile ? 'p-5 space-y-2' : 'p-8 space-y-5') + " " + (disabled ? 'opacity-50' : '') + " " + (selected === idx ? 'bg-gradient-light-theme-alternative' : "bg-surface-level-two " + (disabled ? '' : 'hover:bg-surface-level-three'))
  }, React.createElement(Typography, {
    allBold: true,
    className: selected === idx ? 'text-surface-level-zero' : '',
    size: is_mobile ? '2xl' : '3xl'
  }, title), React.createElement("div", null, React.createElement(DataLines, {
    top_size: is_mobile ? 'md' : '2xl',
    bottom_size: "sm",
    label: label,
    label_color: selected === idx ? 'text-surface-level-zero' : 'text-secondary',
    variant: "verticle",
    values: [{
      value: value,
      color: selected === idx ? 'text-surface-level-zero' : 'text-accent'
    }]
  }), React.createElement(Typography, {
    className: selected === idx ? 'text-surface-level-zero' : 'text-secondary',
    variant: "custom",
    size: "sm"
  }, sub_label))));
};
var SquareButtons = function SquareButtons(_ref2) {
  var buttons_info_array = _ref2.buttons_info_array,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? 'square-buttons' : _ref2$id,
    selected = _ref2.selected,
    setSelected = _ref2.setSelected,
    label = _ref2.label,
    className = _ref2.className,
    tooltip = _ref2.tooltip;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 620;
  return React.createElement("div", {
    id: id,
    className: className
  }, label && React.createElement("label", {
    className: "flex items-center mb-4 text-secondary text-sm"
  }, label, tooltip && React.createElement(Tooltip, {
    id: id,
    text: tooltip
  }, React.createElement(Media, {
    className: "ml-2 text-accent",
    size: 5,
    variant: "info-outline"
  }))), React.createElement("div", {
    className: "grid " + (is_mobile ? 'grid-cols-1' : 'grid-cols-2') + " gap-5"
  }, buttons_info_array.map(function (props, idx) {
    return React.createElement("div", {
      key: props.title
    }, React.createElement(SingleButton, Object.assign({}, props, {
      selected: selected,
      setSelected: setSelected,
      is_mobile: is_mobile,
      idx: idx
    })));
  })));
};
SquareButtons.displayName = 'SquareButtons';
SquareButtons.defaultProps = defaultProps$m;

var FullWidthTabs = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    options = _ref.options,
    setCurrent = _ref.setCurrent,
    current = _ref.current,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'full-width' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return React.createElement(Component, {
    className: "h-16 flex w-full text-center bg-surface-level-one bg-clip-padding mb-10 cursor-pointer justify-start rounded-lg overflow-x-auto low-border space-x-[80px] px-[32px] scroll-none " + className,
    id: id,
    ref: ref
  }, options.map(function (_ref2) {
    var title = _ref2.title,
      locked = _ref2.locked,
      id = _ref2.id;
    return React.createElement("button", {
      key: title,
      id: title,
      disabled: locked,
      onClick: function onClick() {
        return setCurrent(id);
      },
      className: "min-w-max flex space-x-2 items-center justify-center " + (id === current ? 'border-b-4 border-accent pt-4 pb-3' : 'py-4')
    }, locked && React.createElement(Media, {
      variant: "lock",
      className: "text-secondary h-4 w-4"
    }), React.createElement(Typography, {
      allBold: id === current,
      size: "sm",
      variant: id !== current ? 'secondary' : 'primary'
    }, title));
  }));
});

var LimitedTabs = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    options = _ref.options,
    setCurrent = _ref.setCurrent,
    className = _ref.className,
    current = _ref.current,
    background_color = _ref.background_color,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'limited' : _ref$id;
  return React.createElement(Component, {
    ref: ref,
    className: "border bg-clip-padding rounded-lg border-border border-opacity-[0.03] h-[54px] flex items-center p-1 " + background_color + " " + className,
    id: id
  }, options.map(function (_ref2) {
    var title = _ref2.title,
      id = _ref2.id,
      locked = _ref2.locked;
    return React.createElement("button", {
      "data-testid": title,
      id: title,
      key: title,
      disabled: locked,
      onClick: function onClick() {
        return setCurrent(id);
      },
      className: "h-[44px] rounded flex-1 " + (id === current ? 'bg-surface-level-two text-primary low-border' : 'font-normal text-secondary') + " "
    }, React.createElement("div", {
      className: "flex justify-center items-center space-x-2"
    }, locked && React.createElement(Media, {
      variant: "lock",
      className: "text-secondary h-4 w-4"
    }), React.createElement(Typography, {
      allBold: id === current,
      size: "sm",
      variant: id !== current && 'secondary' || 'primary'
    }, title)));
  }));
});

var defaultProps$n = {
  variant: 'limited',
  as: 'div',
  disabled: false,
  background_color: 'bg-surface-level-one'
};
var renderSwitch$1 = function renderSwitch(props, ref) {
  switch (props.variant) {
    case 'full-width':
      return React.createElement(FullWidthTabs, Object.assign({
        ref: ref
      }, props));
    default:
      return React.createElement(LimitedTabs, Object.assign({
        ref: ref
      }, props));
  }
};
var Tabs = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(React.Fragment, null, renderSwitch$1(props, ref));
});
Tabs.displayName = 'Tabs';
Tabs.defaultProps = defaultProps$n;

var tier_borders = {
  yellow: 'border-[#CC7E00]',
  blue: 'border-[#007499]',
  green: 'border-[#1EAE8C]',
  orange: 'border-[#CC4900]',
  pink: 'border-[#E51A67]'
};
var defaultProps$o = {
  as: 'div',
  className: '',
  variant: 'md',
  is_max_tier: false,
  label: false
};
var TierLevel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var image_url = _ref.image_url,
    text = _ref.text,
    is_max_tier = _ref.is_max_tier,
    className = _ref.className,
    Component = _ref.as,
    variant = _ref.variant,
    _ref$multiplier = _ref.multiplier,
    multiplier = _ref$multiplier === void 0 ? 1 : _ref$multiplier,
    _ref$tier_color = _ref.tier_color,
    tier_color = _ref$tier_color === void 0 ? 'yellow' : _ref$tier_color,
    label = _ref.label;
  var medium = variant === 'md';
  var large = variant === 'lg';
  return React.createElement(Component, {
    ref: ref,
    className: "flex items-center " + className
  }, React.createElement("img", {
    className: (large ? 'h-[60px] w-[60px]' : medium ? 'w-11 h-11' : 'h-7 w-7') + " " + (label ? 'mr-5' : 'mr-2'),
    src: image_url,
    alt: "Tier-" + text
  }), React.createElement("div", {
    className: "flex " + (label ? '' : 'items-center')
  }, label ? React.createElement(DataLines, {
    variant: "verticle",
    is_top_bold: true,
    top_size: large ? 'xl' : '2xl',
    label: "Investor tier",
    bottom_size: large ? 'sm' : 'xs',
    values: [{
      value: text
    }]
  }) : React.createElement(Typography, {
    size: medium ? 'md' : 'sm',
    allBold: true
  }, text), is_max_tier && React.createElement("div", {
    className: "py-[2px] px-[6px] bg-surface-level-one rounded-lg border " + (label ? 'ml-3 h-7' : 'ml-2') + " " + tier_borders[tier_color]
  }, React.createElement(Typography, {
    className: "mb-[1px]",
    size: "sm",
    allBold: true
  }, multiplier, "x"))));
});
TierLevel.displayName = 'TierLevel';
TierLevel.defaultProps = defaultProps$o;

var toggle = styles$1.toggle;
var ToggleCheckbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    active = _ref.active,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'checkbox' : _ref$id,
    surface_level = _ref.surface_level;
  return React.createElement(Component, {
    ref: ref,
    className: "flex space-x-5 items-center"
  }, React.createElement("button", {
    id: id,
    onClick: onChange,
    value: active.toString(),
    className: "w-[22px] h-[22px] rounded bg-clip-padding bg-surface-level-" + surface_level + " " + toggle.border_classes + " " + className,
    "data-testid": id,
    disabled: disabled,
    type: "button"
  }, React.createElement("div", {
    className: "w-[21px] h-[21px] flex justify-center items-center"
  }, active && React.createElement(Media, {
    size: 0,
    className: "text-accent h-[15.5px] w-[15.5px]",
    variant: "tick"
  }))), label && React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, label));
});

var _excluded$b = ["active", "onChange", "as", "children", "className", "disabled", "id", "label"];
var ToggleSwitch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var active = _ref.active,
    onChange = _ref.onChange,
    as = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    disabled = _ref.disabled,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'switch' : _ref$id,
    label = _ref.label,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  return React.createElement(Switch.Group, Object.assign({
    as: as,
    className: className + " flex items-center",
    ref: ref
  }, rest), React.createElement(Switch.Label, {
    className: "block mb-2 text-sm font-medium text-secondary"
  }, label), React.createElement(Switch, {
    checked: active,
    onChange: onChange,
    "data-testid": id,
    className: ['relative', 'inline-flex', 'shrink-0', 'w-[50px]', 'h-[26px]', 'pt-[2px]', 'pl-[2px]', 'ease-in-out', 'duration-200', 'rounded-full', 'transition-colors', 'disabled:opacity-50', 'border', 'border-border', 'border-opacity-[0.03]', 'focus:border-accent', 'focus:border-opacity-100', 'hover:border-opacity-[0.16]', 'disabled:border-opacity-[0.03]', 'bg-clip-padding', active ? 'bg-gradient' : 'bg-surface-level-one'].join(' '),
    disabled: disabled
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: ['pointer-events-none', 'inline-block', 'h-[20px]', 'w-[20px]', 'transform', 'rounded-full', 'ring-0', 'transition', 'duration-200', 'ease-in-out', 'bg-white', active ? 'translate-x-6' : 'translate-x-0'].join(' ')
  })));
});

var toggle$1 = styles$1.toggle;
var ToggleRadioBtn = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    active = _ref.active,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'radio-btn' : _ref$id,
    surface_level = _ref.surface_level,
    size = _ref.size;
  return React.createElement(Component, {
    className: "flex space-x-2 " + className,
    ref: ref
  }, React.createElement("label", {
    htmlFor: id,
    className: "block mb-2 text-sm font-medium text-secondary"
  }, label), React.createElement("button", {
    id: id,
    onClick: onChange,
    value: active.toString(),
    className: "bg-clip-padding " + (size === 'md' ? 'w-5 h-5 rounded' : 'h-[26px] w-[26px] rounded-lg') + " bg-surface-level-" + surface_level + " " + toggle$1.border_classes + " " + className,
    "data-testid": id,
    disabled: disabled,
    type: "button"
  }, active && React.createElement("div", {
    "data-testid": "square-div",
    className: "mx-auto bg-gradient bg-origin-border border border-border border-opacity-10  " + (size === 'md' ? 'rounded-[0.188rem] h-3 w-3' : 'rounded h-3.5 w-3.5')
  })));
});

var defaultProps$p = {
  as: 'div',
  label: undefined,
  variant: 'switch',
  active: false,
  surface_level: 'zero',
  size: 'md'
};
var Toggle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  switch (props.variant) {
    case 'checkbox':
      return React.createElement(ToggleCheckbox, Object.assign({
        ref: ref
      }, props));
    case 'radio':
      return React.createElement(ToggleRadioBtn, Object.assign({
        ref: ref
      }, props));
    default:
      return React.createElement(ToggleSwitch, Object.assign({
        ref: ref
      }, props));
  }
});
Toggle.displayName = 'Toggle';
Toggle.defaultProps = defaultProps$p;

var _excluded$c = ["as", "children", "className", "subtitle"],
  _excluded2 = ["as", "children", "className", "isClickable", "isExpandable", "subtitle"];
var Accordion = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  return React.createElement(Disclosure, Object.assign({
    as: as,
    className: className + " mt-2 w-full",
    ref: ref
  }, rest), function (_ref2) {
    var open = _ref2.open;
    return React.createElement(React.Fragment, null, React.createElement(Disclosure.Button, {
      className: ['p-7', 'flex', 'w-full', 'border-t', 'border-x', 'text-left', 'items-center', 'justify-between', 'border-opacity-[0.03]', 'text-primary', 'border-border', 'bg-surface-level-one', open ? 'rounded-t-lg' : 'border-b rounded-lg hover:bg-surface-level-two'].join(' ')
    }, React.createElement(Typography, {
      allBold: true,
      as: "h3",
      size: "2xl"
    }, subtitle), React.createElement(Media, {
      size: 5,
      variant: open ? 'chevron-up' : 'chevron-down'
    })), React.createElement(Disclosure.Panel, {
      className: ['px-7', 'pb-7', 'border-b', 'border-x', 'rounded-b-lg', 'border-opacity-[0.03]', 'border-border', 'bg-surface-level-one'].join(' ')
    }, children));
  });
});
var Investment = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var as = _ref3.as,
    children = _ref3.children,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$isClickable = _ref3.isClickable,
    isClickable = _ref3$isClickable === void 0 ? false : _ref3$isClickable,
    _ref3$isExpandable = _ref3.isExpandable,
    isExpandable = _ref3$isExpandable === void 0 ? true : _ref3$isExpandable,
    _ref3$subtitle = _ref3.subtitle,
    subtitle = _ref3$subtitle === void 0 ? '' : _ref3$subtitle,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  return React.createElement(Disclosure, Object.assign({
    as: as,
    className: className + " mt-2 w-full",
    ref: ref
  }, rest), function (_ref4) {
    var open = _ref4.open;
    return React.createElement(React.Fragment, null, React.createElement(Disclosure.Button, {
      className: ['w-full', 'border-t', 'border-x', 'border-primary', 'border-opacity-[0.03]', 'bg-surface-level-one', open ? 'rounded-t-lg' : 'border-b rounded-lg md:hover:bg-surface-level-two'].join(' '),
      disabled: !isExpandable
    }, React.createElement("div", {
      className: "grid grid-cols-4 md:grid-cols-12 md:p-5"
    }, subtitle, React.createElement("div", {
      className: "col-span-2 hidden justify-self-end self-center md:block"
    }, isExpandable ? React.createElement(Media, {
      size: 5,
      variant: open ? 'chevron-up' : 'chevron-down'
    }) : null, isClickable ? React.createElement(Media, {
      size: 5,
      variant: "chevron-right"
    }) : null))), React.createElement(Disclosure.Panel, {
      className: ['px-5', 'pb-5', 'border-b', 'border-x', 'rounded-b-lg', 'border-border', 'border-opacity-[0.03]', 'bg-surface-level-one'].join(' ')
    }, children));
  });
});
Accordion.displayName = 'Accordion';
var Accordion$1 = /*#__PURE__*/Object.assign(Accordion, {
  Investment: Investment
});

var defaultProps$q = {
  as: 'div',
  className: '',
  steps: []
};
var AccountProgress = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    id = _ref.id,
    progress = _ref.progress,
    steps = _ref.steps;
  return React.createElement(Component, {
    className: "bg-surface-level-one low-border p-5 rounded space-y-8 " + className,
    "data-testid": id,
    ref: ref
  }, React.createElement("div", {
    className: "space-y-4"
  }, React.createElement(Typography, {
    allBold: true
  }, progress === 100 ? 'Congratulations! Your account is complete' : 'Let’s complete your investor account'), React.createElement(Progress, {
    label: true,
    percent: progress
  })), steps == null ? void 0 : steps.map(function (step, id) {
    return React.createElement("div", {
      className: "flex items-center gap-5",
      key: id
    }, React.createElement("div", null, React.createElement(Steps, {
      variant: "secondary"
    }, progress >= 100 / steps.length * (id + 1) ? React.createElement(Media, {
      size: 4,
      className: "pt-[2px]",
      variant: "tick"
    }) : null)), React.createElement("div", {
      className: "flex items-center justify-between w-full",
      onClick: step.onClick
    }, React.createElement(Typography, {
      variant: "secondary"
    }, step.label), progress < 100 / steps.length * (id + 1) && step.onClick !== undefined ? React.createElement(Media, {
      className: "cursor-pointer text-white",
      size: 5,
      variant: "arrow-right"
    }) : null));
  }), progress === 100 ? React.createElement(Button, {
    fullwidth: true,
    variant: "secondary"
  }, "Dismiss") : null);
});
AccountProgress.displayName = 'AccountProgress';
AccountProgress.defaultProps = defaultProps$q;

var defaultProps$r = {
  label: '',
  if_contract_type: false,
  loading: false,
  options: undefined,
  setSelectCurrent: undefined,
  select_current: undefined
};
var Form = function Form(_ref) {
  var tab_current = _ref.tab_current,
    contract = _ref.contract,
    balance = _ref.balance,
    handleClick = _ref.handleClick,
    value = _ref.value,
    handleChange = _ref.handleChange,
    loading = _ref.loading,
    handleMaxClick = _ref.handleMaxClick,
    token_ticker = _ref.token_ticker,
    options = _ref.options,
    setSelectCurrent = _ref.setSelectCurrent,
    select_current = _ref.select_current,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  return React.createElement("div", {
    className: "pt-5"
  }, options && React.createElement(Select, {
    current: select_current,
    setCurrent: setSelectCurrent,
    surface: "zero",
    placeholder: "Select contract",
    options: options,
    label: "Smart contract"
  }), React.createElement("div", {
    className: "bg-surface-level-two rounded-lg my-5 p-5 border space-y-[2px] border-border border-opacity-[0.03]"
  }, React.createElement(DataLines, {
    variant: "default",
    label: "Address",
    values: [{
      value: breakpoint < 640 ? shortenHex(contract) : contract
    }]
  }), React.createElement(DataLines, {
    variant: "default",
    label: "Balance",
    values: [{
      value: balance
    }]
  })), React.createElement(Input, {
    placeholder: "Enter " + (tab_current === daw_tab_options[0].id ? 'deposit' : 'withdraw') + " amount\n        ",
    min: 0,
    value: value,
    className: "w-full",
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    label: tab_current === daw_tab_options[0].id ? 'Deposit amount' : 'Withdraw amount',
    id: "contract-deposit-withdraw-input",
    type: "number",
    unit: token_ticker,
    surface: "zero",
    handleMaxClick: handleMaxClick
  }), React.createElement(Button, {
    id: "button",
    onClick: handleClick,
    className: "mt-5 w-full",
    disabled: value === '0' || value === '' || loading || disabled,
    loading: loading
  }, tab_current === daw_tab_options[0].id ? 'Deposit' : 'Withdraw'));
};
Form.displayName = 'Form';
Form.defaultProps = defaultProps$r;

var defaultProps$s = {};
var daw_tab_options = [{
  title: 'Deposit',
  id: '0'
}, {
  title: 'Withdraw',
  id: '1'
}];
var DepositWithdraw = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(Card, {
    ref: ref,
    className: "p-5 " + props.cardClassName
  }, React.createElement(Tabs, {
    variant: "limited",
    options: daw_tab_options,
    current: props.tab_current,
    setCurrent: function setCurrent(id) {
      return props.setTabCurrent(id);
    },
    background_color: "bg-surface-level-zero"
  }), React.createElement(Form, Object.assign({}, props)));
});
DepositWithdraw.displayName = 'DepositWithdraw';
DepositWithdraw.defaultProps = defaultProps$s;

var IconLink = function IconLink(_ref) {
  var type = _ref.type,
    url = _ref.url;
  var _useState = useState(false),
    hovering = _useState[0],
    setHovering = _useState[1];
  return React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    }
  }, React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "hover:text-primary"
  }, React.createElement(Media, {
    size: 5,
    className: hovering ? 'text-primary' : 'text-accent',
    variant: type
  })));
};
var defaultProps$t = {
  show_powered_by: true,
  as: 'footer',
  company_name: 'Decubate B.V',
  audited_by_img_urls: undefined
};
var Footer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    links = _ref2.links,
    social_links = _ref2.social_links,
    Component = _ref2.as,
    company_name = _ref2.company_name,
    audited_by_img_urls = _ref2.audited_by_img_urls,
    decubate_img_url = _ref2.decubate_img_url,
    show_powered_by = _ref2.show_powered_by;
  var breakpoint = useBreakpoint();
  var is_desktop = breakpoint > 709;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className
  }, audited_by_img_urls && React.createElement("div", {
    className: "" + (is_desktop ? 'flex items-center justify-center mb-[97px] space-x-[100px]' : "space-y-[38px] mb-[53px]")
  }, show_powered_by && React.createElement("a", {
    href: "https://www.decubate.com",
    target: "_blank",
    rel: "noopener"
  }, React.createElement(Typography, {
    className: "" + (is_desktop ? 'pb-6' : 'pb-4'),
    size: "sm",
    variant: "secondary"
  }, "Powered by"), React.createElement("img", {
    src: decubate_img_url
  })), React.createElement("div", null, React.createElement(Typography, {
    className: (breakpoint > 560 ? 'pb-6' : 'pb-4') + " " + (show_powered_by ? '' : "" + (is_desktop ? 'text-center' : 'text-left')),
    size: "sm",
    variant: "secondary"
  }, "Smart contracts audited by"), React.createElement("div", {
    className: "flex items-end " + (is_desktop ? 'space-x-[100px]' : 'space-x-10 ')
  }, React.createElement("img", {
    src: audited_by_img_urls[0]
  }), React.createElement("img", {
    src: audited_by_img_urls[1]
  })))), React.createElement("div", {
    className: "md:flex items-center " + (social_links.length ? 'mb-8' : 'md:mb-8') + " md:space-x-8"
  }, links && React.createElement("div", {
    className: "flex-1 md:flex items-center justify-items-start md:space-x-10 sm:gap-y-8 gap-y-10 grid grid-cols-2 sm:grid-cols-3"
  }, links.map(function (_ref3) {
    var name = _ref3.name,
      handleClick = _ref3.handleClick;
    return React.createElement("button", {
      key: name,
      onClick: handleClick
    }, React.createElement(Typography, {
      className: "hover:text-primary",
      size: "md",
      variant: "secondary"
    }, name));
  })), social_links && React.createElement("div", {
    className: "flex items-center justify-between space-x-10 mt-[60px] sm:mt-8 md:mt-0"
  }, social_links.map(function (_ref4, idx) {
    var type = _ref4.type,
      url = _ref4.url;
    return React.createElement(IconLink, {
      key: type + idx,
      type: type,
      url: url
    });
  }))), React.createElement("div", {
    className: "border-t-[1px] border-border text-primary"
  }, React.createElement(Typography, {
    size: "xs",
    className: "my-5"
  }, "\xA9 COPYRIGHT ", new Date().getFullYear(), " ", company_name, " | All rights reserved")));
});
Footer.displayName = 'Footer';
Footer.defaultProps = defaultProps$t;

var defaultProps$u = {
  className: '',
  disabled: false,
  continue_btn_text: 'Continue',
  loading: false,
  progress: undefined,
  skip_btn_text: undefined,
  subtitle: '',
  title: ''
};
var FormWrapper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    skip_btn_disabled = _ref.skip_btn_disabled,
    continue_btn_disabled = _ref.continue_btn_disabled,
    loading = _ref.loading,
    progress = _ref.progress,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_text = _ref.continue_btn_text,
    subtitle = _ref.subtitle,
    title = _ref.title,
    handleContinueBtnClick = _ref.handleContinueBtnClick,
    handleSkipBtnClick = _ref.handleSkipBtnClick;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "overflow-hidden max-w-[580px] " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    border: false,
    height: "h-4",
    percent: progress,
    rounded: false,
    surface: "two"
  }), React.createElement("div", {
    className: "h-8 border-x border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: (is_mobile ? 'px-5' : 'px-8') + " pt-8 rounded-b-lg " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, title), subtitle && React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center"
  }, subtitle), children, React.createElement("div", {
    className: "flex flex-row-reverse pt-8 " + (is_mobile ? 'pb-5' : 'pb-8')
  }, React.createElement(Button, {
    id: "continue-btn",
    className: skip_btn_text ? 'min-w-[177px]' : 'w-full',
    disabled: continue_btn_disabled,
    loading: loading,
    onClick: handleContinueBtnClick
  }, continue_btn_text), handleSkipBtnClick && skip_btn_text && React.createElement(Button, {
    id: "skip-btn",
    className: "bg-surface-level-one border-none text-secondary pr-5",
    disabled: skip_btn_disabled,
    variant: "custom",
    onClick: handleSkipBtnClick
  }, skip_btn_text))));
});
FormWrapper.displayName = 'FormWrapper';
FormWrapper.defaultProps = defaultProps$u;

var defaultProps$v = {
  as: 'div',
  tokens: [],
  surface: undefined
};
var StakingChips = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    className = _ref.className,
    tokens = _ref.tokens,
    surface = _ref.surface,
    is_always_mobile = _ref.is_always_mobile;
  var breakpoint = useBreakpoint();
  return React.createElement("div", {
    className: "flex gap-1 items-center"
  }, tokens == null ? void 0 : tokens.map(function (token) {
    return React.createElement(Chip, {
      className: [className, 'px-2', 'border', 'border-border', 'text-secondary', 'border-opacity-[0.03]', surface ? "bg-surface-level-" + surface : !is_always_mobile && breakpoint > 992 ? 'bg-surface-level-two' : is_always_mobile ? 'bg-surface-level-four' : 'bg-surface-level-three'].join(' '),
      "data-testid": id,
      key: JSON.stringify(token),
      ref: ref,
      size: "lg",
      variant: "custom"
    }, token.parts.length > 1 ? React.createElement(React.Fragment, null, React.createElement("div", {
      className: "relative w-12 -top-4"
    }, React.createElement("img", {
      src: token.parts[0].image,
      className: "absolute h-6 left-0 top-2",
      alt: token.parts[0].name
    }), React.createElement("img", {
      src: token.parts[1].image,
      className: "absolute h-6 left-4 top-0",
      alt: token.parts[1].name
    })), React.createElement("div", {
      className: "pb-1.5"
    }, React.createElement(Typography, {
      allBold: true,
      size: "sm"
    }, token.parts.map(function (t) {
      return t.name;
    }).join(' / ')), React.createElement(Typography, {
      variant: "secondary",
      size: "xs",
      className: "leading-[8px]"
    }, token.label))) : React.createElement(React.Fragment, null, React.createElement("img", {
      src: token.parts[0].image,
      className: "h-7 w-7",
      alt: token.parts[0].name
    }), React.createElement("div", {
      className: "ml-2 pb-1.5"
    }, React.createElement(Typography, {
      allBold: true,
      size: "sm"
    }, token.parts[0].name), React.createElement(Typography, {
      variant: "secondary",
      size: "xs",
      className: "leading-[8px]"
    }, token.label))));
  }));
});
StakingChips.displayName = 'StakingChips';
StakingChips.defaultProps = defaultProps$v;

var Links = function Links(_ref) {
  var nav_options = _ref.nav_options,
    current = _ref.current,
    setCurrent = _ref.setCurrent;
  var nav_options_to_use = useMemo(function () {
    return nav_options.filter(function (_ref2) {
      var desktop = _ref2.desktop;
      return desktop;
    });
  }, [nav_options]);
  return React.createElement("div", {
    className: "hidden md:flex items-center space-x-20 h-16"
  }, nav_options_to_use.map(function (_ref3) {
    var name = _ref3.name,
      id = _ref3.id,
      onOptionClick = _ref3.onOptionClick;
    return React.createElement("button", {
      key: name,
      id: name,
      onClick: function onClick() {
        setCurrent(id);
        onOptionClick();
      },
      className: "min-w-max flex space-x-2 items-center h-full justify-center " + (id === current ? 'border-b-4 border-accent pt-4 pb-3' : 'pt-4 pb-4')
    }, React.createElement(Typography, {
      allBold: id === current,
      size: "md"
    }, name));
  }));
};

var Logo = function Logo(_ref) {
  var _onClick = _ref.onClick,
    mobile = _ref.mobile,
    desktop = _ref.desktop;
  return React.createElement("button", {
    onClick: function onClick() {
      return _onClick();
    }
  }, React.createElement("div", {
    className: "hidden md:flex items-center"
  }, React.createElement("img", {
    src: desktop,
    className: "h-[30px]",
    alt: "Logo"
  })), React.createElement("div", {
    className: "flex items-center md:hidden"
  }, React.createElement("img", {
    src: mobile,
    className: "h-[30px]",
    alt: "Logo"
  })));
};

var Account = function Account(_ref) {
  var dropdown_options = _ref.dropdown_options,
    handleDrawerClose = _ref.handleDrawerClose;
  return React.createElement("div", {
    className: "space-y-6 mt-10 mb-4"
  }, dropdown_options.map(function (_ref2, idx) {
    var name = _ref2.name,
      icon = _ref2.icon,
      onOptionClick = _ref2.onOptionClick,
      rightBtnHandleClick = _ref2.rightBtnHandleClick,
      right_btn_text = _ref2.right_btn_text;
    return React.createElement("div", {
      key: name + idx,
      className: "flex justify-between"
    }, React.createElement("div", {
      className: "flex space-x-6 items-center"
    }, React.createElement(Media, {
      variant: icon,
      size: 5,
      className: "text-accent"
    }), React.createElement("button", {
      key: name,
      id: name,
      onClick: function onClick() {
        if (onOptionClick) {
          onOptionClick();
          handleDrawerClose();
        }
      }
    }, React.createElement(Typography, {
      variant: "secondary",
      size: "md"
    }, name))), rightBtnHandleClick && React.createElement(Typography, {
      size: "sm",
      variant: "custom",
      className: "text-accent hover:underline cursor-pointer pl-5",
      onClick: function onClick() {
        if (rightBtnHandleClick) {
          rightBtnHandleClick();
          handleDrawerClose();
        }
      }
    }, right_btn_text));
  }));
};

var defaultProps$w = {
  right_label_text: undefined,
  right_info_text: undefined,
  variant: 'none'
};
var ListItem = function ListItem(_ref) {
  var button_text = _ref.button_text,
    label_text = _ref.label_text,
    info_text = _ref.info_text,
    image_url = _ref.image_url,
    handleClick = _ref.handleClick,
    right_label_text = _ref.right_label_text,
    right_info_text = _ref.right_info_text,
    label_color = _ref.label_color,
    variant = _ref.variant;
  return React.createElement("div", {
    className: "flex justify-between items-center w-full"
  }, React.createElement("div", {
    className: "flex"
  }, image_url && React.createElement("div", {
    className: "pr-5"
  }, React.createElement("img", {
    className: "w-11 h-11",
    src: image_url,
    alt: label_text
  })), React.createElement(DataLines, {
    top_size: "md",
    bottom_size: variant === 'data' ? 'xs' : 'sm',
    is_top_bold: true,
    label: info_text,
    values: [{
      value: label_text
    }],
    className: "text-left",
    variant: "verticle"
  })), variant === 'button' && React.createElement(Typography, {
    size: "sm",
    onClick: handleClick,
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer pl-5 min-w-max"
  }, button_text), variant === 'data' && React.createElement(DataLines, {
    top_size: "md",
    bottom_size: "xs",
    is_top_bold: true,
    is_bottom_bold: true,
    label_color: label_color,
    label: right_info_text,
    values: [{
      value: right_label_text
    }],
    variant: "verticle",
    float_right: true
  }));
};
ListItem.displayName = 'ListItem';
ListItem.defaultProps = defaultProps$w;

var defaultProps$x = {
  surface: 'two'
};
var TierCard = function TierCard(_ref) {
  var tier_info = _ref.tier_info,
    className = _ref.className,
    surface = _ref.surface;
  return React.createElement(Card, {
    surface: surface,
    className: "px-5 py-4 " + className
  }, React.createElement(ListItem, {
    info_text: "Investor tier",
    label_text: tier_info == null ? void 0 : tier_info.tier_string,
    button_text: "Upgrade",
    variant: "button",
    image_url: tier_info.tier_img_url,
    handleClick: tier_info.handleClick
  }));
};
TierCard.displayName = 'TierCard';
TierCard.defaultProps = defaultProps$x;

var MobileNav = function MobileNav(_ref) {
  var dropdown_options = _ref.dropdown_options,
    mobile_nav_open = _ref.mobile_nav_open,
    handleDrawerClose = _ref.handleDrawerClose,
    nav_options = _ref.nav_options,
    tier = _ref.tier,
    handleTierClick = _ref.handleTierClick;
  return React.createElement(Drawer, {
    className: "md:hidden bg-surface-level-one mt-[63px] z-50 " + (tier ? 'pt-5' : ''),
    show: mobile_nav_open
  }, tier && React.createElement(TierCard, {
    tier_info: {
      handleClick: handleTierClick,
      tier_string: (tier == null ? void 0 : tier.text) || '',
      tier_img_url: tier == null ? void 0 : tier.image_url
    }
  }), React.createElement("div", null, React.createElement("div", {
    className: "space-y-10 pt-10"
  }, nav_options.map(function (_ref2) {
    var name = _ref2.name,
      onOptionClick = _ref2.onOptionClick;
    return React.createElement("div", {
      key: name
    }, React.createElement("button", {
      onClick: function onClick() {
        onOptionClick();
        handleDrawerClose();
      }
    }, React.createElement(Typography, {
      allBold: true,
      as: "h4",
      size: "2xl"
    }, name)));
  })), React.createElement(Account, {
    handleDrawerClose: handleDrawerClose,
    dropdown_options: dropdown_options
  })));
};
MobileNav.displayName = 'MobileNav';

var defaultProps$y = {
  user: undefined,
  tier: undefined,
  dcb_burned: undefined
};
var Header = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    dropdown_options = _ref.dropdown_options,
    tier = _ref.tier,
    setCurrent = _ref.setCurrent,
    current = _ref.current,
    nav_options = _ref.nav_options,
    logo = _ref.logo,
    handleTierClick = _ref.handleTierClick,
    dcb_burned = _ref.dcb_burned,
    handleBurnClick = _ref.handleBurnClick;
  var _useState = useState(false),
    mobile_nav_open = _useState[0],
    setMobileNavOpen = _useState[1];
  var handleDrawerClose = function handleDrawerClose() {
    setMobileNavOpen(false);
  };
  return React.createElement("header", {
    "data-testid": "header",
    className: "bg-surface-level-one w-full mx-auto flex items-center justify-center h-16 " + (className || ''),
    ref: ref
  }, React.createElement("div", {
    className: "flex justify-between px-5 w-full max-w-screen-lg mx-auto"
  }, React.createElement("div", {
    className: "flex items-center space-x-20"
  }, React.createElement(Logo, Object.assign({}, logo)), React.createElement(Links, {
    nav_options: nav_options,
    current: current,
    setCurrent: setCurrent
  })), React.createElement("div", {
    className: "flex my-auto space-x-3"
  }, dcb_burned && React.createElement("div", {
    className: "cursor-pointer",
    onClick: handleBurnClick
  }, React.createElement(StakingChips, {
    className: "hover:bg-surface-level-three",
    surface: "two",
    id: "burn-chip",
    tokens: [{
      label: 'DCB burned',
      parts: [{
        image: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/DCB-Burn.svg',
        name: dcb_burned || ''
      }]
    }]
  })), React.createElement("div", {
    className: "flex space-x-5 md:space-x-10 items-center"
  }, React.createElement(AccountDropdown, {
    tier_info: tier ? {
      tier_string: (tier == null ? void 0 : tier.text) || '',
      tier_img_url: tier == null ? void 0 : tier.image_url,
      handleClick: handleTierClick
    } : undefined,
    setMobileNavOpen: setMobileNavOpen,
    mobile_nav_open: mobile_nav_open,
    className: "absolute z-30 md:inline-block",
    options: dropdown_options,
    mediaClassName: "text-accent"
  })))), React.createElement(MobileNav, {
    tier: tier,
    handleTierClick: handleTierClick,
    handleDrawerClose: handleDrawerClose,
    nav_options: nav_options,
    dropdown_options: dropdown_options,
    mobile_nav_open: mobile_nav_open
  }));
});
Header.displayName = 'Header';
Header.defaultProps = defaultProps$y;

var defaultProps$z = {
  as: 'div',
  className: ''
};
var DisclosureButton = function DisclosureButton(_ref) {
  var eventName = _ref.eventName,
    isProtected = _ref.isProtected,
    status = _ref.status,
    totalInvested = _ref.totalInvested,
    totalTokens = _ref.totalTokens,
    vestingDetails = _ref.vestingDetails,
    handleClick = _ref.handleClick;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: ['p-5', 'col-span-4', 'rounded-lg', 'bg-surface-level-two', 'md:p-0', 'md:rounded-none', 'md:bg-transparent', handleClick ? 'cursor-pointer' : ''].join(' '),
    onClick: handleClick
  }, React.createElement("div", {
    className: "flex items-center self-center"
  }, React.createElement(Typography, {
    allBold: true
  }, eventName), isProtected ? React.createElement("img", {
    className: "h-8 w-8 ml-3",
    src: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/Protected-Green.svg',
    alt: "protected"
  }) : null, React.createElement("span", {
    className: "ml-auto md:hidden"
  }, handleClick ? React.createElement(Media, {
    size: 5,
    variant: "chevron-right"
  }) : vestingDetails !== undefined ? React.createElement(Media, {
    size: 5,
    variant: "chevron-down"
  }) : null))), React.createElement("div", {
    className: "col-span-2 mt-5 pl-5 self-center md:hidden"
  }, React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Invested")), React.createElement("div", {
    className: "col-span-2 mt-5 pr-5 self-center md:mt-0 md:pr-0"
  }, React.createElement("p", {
    className: "font-bold text-primary text-right text-sm md:font-normal md:text-justify"
  }, totalInvested)), React.createElement("div", {
    className: "col-span-2 pl-5 self-center md:hidden"
  }, React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Tokens")), React.createElement("div", {
    className: "col-span-2 pr-5 self-center md:pr-0"
  }, React.createElement("p", {
    className: "font-bold text-primary text-right text-sm md:font-normal md:text-justify"
  }, totalTokens)), React.createElement("div", {
    className: "col-span-2 mb-5 pl-5 self-center md:hidden"
  }, React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Status")), React.createElement("div", {
    className: "col-span-2 mb-5 pr-5 self-center md:mb-0 md:pr-0"
  }, React.createElement("p", {
    className: "font-bold text-primary text-right text-sm md:font-normal md:text-justify"
  }, status)));
};
var PortfolioItem = function PortfolioItem(_ref2) {
  var className = _ref2.className,
    eventName = _ref2.eventName,
    isProtected = _ref2.isProtected,
    status = _ref2.status,
    totalInvested = _ref2.totalInvested,
    totalTokens = _ref2.totalTokens,
    vestingDetails = _ref2.vestingDetails,
    handleClick = _ref2.handleClick;
  return React.createElement(Accordion$1.Investment, {
    className: "" + className,
    isClickable: handleClick !== undefined,
    isExpandable: vestingDetails !== undefined,
    subtitle: React.createElement(DisclosureButton, {
      eventName: eventName,
      isProtected: isProtected,
      status: status,
      totalInvested: totalInvested,
      totalTokens: totalTokens,
      vestingDetails: vestingDetails,
      handleClick: handleClick
    })
  }, React.createElement("div", {
    className: "flex flex-col gap-5 border-t border-surface-level-three md:flex-row"
  }, React.createElement("div", {
    className: "flex-1 space-y-5"
  }, React.createElement("div", {
    className: "gap-5 grid grid-cols-2 mt-5 md:grid-cols-3"
  }, React.createElement(Card, {
    className: "p-5 w-full",
    surface: "two"
  }, React.createElement("h1", {
    className: "font-bold text-md text-white md:text-2xl"
  }, vestingDetails == null ? void 0 : vestingDetails.startDate), React.createElement(Typography, {
    allCaps: true,
    size: "xs",
    variant: "secondary"
  }, "vesting start")), React.createElement(Card, {
    className: "p-5 w-full",
    surface: "two"
  }, React.createElement("h1", {
    className: "font-bold text-md text-white md:text-2xl"
  }, vestingDetails == null ? void 0 : vestingDetails.endDate), React.createElement(Typography, {
    allCaps: true,
    size: "xs",
    variant: "secondary"
  }, "vesting end")), React.createElement(Card, {
    className: "col-span-2 p-5 w-full md:col-span-1",
    surface: "two"
  }, React.createElement("h1", {
    className: "font-bold text-md text-white md:text-2xl"
  }, vestingDetails == null ? void 0 : vestingDetails.refundDeadline), React.createElement(Typography, {
    allCaps: true,
    size: "xs",
    variant: "secondary"
  }, "refund deadline"))), React.createElement("div", null, React.createElement(Card, {
    className: "p-5",
    surface: "two"
  }, React.createElement("div", {
    className: "mb-8 space-y-2"
  }, React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Locked"), React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, vestingDetails == null ? void 0 : vestingDetails.locked)), React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Claimed"), React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, vestingDetails == null ? void 0 : vestingDetails.claimed)), React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Available to claim"), React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, vestingDetails == null ? void 0 : vestingDetails.available))), React.createElement(Button, {
    fullwidth: true,
    className: "mb-4"
  }, "Claim tokens"), React.createElement(Button, {
    fullwidth: true,
    className: "bg-surface-level-three text-secondary",
    variant: "custom"
  }, "Refund")))), React.createElement(Chart, {
    className: "flex-1 md:mt-5",
    data: vestingDetails == null ? void 0 : vestingDetails.chartData,
    unit: "" + (vestingDetails == null ? void 0 : vestingDetails.symbol)
  })));
};
PortfolioItem.displayName = 'PortfolioItem';
PortfolioItem.defaultProps = defaultProps$z;

var defaultProps$A = {
  surface: 'one'
};
var ListItemUnit = function ListItemUnit(_ref) {
  var list_item_arr = _ref.list_item_arr,
    className = _ref.className,
    surface = _ref.surface;
  return React.createElement("div", {
    className: "bg-surface-level-" + surface + " low-border rounded-lg max-w-[580px] w-full " + className
  }, list_item_arr.map(function (_ref2, id) {
    var button_text = _ref2.button_text,
      label_text = _ref2.label_text,
      info_text = _ref2.info_text,
      image_url = _ref2.image_url,
      handleClick = _ref2.handleClick,
      right_info_text = _ref2.right_info_text,
      right_label_text = _ref2.right_label_text,
      label_color = _ref2.label_color,
      variant = _ref2.variant;
    return React.createElement("div", {
      key: JSON.stringify({
        label_text: label_text,
        id: id
      })
    }, React.createElement("div", {
      className: "px-5 py-4"
    }, React.createElement(ListItem, {
      variant: variant,
      button_text: button_text,
      label_text: label_text,
      info_text: info_text,
      image_url: image_url,
      handleClick: handleClick,
      label_color: label_color,
      right_info_text: right_info_text,
      right_label_text: right_label_text
    })), list_item_arr.length - 1 !== id && React.createElement("div", {
      key: label_text + "-" + id,
      className: "border-b bg-surface-level-three border-b-surface-level-three " + (image_url ? 'mr-5 ml-[84px]' : 'mr-5 ml-5')
    }));
  }));
};
ListItemUnit.displayName = 'ListItemUnit';
ListItemUnit.defaultProps = defaultProps$A;

var LoginFooter = function LoginFooter(_ref) {
  var nav_options = _ref.nav_options,
    className = _ref.className;
  return React.createElement("div", {
    className: "px-5 " + className
  }, React.createElement(Typography, {
    variant: "secondary",
    className: "text-center mb-10",
    size: "md"
  }, "Trusted by"), React.createElement("div", {
    className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 items-center justify-center gap-[60px] w-full px-10"
  }, nav_options.map(function (_ref2) {
    var image_url = _ref2.image_url,
      link = _ref2.link;
    return React.createElement("a", {
      key: image_url,
      className: "flex items-center justify-center",
      target: "_blank",
      rel: "noreferrer",
      href: link
    }, React.createElement("img", {
      alt: link,
      src: image_url
    }));
  })));
};
LoginFooter.displayName = 'LoginFooter';

var defaultProps$B = {};
var MessageCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    subtitle = _ref.subtitle,
    progress = _ref.progress,
    title = _ref.title,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    loading = _ref.loading,
    disabled = _ref.disabled;
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "max-w-[580px] overflow-hidden " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    percent: progress,
    surface: "two",
    border: false,
    height: "h-4",
    rounded: false
  }), React.createElement("div", {
    className: "h-8 border border-b-surface-level-one border-t-surface-level-one border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: "px-8 pt-8 rounded-b-lg  " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: "4xl",
    allBold: true
  }, title), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center"
  }, subtitle), React.createElement("div", {
    className: "flex flex-row-reverse py-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    disabled: disabled,
    onClick: function onClick() {
      return handleContinueClick();
    },
    className: "" + (skip_btn_text ? 'w-[200px]' : 'w-full'),
    type: "submit",
    loading: loading
  }, continue_btn_text), skip_btn_text && handleSkipClick && React.createElement("button", {
    "data-testid": "skip-btn",
    onClick: function onClick() {
      return handleSkipClick();
    },
    className: "sm:px-10 pr-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, skip_btn_text)))));
});
MessageCard.displayName = 'MessageCard';
MessageCard.defaultProps = defaultProps$B;

var _excluded$d = ["as", "children", "className", "desc", "noClose", "show", "title", "surface", "onClose", "is_fixed_height", "container_class"];
var defaultProps$C = {
  as: 'div',
  desc: '',
  noClose: false,
  surface: 'one',
  title: '',
  is_fixed_height: true
};
var Modal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    children = _ref.children,
    className = _ref.className,
    desc = _ref.desc,
    noClose = _ref.noClose,
    show = _ref.show,
    title = _ref.title,
    surface = _ref.surface,
    onClose = _ref.onClose,
    is_fixed_height = _ref.is_fixed_height,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var _useState = useState(false),
    inside_card = _useState[0],
    setInsideCard = _useState[1];
  return React.createElement(Transition, {
    show: show,
    onClick: inside_card ? undefined : onClose
  }, React.createElement(Component, Object.assign({
    ref: ref
  }, rest), React.createElement(Transition.Child, {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    className: "z-50"
  }, React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-80"
  })), React.createElement("div", {
    className: "fixed inset-0 overflow-y-auto"
  }, React.createElement("div", {
    className: "flex min-h-full items-center justify-center p-4 text-center"
  }, React.createElement(Transition.Child, {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 scale-95",
    enterTo: "opacity-100 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 scale-100",
    leaveTo: "opacity-0 scale-95",
    className: "w-full z-50"
  }, !noClose ? React.createElement(Button, {
    iconOnly: true,
    className: [surface === 'zero' ? 'bg-surface-level-zero hover:bg-surface-level-one' : '', surface === 'one' ? 'bg-surface-level-one hover:bg-surface-level-two' : '', surface === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : '', surface === 'three' ? 'bg-surface-level-three hover:bg-surface-level-zero' : '', surface === 'custom' ? 'bg-primary hover:bg-white' : '', 'mb-8'].join(' '),
    variant: "custom",
    onClick: onClose
  }, React.createElement(Media, {
    size: 5,
    variant: "cross"
  })) : null, React.createElement("div", {
    className: ['p-5', 'border', 'border-white', 'border-opacity-[0.03]', 'w-full', 'mx-auto', 'transform', 'rounded-lg', 'align-middle', 'max-w-[580px]', 'overflow-auto', 'transition-all', 'xs:p-8', is_fixed_height ? 'max-h-[540px] xs:max-h-[580px]' : '', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : '', surface === 'three' ? 'bg-surface-level-three' : '', surface === 'custom' ? '' : ''].join(' '),
    onMouseEnter: function onMouseEnter() {
      return setInsideCard(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInsideCard(false);
    }
  }, React.createElement("h3", {
    className: "font-bold text-3xl text-center text-primary xs:text-4xl"
  }, title), React.createElement("div", {
    className: "mt-2 text-center text-secondary"
  }, desc), React.createElement("div", {
    className: "mt-8 " + className
  }, children)))))));
});
Modal.displayName = 'Modal';
Modal.defaultProps = defaultProps$C;

var defaultProps$D = {
  className: '',
  multiplier: {
    active: false,
    amount: '0',
    boostReward: '0',
    name: ''
  }
};
var MultiplierChip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    className = _ref.className,
    multiplier = _ref.multiplier;
  return React.createElement(Tooltip, {
    text: "\n        <div class=\"flex gap-4\">\n          <div class=\"text-secondary min-w-max\">Required NFT</div>\n          <div class=\"text-primary font-bold\">" + (multiplier == null ? void 0 : multiplier.name) + "</div>\n        </div>\n        <div class=\"flex gap-4\">\n          <div class=\"text-secondary min-w-max\">APY with boost</div>\n          <div class=\"text-primary font-bold\">" + (multiplier == null ? void 0 : multiplier.boostReward) + "</div>\n        </div>\n      "
  }, React.createElement(Chip, {
    as: 'div',
    id: multiplier != null && multiplier.active ? 'MultiplierActive' : 'MultiplierInactive',
    className: [className, 'gap-1', 'px-2', 'text-secondary', 'bg-surface-level-two', multiplier != null && multiplier.active ? 'border border-success border-opacity-100' : 'border border-border border-opacity-[0.03]'].join(' '),
    "data-testid": id,
    ref: ref,
    size: "md",
    variant: "custom"
  }, React.createElement("div", {
    className: ['h-4', 'w-4', 'flex', 'border', 'rounded-full', 'items-center', 'justify-center', 'bg-clip-padding', 'border-opacity-[0.03]', 'bg-surface-level-one', 'border-border'].join(' ')
  }, multiplier != null && multiplier.active ? React.createElement("div", {
    className: "bg-success bg-clip-padding h-3 rounded-full w-3"
  }) : null), React.createElement("div", null, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, multiplier == null ? void 0 : multiplier.amount))));
});
MultiplierChip.displayName = 'MultiplierChip';
MultiplierChip.defaultProps = defaultProps$D;

var defaultProps$E = {
  chipText: '',
  className: '',
  subtitle: '',
  surface: 'one',
  title: '',
  variant: 'staking'
};
var ProductCard = function ProductCard(_ref) {
  var id = _ref.id,
    chipText = _ref.chipText,
    className = _ref.className,
    subtitle = _ref.subtitle,
    surface = _ref.surface,
    title = _ref.title,
    variant = _ref.variant,
    handleClick = _ref.handleClick;
  var breakpoint = useBreakpoint();
  var _useState = useState(false),
    hover = _useState[0],
    setHover = _useState[1];
  return React.createElement("button", {
    onClick: handleClick,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    className: ['px-5', 'py-[12px]', 'flex', 'w-full', 'relative', 'low-border', 'rounded-lg', 'items-center', surface === 'zero' ? 'bg-surface-level-zero hover:bg-surface-level-one' : '', surface === 'one' ? 'bg-surface-level-one hover:bg-surface-level-two' : '', surface === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : '', surface === 'three' ? 'bg-surface-level-three' : '', 'xs:p-5', className].join(' '),
    "data-testid": id
  }, chipText ? React.createElement(Chip, {
    variant: "custom",
    size: "xs",
    className: "bg-gradient-purple text-primary text-xs font-bold px-3 absolute -top-3 right-5"
  }, chipText) : null, React.createElement(ProductBadge, {
    size: breakpoint < 480 ? 'sm' : 'md',
    surface: hover ? 'three' : 'two',
    variant: variant
  }), React.createElement("div", {
    className: "pl-5 pb-[1px] text-left"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, subtitle), React.createElement(Typography, {
    allBold: true,
    as: "h3",
    size: "2xl"
  }, title)));
};
ProductCard.displayName = 'ProductCard';
ProductCard.defaultProps = defaultProps$E;

var BADGE_COLOR = {
  'bg-gradient': 'primary',
  'bg-gradient-purple': 'light'
};
var ProjectCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    chip_text = _ref.chip_text,
    heading_text = _ref.heading_text,
    image_url = _ref.image_url,
    logo_url = _ref.logo_url,
    network_logo = _ref.network_logo,
    status_badge = _ref.status_badge,
    card_data = _ref.card_data,
    badge_color = _ref.badge_color,
    protected_img_url = _ref.protected_img_url,
    protected_helper_text = _ref.protected_helper_text,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'project-card' : _ref$id;
  var _useState = useState(true),
    logo_loading = _useState[0],
    setLogoLoading = _useState[1];
  var _useState2 = useState(true),
    image_loading = _useState2[0],
    setImageLoading = _useState2[1];
  var _useState3 = useState(false),
    hover = _useState3[0],
    setHover = _useState3[1];
  var image = useRef(null);
  var logo = useRef(null);
  useEffect(function () {
    var _image$current;
    if ((_image$current = image.current) != null && _image$current.complete) setImageLoading(false);
  }, [image.current]);
  useEffect(function () {
    var _logo$current;
    if ((_logo$current = logo.current) != null && _logo$current.complete) setLogoLoading(false);
  }, [logo]);
  return React.createElement(Card, {
    id: id,
    className: "relative w-full " + className,
    ref: ref
  }, React.createElement("div", {
    className: "relative " + (image_loading ? 'bg-surface-level-two aspect-[7/4] animate-pulse' : '')
  }, React.createElement("div", null, React.createElement("img", {
    ref: image,
    className: "rounded-t-lg w-full",
    src: image_url,
    alt: "card-img",
    onLoad: function onLoad() {
      return setImageLoading(false);
    }
  })), React.createElement("div", {
    className: "flex items-center justify-center w-20 h-20 bg-surface-level-zero low-border rounded-lg absolute left-7 bottom-[-32px] " + (logo_loading ? 'animate-pulse' : '')
  }, React.createElement("img", {
    ref: logo,
    src: logo_url,
    className: "h-[52px] w-[52px]",
    placeholder: "project-logo",
    onLoad: function onLoad() {
      return setLogoLoading(false);
    }
  }))), React.createElement("div", {
    className: "pb-7 px-7 pt-12"
  }, React.createElement(Chip, {
    className: "absolute right-7 top-7",
    variant: badge_color ? BADGE_COLOR[badge_color] : 'secondary'
  }, status_badge), protected_img_url && protected_helper_text && hover && React.createElement(HelperBox, {
    className: "absolute w-[180px] bottom-[216px] left-[80px]",
    helper_text: protected_helper_text
  }), protected_img_url && React.createElement("img", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    className: "absolute left-[155px] h-8 w-8",
    src: protected_img_url,
    alt: "protected"
  }), React.createElement("div", {
    className: "flex items-center space-x-8"
  }, React.createElement(Chip, {
    variant: "secondary"
  }, chip_text), React.createElement("div", {
    className: "flex-1 flex items-center justify-end"
  }, React.createElement("div", {
    className: "p-1 h-8 w-8 bg-white rounded-full border border-border border-opacity-5"
  }, network_logo ? React.createElement("img", {
    src: network_logo,
    alt: "network",
    className: "h-6 w-6"
  }) : React.createElement("div", {
    className: "h-6 w-6 pb-[2px] pr-[2px] flex items-center justify-center text-xl text-black"
  }, React.createElement("strong", null, "?"))))), React.createElement(Typography, {
    allBold: true,
    className: "pt-4",
    as: "h3",
    size: "3xl"
  }, heading_text), React.createElement("div", {
    className: "space-y-3 pt-4"
  }, card_data.map(function (_ref2, idx) {
    var label = _ref2.label,
      values = _ref2.values;
    return React.createElement(DataLines, {
      key: label + idx,
      label: label,
      values: values,
      variant: "default"
    });
  }))));
});
ProjectCard.displayName = 'ProjectCard';

var defaultProps$F = {
  loading: false,
  disabled: false
};
var Setup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    value = _ref.value,
    loading = _ref.loading,
    handleClick = _ref.handleClick,
    handleChange = _ref.handleChange,
    error = _ref.error,
    handleSkipClick = _ref.handleSkipClick,
    qr_code = _ref.qr_code,
    progress = _ref.progress,
    disabled = _ref.disabled;
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "overflow-hidden max-w-[580px] " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    percent: progress,
    surface: "two",
    border: false,
    height: "h-4",
    rounded: false
  }), React.createElement("div", {
    className: "h-8 border-x border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: "px-8 pt-8 rounded-b-lg " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: "4xl",
    allBold: true
  }, "2FA setup"), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center pb-8"
  }, React.createElement("span", null, "Please use your authenticator app such as ", React.createElement("br", null), "Google Authenticator, to scan this QR code.")), React.createElement("div", {
    className: "mx-auto flex items-center justify-center rounded-lg bg-surface-level-two w-[230px] h-[230px]"
  }, qr_code ? React.createElement("img", {
    src: qr_code,
    className: "w-[230px] h-[230px] mx-auto rounded-lg",
    alt: "QR code"
  }) : React.createElement(Media, {
    className: "text-button",
    variant: "loader"
  })), React.createElement(Typography, {
    variant: "secondary",
    className: "pt-8",
    size: "sm"
  }, React.createElement("span", null, "1. Download an authenticator app on your phone or tablet", React.createElement("br", null), "2. Scan the QR code using the app", React.createElement("br", null), "3. Enter the code below")), React.createElement(Input, {
    containerClasses: "pt-8",
    surface: "zero",
    placeholder: "Enter verification code",
    id: "verification",
    label: "Verification code",
    type: "text",
    value: value,
    error: error,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  }), React.createElement("div", {
    className: "flex flex-row-reverse py-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    onClick: function onClick() {
      return handleClick();
    },
    className: "w-[114px]",
    type: "submit",
    loading: loading,
    disabled: disabled
  }, "Enable 2FA"), React.createElement("button", {
    "data-testid": "skip-btn",
    onClick: function onClick() {
      return handleSkipClick();
    },
    className: "px-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Cancel")))));
});
Setup.displayName = 'Setup';
Setup.defaultProps = defaultProps$F;

var screens = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1220
};
var defaultProps$G = {
  as: 'div',
  loading: false,
  account: false
};
var StakingAnalytics = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    bounty_data = _ref.bounty_data,
    card_data = _ref.card_data,
    handleClick = _ref.handleClick,
    loading = _ref.loading,
    Component = _ref.as,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'bounty-info-cards' : _ref$id,
    account = _ref.account;
  var Breakpoint = useBreakpoint();
  var button_text = Breakpoint > screens.sm ? 'Connect wallet' : 'Connect';
  return React.createElement("div", {
    className: "overflow-x-auto"
  }, React.createElement(Component, {
    className: "grid grid-cols-3 gap-5 min-w-max " + className,
    ref: ref,
    id: id
  }, React.createElement("div", null, React.createElement(Typography, {
    className: "mb-4",
    size: "md",
    allBold: true
  }, "Compound bounty"), React.createElement(Card, {
    className: "bg-gradient-level-one-to-accent h-40 p-5 w-[320px] md:w-[380px]"
  }, React.createElement("div", {
    className: "w-full md:space-y-7 space-y-3.5 items-center"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, bounty_data.text), React.createElement("div", {
    className: "flex items-center justify-between"
  }, Breakpoint > screens.md ? React.createElement(DataLines, {
    top_size: "2xl",
    is_top_bold: true,
    label: bounty_data.label,
    values: bounty_data.values,
    variant: "verticle"
  }) : React.createElement("div", null, React.createElement(Typography, {
    key: bounty_data.values[0].value,
    allBold: true,
    size: "md"
  }, bounty_data.values[0].value), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, bounty_data.label)), React.createElement(Button, {
    loading: loading,
    onClick: handleClick,
    className: "float-right min-w-[130px]"
  }, account ? 'Claim bounty' : button_text))))), card_data.map(function (card, idx) {
    return React.createElement("div", {
      key: idx
    }, React.createElement(Typography, {
      className: "mb-4",
      size: "md",
      allBold: true
    }, idx === 1 ? 'My account' : 'Platform'), React.createElement(Card, {
      className: "h-40 w-[320px] p-5 md:w-[380px] flex items-center",
      key: card[0].label + idx,
      surface: "one"
    }, React.createElement("div", {
      className: "md:space-y-5  space-y-3.5"
    }, card.map(function (_ref2, idx) {
      var label = _ref2.label,
        values = _ref2.values;
      return React.createElement(DataLines, {
        key: idx + label,
        top_size: "2xl",
        is_top_bold: true,
        label: label.toUpperCase(),
        values: values,
        variant: "verticle"
      });
    }))));
  })));
});
StakingAnalytics.displayName = 'StakingAnalytics';
StakingAnalytics.defaultProps = defaultProps$G;

var _excluded$e = ["items", "className"];
var MainCard = function MainCard(_ref) {
  var button_text = _ref.button_text,
    handleClick = _ref.handleClick,
    image = _ref.image,
    subtitle = _ref.subtitle,
    title = _ref.title,
    mobile_image = _ref.mobile_image;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  var _useState = useState(''),
    background = _useState[0],
    setBackground = _useState[1];
  useEffect(function () {
    setBackground((is_mobile ? 'linear-gradient(360deg, rgba(17, 6, 34, 0.4) 0%, rgba(17, 6, 34, 0) 70.49%)' : 'linear-gradient(90deg, rgba(17, 6, 34, 0.4) 0%, rgba(17, 6, 34, 0) 50%)') + ", url('" + (is_mobile && mobile_image ? mobile_image : image) + "')");
  }, [is_mobile, image, mobile_image]);
  return React.createElement("div", {
    className: "w-[300px] h-[460px] sm:w-full sm:h-full sm:cursor-pointer relative bg-surface-level-one rounded-lg",
    onClick: !is_mobile ? handleClick : undefined
  }, React.createElement("div", {
    key: background,
    style: {
      backgroundImage: background
    },
    className: "w-full h-full object-cover rounded-lg bg-cover bg-center transition-all ease-out duration-500"
  }), React.createElement("div", {
    className: "absolute bottom-8 left-8 right-8 max-w-[320px]"
  }, React.createElement(Typography, {
    allBold: true,
    size: is_mobile ? '2xl' : '3xl',
    className: "mb-2"
  }, title), React.createElement(Typography, {
    className: "sm:mb-5"
  }, subtitle), React.createElement(Button, {
    className: "hidden sm:inline",
    onClick: handleClick
  }, button_text)));
};
var Thumbnail = function Thumbnail(_ref2) {
  var image = _ref2.image,
    subtitle = _ref2.subtitle,
    title = _ref2.title,
    id = _ref2.id,
    current = _ref2.current,
    handleClick = _ref2.handleClick;
  var _useState2 = useState('w-0'),
    className = _useState2[0],
    setClassName = _useState2[1];
  var init = useIntitialised();
  useEffect(function () {
    if (!init) return;
    if (current === id) {
      setClassName('w-full ease-in duration-[9000ms]');
    } else {
      setClassName('w-0 ease-out duration-[0ms]');
    }
  }, [current, id, init]);
  return React.createElement("div", {
    "data-testid": "carousel-thumbnail",
    className: "relative rounded-lg overflow-hidden object-cover bg-cover bg-center cursor-pointer",
    onClick: handleClick,
    style: {
      backgroundImage: "linear-gradient(360deg, rgba(17, 6, 34, 0.4) 0%, rgba(17, 6, 34, 0) 71.52%), url('" + image + "')"
    }
  }, React.createElement("img", {
    src: image,
    alt: subtitle,
    className: "rounded-t-lg pointer-events-none opacity-0"
  }), React.createElement("div", {
    className: "absolute bottom-5 left-5 max-w-[60%]"
  }, React.createElement(Typography, {
    allBold: true
  }, title)), React.createElement("div", {
    className: "h-1 relative w-[full] rounded-b-lg overflow-hidden"
  }, React.createElement("div", {
    className: "w-full h-full bg-surface-level-two absolute"
  }), React.createElement("div", {
    id: "bar",
    className: "\"transition-all h-full bg-accent relative " + className
  })));
};
var CarouselContainer = function CarouselContainer(_ref3) {
  var items = _ref3.items,
    className = _ref3.className,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$e);
  var _useState3 = useState(0),
    current = _useState3[0],
    setCurrent = _useState3[1];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  var handleNext = useCallback(function () {
    return setCurrent((current + 1) % items.length);
  }, [current, items.length, setCurrent]);
  useEffect(function () {
    if (is_mobile) return;
    var handler = setTimeout(handleNext, 9000);
    return function () {
      return clearTimeout(handler);
    };
  }, [handleNext, is_mobile]);
  return React.createElement("div", Object.assign({
    className: "sm:grid sm:grid-cols-4 gap-5 overflow-x-scroll sm:overflow-x-auto " + className
  }, rest), React.createElement("div", {
    className: "hidden sm:inline col-span-3",
    "data-testid": "carousel-main-card"
  }, React.createElement(MainCard, Object.assign({}, items[current]))), React.createElement("div", {
    className: "hidden sm:inline h-full space-y-5"
  }, items.map(function (i, idx) {
    return React.createElement(Thumbnail, Object.assign({}, i, {
      id: idx,
      current: current,
      handleNext: handleNext,
      handleClick: function handleClick() {
        return setCurrent(idx);
      },
      key: JSON.stringify(i)
    }));
  })), React.createElement("div", {
    className: "flex gap-5 mb-8 sm:hidden min-w-max"
  }, items.map(function (i) {
    return React.createElement(MainCard, Object.assign({}, i, {
      key: JSON.stringify(i)
    }));
  })));
};
var Carousel = /*#__PURE__*/Object.assign(CarouselContainer, {
  MainCard: MainCard,
  Thumbnail: Thumbnail
});

var Header$1 = function Header(_ref) {
  var logo = _ref.logo,
    title = _ref.title,
    className = _ref.className;
  return React.createElement("div", {
    className: "text-center " + className
  }, logo && React.createElement("img", {
    src: logo,
    alt: "logo",
    className: "mx-auto h-[30px] mb-5"
  }), React.createElement(Typography, {
    allBold: true,
    as: "h1",
    size: "4xl"
  }, title));
};

var LoginStage;
(function (LoginStage) {
  LoginStage["Login"] = "login";
  LoginStage["MFA"] = "mfa";
})(LoginStage || (LoginStage = {}));
var defaultProps$H = {
  disabled: false,
  image: '',
  loading: false,
  noTitle: false,
  logo: ''
};
var LoginForm = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    errors = _ref.errors,
    image = _ref.image,
    loading = _ref.loading,
    logo = _ref.logo,
    noTitle = _ref.noTitle,
    state = _ref.state,
    handleChange = _ref.handleChange,
    handleClick = _ref.handleClick,
    handleCreateAccount = _ref.handleCreateAccount,
    handleForgotPassword = _ref.handleForgotPassword;
  var _useState = useState(false),
    show_password = _useState[0],
    setShowPassword = _useState[1];
  return React.createElement("div", {
    className: "max-w-[580px] " + className
  }, state.stage === LoginStage.Login && React.createElement(Header$1, {
    title: !noTitle ? 'Log in' : '',
    className: "mb-[60px]",
    logo: logo
  }), React.createElement(Card, {
    className: "overflow-hidden",
    ref: ref
  }, image ? React.createElement("img", {
    className: "w-full",
    src: image,
    alt: "login-img"
  }) : null, React.createElement("div", {
    className: "" + (state.stage === LoginStage.Login ? 'p-5' : 'p-8')
  }, (errors == null ? void 0 : errors.form) && React.createElement("div", {
    className: "pb-8"
  }, React.createElement(Alert, {
    variant: "error"
  }, React.createElement("span", {
    className: "text-error"
  }, errors.form))), state.stage === LoginStage.Login && React.createElement(Input, {
    placeholder: "Enter email address",
    surface: "zero",
    id: "email",
    label: "Email",
    type: "email",
    value: state.email,
    onChange: function onChange(e) {
      return handleChange('email', e.target.value);
    }
  }), state.stage === LoginStage.Login && React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    id: "password",
    label: "Password",
    type: show_password ? 'text' : 'password',
    placeholder: "Enter password",
    value: state.password,
    onChange: function onChange(e) {
      return handleChange('password', e.target.value);
    }
  }), state.stage === LoginStage.Login && React.createElement("div", {
    className: "pt-5 pb-8 pl-5"
  }, React.createElement(Toggle, {
    label: "Show password",
    surface_level: "zero",
    active: show_password,
    onChange: function onChange() {
      return setShowPassword(!show_password);
    },
    variant: "checkbox"
  })), state.stage === LoginStage.MFA && React.createElement("div", {
    className: "w-full"
  }, React.createElement(Typography, {
    size: "4xl",
    as: "h1",
    allBold: true,
    className: "mb-8 text-center"
  }, "Two-factor authentication"), React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Enter two-factor authentication code from your authenticator app."), React.createElement(Input, {
    placeholder: "--- ---",
    surface: "zero",
    id: "code",
    type: "code",
    className: "mb-8",
    value: state.code,
    onChange: function onChange(e) {
      return handleChange('code', e.target.value);
    }
  })), React.createElement("div", {
    className: "flex flex-row-reverse"
  }, React.createElement(Button, {
    disabled: disabled,
    onClick: function onClick() {
      return handleClick();
    },
    className: "" + (state.stage === LoginStage.Login ? 'w-full' : 'w-[200px]'),
    loading: loading
  }, state.stage === LoginStage.Login ? 'Log in' : 'Verify code'), state.stage === LoginStage.MFA && React.createElement("button", {
    onClick: function onClick() {
      return handleChange('stage', LoginStage.Login);
    },
    className: "px-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Cancel"))))), state.stage === LoginStage.Login && React.createElement("div", {
    className: "flex justify-between mt-5"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleCreateAccount
  }, "Create account"), React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleForgotPassword
  }, "Forgot password?")));
});
LoginForm.displayName = 'LoginForm';
LoginForm.defaultProps = defaultProps$H;

var defaultProps$I = {
  progress: 0,
  loading: false,
  disabled: false
};
var Onboarding = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    loading = _ref.loading,
    progress = _ref.progress,
    roles = _ref.roles,
    state = _ref.state,
    handleChange = _ref.handleChange,
    handleContinue = _ref.handleContinue;
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var first_name = state.first_name,
      last_name = state.last_name,
      company_name = state.company_name,
      company_role = state.company_role;
    handleContinue({
      first_name: first_name,
      last_name: last_name,
      company_name: company_name,
      company_role: company_role
    });
  };
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "overflow-hidden max-w-[580px] " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    percent: progress,
    surface: "two",
    border: false,
    height: "h-4",
    rounded: false
  }), React.createElement("div", {
    className: "h-8 border-x border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: "px-8 pt-8 rounded-b-lg " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: "4xl",
    allBold: true
  }, "Welcome to Client portal"), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center"
  }, "Let\u2019s get you all set up to deploy and manage ", React.createElement("br", null), "your Decubate products."), React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(Input, {
    containerClasses: "pt-[32px]",
    surface: "zero",
    placeholder: "Enter first name",
    id: "first-name-input",
    label: "First name",
    type: "text",
    value: state.first_name,
    onChange: function onChange(e) {
      return handleChange('first_name', e.target.value);
    }
  }), React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    placeholder: "Enter last name",
    id: "last-name-input",
    label: "Last name",
    type: "text",
    value: state.last_name,
    onChange: function onChange(e) {
      return handleChange('last_name', e.target.value);
    }
  }), React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    placeholder: "Enter registered company name",
    id: "company-name-input",
    label: "Registered company name",
    type: "text",
    value: state.company_name,
    onChange: function onChange(e) {
      return handleChange('company_name', e.target.value);
    }
  }), React.createElement(Typography, {
    variant: "secondary",
    className: "mb-4 mt-5"
  }, "Your role in the company"), React.createElement("div", {
    className: "grid grid-cols-2 sm:grid-cols-4 gap-4"
  }, roles.map(function (role) {
    return React.createElement(Button, {
      key: role.split(' ').join('') + "-btn",
      id: role.split(' ').join('') + "-btn",
      onClick: function onClick() {
        handleChange('company_role', role);
      },
      variant: role === state.company_role ? 'light' : 'secondary'
    }, role);
  })), React.createElement("div", {
    className: "py-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    className: "w-full",
    type: "submit",
    loading: loading,
    disabled: disabled
  }, "Continue")))));
});
Onboarding.displayName = 'Onboarding';
Onboarding.defaultProps = defaultProps$I;

var countries = [
	{
		name_en: "Afghanistan",
		name_es: "Afganistán",
		dial_code: "+93",
		code: "AF"
	},
	{
		name_en: "Albania",
		name_es: "Albania",
		dial_code: "+355",
		code: "AL"
	},
	{
		name_en: "Algeria",
		name_es: "Argelia",
		dial_code: "+213",
		code: "DZ"
	},
	{
		name_en: "AmericanSamoa",
		name_es: "Samoa Americana",
		dial_code: "+1684",
		code: "AS"
	},
	{
		name_en: "Andorra",
		name_es: "Andorra",
		dial_code: "+376",
		code: "AD"
	},
	{
		name_en: "Angola",
		name_es: "Angola",
		dial_code: "+244",
		code: "AO"
	},
	{
		name_en: "Anguilla",
		name_es: "Anguilla",
		dial_code: "+1264",
		code: "AI"
	},
	{
		name_en: "Antarctica",
		name_es: "Antártida",
		dial_code: "+672",
		code: "AQ"
	},
	{
		name_en: "Antigua and Barbuda",
		name_es: "Antigua y Barbuda",
		dial_code: "+1268",
		code: "AG"
	},
	{
		name_en: "Argentina",
		name_es: "Argentina",
		dial_code: "+54",
		code: "AR"
	},
	{
		name_en: "Armenia",
		name_es: "Armenia",
		dial_code: "+374",
		code: "AM"
	},
	{
		name_en: "Aruba",
		name_es: "Aruba",
		dial_code: "+297",
		code: "AW"
	},
	{
		name_en: "Australia",
		name_es: "Australia",
		dial_code: "+61",
		code: "AU"
	},
	{
		name_en: "Austria",
		name_es: "Austria",
		dial_code: "+43",
		code: "AT"
	},
	{
		name_en: "Azerbaijan",
		name_es: "Azerbaiyán",
		dial_code: "+994",
		code: "AZ"
	},
	{
		name_en: "Bahamas",
		name_es: "Bahamas",
		dial_code: "+1242",
		code: "BS"
	},
	{
		name_en: "Bahrain",
		name_es: "Baréin",
		dial_code: "+973",
		code: "BH"
	},
	{
		name_en: "Bangladesh",
		name_es: "Banglades",
		dial_code: "+880",
		code: "BD"
	},
	{
		name_en: "Barbados",
		name_es: "Barbados",
		dial_code: "+1246",
		code: "BB"
	},
	{
		name_en: "Belarus",
		name_es: "Bielorrusia",
		dial_code: "+375",
		code: "BY"
	},
	{
		name_en: "Belgium",
		name_es: "Bélgica",
		dial_code: "+32",
		code: "BE"
	},
	{
		name_en: "Belize",
		name_es: "Belice",
		dial_code: "+501",
		code: "BZ"
	},
	{
		name_en: "Benin",
		name_es: "Benin",
		dial_code: "+229",
		code: "BJ"
	},
	{
		name_en: "Bermuda",
		name_es: "Bermudas",
		dial_code: "+1441",
		code: "BM"
	},
	{
		name_en: "Bhutan",
		name_es: "Butan",
		dial_code: "+975",
		code: "BT"
	},
	{
		name_en: "Bolivia",
		name_es: "Bolivia",
		dial_code: "+591",
		code: "BO"
	},
	{
		name_en: "Bosnia and Herzegovina",
		name_es: "Bosnia-Herzegovina",
		dial_code: "+387",
		code: "BA"
	},
	{
		name_en: "Botswana",
		name_es: "Botsuana",
		dial_code: "+267",
		code: "BW"
	},
	{
		name_en: "Brazil",
		name_es: "Brasil",
		dial_code: "+55",
		code: "BR"
	},
	{
		name_en: "British Indian Ocean Territory",
		name_es: "Territorio Británico del Océano Índico",
		dial_code: "+246",
		code: "IO"
	},
	{
		name_en: "Brunei Darussalam",
		name_es: "Brunei",
		dial_code: "+673",
		code: "BN"
	},
	{
		name_en: "Bulgaria",
		name_es: "Bulgaria",
		dial_code: "+359",
		code: "BG"
	},
	{
		name_en: "Burkina Faso",
		name_es: "Burkina Faso",
		dial_code: "+226",
		code: "BF"
	},
	{
		name_en: "Burundi",
		name_es: "Burundi",
		dial_code: "+257",
		code: "BI"
	},
	{
		name_en: "Cambodia",
		name_es: "Camboya",
		dial_code: "+855",
		code: "KH"
	},
	{
		name_en: "Cameroon",
		name_es: "Camerún",
		dial_code: "+237",
		code: "CM"
	},
	{
		name_en: "Canada",
		name_es: "Canadá",
		dial_code: "+1",
		code: "CA"
	},
	{
		name_en: "Cape Verde",
		name_es: "Cabo Verde",
		dial_code: "+238",
		code: "CV"
	},
	{
		name_en: "Cayman Islands",
		name_es: "Islas Caimán",
		dial_code: "+ 345",
		code: "KY"
	},
	{
		name_en: "Central African Republic",
		name_es: "República Centroafricana",
		dial_code: "+236",
		code: "CF"
	},
	{
		name_en: "Chad",
		name_es: "Chad",
		dial_code: "+235",
		code: "TD"
	},
	{
		name_en: "Chile",
		name_es: "Chile",
		dial_code: "+56",
		code: "CL"
	},
	{
		name_en: "China",
		name_es: "China",
		dial_code: "+86",
		code: "CN"
	},
	{
		name_en: "Christmas Island",
		name_es: "Isla de Navidad",
		dial_code: "+61",
		code: "CX"
	},
	{
		name_en: "Cocos (Keeling) Islands",
		name_es: "Islas Cocos",
		dial_code: "+61",
		code: "CC"
	},
	{
		name_en: "Colombia",
		name_es: "Colombia",
		dial_code: "+57",
		code: "CO"
	},
	{
		name_en: "Comoros",
		name_es: "Comoras",
		dial_code: "+269",
		code: "KM"
	},
	{
		name_en: "Congo",
		name_es: "Congo",
		dial_code: "+242",
		code: "CG"
	},
	{
		name_en: "Congo, The Democratic Republic of the",
		name_es: "República Democrática del Congo",
		dial_code: "+243",
		code: "CD"
	},
	{
		name_en: "Cook Islands",
		name_es: "Islas Cook",
		dial_code: "+682",
		code: "CK"
	},
	{
		name_en: "Costa Rica",
		name_es: "Costa Rica",
		dial_code: "+506",
		code: "CR"
	},
	{
		name_en: "Cote d'Ivoire",
		name_es: "Costa de Marfil",
		dial_code: "+225",
		code: "CI"
	},
	{
		name_en: "Croatia",
		name_es: "Croacia",
		dial_code: "+385",
		code: "HR"
	},
	{
		name_en: "Cuba",
		name_es: "Cuba",
		dial_code: "+53",
		code: "CU"
	},
	{
		name_en: "Cyprus",
		name_es: "Chipre",
		dial_code: "+537",
		code: "CY"
	},
	{
		name_en: "Czechia",
		name_es: "Chequia",
		dial_code: "+420",
		code: "CZ"
	},
	{
		name_en: "Denmark",
		name_es: "Dinamarca",
		dial_code: "+45",
		code: "DK"
	},
	{
		name_en: "Djibouti",
		name_es: "Yibuti",
		dial_code: "+253",
		code: "DJ"
	},
	{
		name_en: "Dominica",
		name_es: "Dominica",
		dial_code: "+1767",
		code: "DM"
	},
	{
		name_en: "Dominican Republic",
		name_es: "República Dominicana",
		dial_code: "+1849",
		code: "DO"
	},
	{
		name_en: "Ecuador",
		name_es: "Ecuador",
		dial_code: "+593",
		code: "EC"
	},
	{
		name_en: "Egypt",
		name_es: "Egipto",
		dial_code: "+20",
		code: "EG"
	},
	{
		name_en: "El Salvador",
		name_es: "El Salvador",
		dial_code: "+503",
		code: "SV"
	},
	{
		name_en: "Equatorial Guinea",
		name_es: "Guinea Ecuatorial",
		dial_code: "+240",
		code: "GQ"
	},
	{
		name_en: "Eritrea",
		name_es: "Eritrea",
		dial_code: "+291",
		code: "ER"
	},
	{
		name_en: "Estonia",
		name_es: "Estonia",
		dial_code: "+372",
		code: "EE"
	},
	{
		name_en: "Ethiopia",
		name_es: "Etiopía",
		dial_code: "+251",
		code: "ET"
	},
	{
		name_en: "Falkland Islands (Malvinas)",
		name_es: "Islas Malvinas",
		dial_code: "+500",
		code: "FK"
	},
	{
		name_en: "Faroe Islands",
		name_es: "Islas Feroe",
		dial_code: "+298",
		code: "FO"
	},
	{
		name_en: "Fiji",
		name_es: "Fiyi",
		dial_code: "+679",
		code: "FJ"
	},
	{
		name_en: "Finland",
		name_es: "Finlandia",
		dial_code: "+358",
		code: "FI"
	},
	{
		name_en: "France",
		name_es: "Francia",
		dial_code: "+33",
		code: "FR"
	},
	{
		name_en: "French Guiana",
		name_es: "Guayana Francesa",
		dial_code: "+594",
		code: "GF"
	},
	{
		name_en: "French Polynesia",
		name_es: "Polinesia Francesa",
		dial_code: "+689",
		code: "PF"
	},
	{
		name_en: "Gabon",
		name_es: "Gabón",
		dial_code: "+241",
		code: "GA"
	},
	{
		name_en: "Gambia",
		name_es: "Gambia",
		dial_code: "+220",
		code: "GM"
	},
	{
		name_en: "Georgia",
		name_es: "Georgia",
		dial_code: "+995",
		code: "GE"
	},
	{
		name_en: "Germany",
		name_es: "Alemania",
		dial_code: "+49",
		code: "DE"
	},
	{
		name_en: "Ghana",
		name_es: "Ghana",
		dial_code: "+233",
		code: "GH"
	},
	{
		name_en: "Gibraltar",
		name_es: "Gibraltar",
		dial_code: "+350",
		code: "GI"
	},
	{
		name_en: "Greece",
		name_es: "Grecia",
		dial_code: "+30",
		code: "GR"
	},
	{
		name_en: "Greenland",
		name_es: "Groenlandia",
		dial_code: "+299",
		code: "GL"
	},
	{
		name_en: "Grenada",
		name_es: "Granada",
		dial_code: "+1473",
		code: "GD"
	},
	{
		name_en: "Guadeloupe",
		name_es: "Guadalupe",
		dial_code: "+590",
		code: "GP"
	},
	{
		name_en: "Guam",
		name_es: "Guam",
		dial_code: "+1671",
		code: "GU"
	},
	{
		name_en: "Guatemala",
		name_es: "Guatemala",
		dial_code: "+502",
		code: "GT"
	},
	{
		name_en: "Guernsey",
		name_es: "Guernsey",
		dial_code: "+44",
		code: "GG"
	},
	{
		name_en: "Guinea",
		name_es: "Guinea",
		dial_code: "+224",
		code: "GN"
	},
	{
		name_en: "Guinea-Bissau",
		name_es: "Guinea-Bisau",
		dial_code: "+245",
		code: "GW"
	},
	{
		name_en: "Guyana",
		name_es: "Guyana",
		dial_code: "+595",
		code: "GY"
	},
	{
		name_en: "Haiti",
		name_es: "Haití",
		dial_code: "+509",
		code: "HT"
	},
	{
		name_en: "Holy See (Vatican City State)",
		name_es: "Ciudad del Vaticano",
		dial_code: "+379",
		code: "VA"
	},
	{
		name_en: "Honduras",
		name_es: "Honduras",
		dial_code: "+504",
		code: "HN"
	},
	{
		name_en: "Hong Kong",
		name_es: "Hong Kong",
		dial_code: "+852",
		code: "HK"
	},
	{
		name_en: "Hungary",
		name_es: "Hungría",
		dial_code: "+36",
		code: "HU"
	},
	{
		name_en: "Iceland",
		name_es: "Islandia",
		dial_code: "+354",
		code: "IS"
	},
	{
		name_en: "India",
		name_es: "India",
		dial_code: "+91",
		code: "IN"
	},
	{
		name_en: "Indonesia",
		name_es: "Indonesia",
		dial_code: "+62",
		code: "ID"
	},
	{
		name_en: "Iran, Islamic Republic of",
		name_es: "Irán",
		dial_code: "+98",
		code: "IR"
	},
	{
		name_en: "Iraq",
		name_es: "Iraq",
		dial_code: "+964",
		code: "IQ"
	},
	{
		name_en: "Ireland",
		name_es: "Irlanda",
		dial_code: "+353",
		code: "IE"
	},
	{
		name_en: "Isle of Man",
		name_es: "Isla de Man",
		dial_code: "+44",
		code: "IM"
	},
	{
		name_en: "Israel",
		name_es: "Israel",
		dial_code: "+972",
		code: "IL"
	},
	{
		name_en: "Italy",
		name_es: "Italia",
		dial_code: "+39",
		code: "IT"
	},
	{
		name_en: "Jamaica",
		name_es: "Jamaica",
		dial_code: "+1876",
		code: "JM"
	},
	{
		name_en: "Japan",
		name_es: "Japón",
		dial_code: "+81",
		code: "JP"
	},
	{
		name_en: "Jersey",
		name_es: "Jersey",
		dial_code: "+44",
		code: "JE"
	},
	{
		name_en: "Jordan",
		name_es: "Jordania",
		dial_code: "+962",
		code: "JO"
	},
	{
		name_en: "Kazakhstan",
		name_es: "Kazajistán",
		dial_code: "+7",
		code: "KZ"
	},
	{
		name_en: "Kenya",
		name_es: "Kenia",
		dial_code: "+254",
		code: "KE"
	},
	{
		name_en: "Kiribati",
		name_es: "Kiribati",
		dial_code: "+686",
		code: "KI"
	},
	{
		name_en: "Korea, Democratic People's Republic of",
		name_es: "Corea del Norte",
		dial_code: "+850",
		code: "KP"
	},
	{
		name_en: "Korea, Republic of",
		name_es: "Corea del Sur",
		dial_code: "+82",
		code: "KR"
	},
	{
		name_en: "Kosovo",
		name_es: "Kosovo",
		dial_code: "+383",
		code: "XK"
	},
	{
		name_en: "Kuwait",
		name_es: "Kuwait",
		dial_code: "+965",
		code: "KW"
	},
	{
		name_en: "Kyrgyzstan",
		name_es: "Kirguistán",
		dial_code: "+996",
		code: "KG"
	},
	{
		name_en: "Lao People's Democratic Republic",
		name_es: "Laos",
		dial_code: "+856",
		code: "LA"
	},
	{
		name_en: "Latvia",
		name_es: "Letonia",
		dial_code: "+371",
		code: "LV"
	},
	{
		name_en: "Lebanon",
		name_es: "Líbano",
		dial_code: "+961",
		code: "LB"
	},
	{
		name_en: "Lesotho",
		name_es: "Lesoto",
		dial_code: "+266",
		code: "LS"
	},
	{
		name_en: "Liberia",
		name_es: "Liberia",
		dial_code: "+231",
		code: "LR"
	},
	{
		name_en: "Libyan Arab Jamahiriya",
		name_es: "Libia",
		dial_code: "+218",
		code: "LY"
	},
	{
		name_en: "Liechtenstein",
		name_es: "Liechtenstein",
		dial_code: "+423",
		code: "LI"
	},
	{
		name_en: "Lithuania",
		name_es: "Lituania",
		dial_code: "+370",
		code: "LT"
	},
	{
		name_en: "Luxembourg",
		name_es: "Luxemburgo",
		dial_code: "+352",
		code: "LU"
	},
	{
		name_en: "Macao",
		name_es: "Macao",
		dial_code: "+853",
		code: "MO"
	},
	{
		name_en: "Macedonia, The Former Yugoslav Republic of",
		name_es: "República de Macedonia",
		dial_code: "+389",
		code: "MK"
	},
	{
		name_en: "Madagascar",
		name_es: "Madagascar",
		dial_code: "+261",
		code: "MG"
	},
	{
		name_en: "Malawi",
		name_es: "Malaui",
		dial_code: "+265",
		code: "MW"
	},
	{
		name_en: "Malaysia",
		name_es: "Malasia",
		dial_code: "+60",
		code: "MY"
	},
	{
		name_en: "Maldives",
		name_es: "Maldivas",
		dial_code: "+960",
		code: "MV"
	},
	{
		name_en: "Mali",
		name_es: "Malí",
		dial_code: "+223",
		code: "ML"
	},
	{
		name_en: "Malta",
		name_es: "Malta",
		dial_code: "+356",
		code: "MT"
	},
	{
		name_en: "Marshall Islands",
		name_es: "Islas Marshall",
		dial_code: "+692",
		code: "MH"
	},
	{
		name_en: "Martinique",
		name_es: "Martinica",
		dial_code: "+596",
		code: "MQ"
	},
	{
		name_en: "Mauritania",
		name_es: "Mauritania",
		dial_code: "+222",
		code: "MR"
	},
	{
		name_en: "Mauritius",
		name_es: "Mauricio",
		dial_code: "+230",
		code: "MU"
	},
	{
		name_en: "Mayotte",
		name_es: "Mayotte",
		dial_code: "+262",
		code: "YT"
	},
	{
		name_en: "Mexico",
		name_es: "México",
		dial_code: "+52",
		code: "MX"
	},
	{
		name_en: "Micronesia, Federated States of",
		name_es: "Estados Federados de Micronesia",
		dial_code: "+691",
		code: "FM"
	},
	{
		name_en: "Moldova, Republic of",
		name_es: "Moldavia",
		dial_code: "+373",
		code: "MD"
	},
	{
		name_en: "Monaco",
		name_es: "Monaco",
		dial_code: "+377",
		code: "MC"
	},
	{
		name_en: "Mongolia",
		name_es: "Mongolia",
		dial_code: "+976",
		code: "MN"
	},
	{
		name_en: "Montenegro",
		name_es: "Montenegro",
		dial_code: "+382",
		code: "ME"
	},
	{
		name_en: "Montserrat",
		name_es: "Montserrat",
		dial_code: "+1664",
		code: "MS"
	},
	{
		name_en: "Morocco",
		name_es: "Marruecos",
		dial_code: "+212",
		code: "MA"
	},
	{
		name_en: "Mozambique",
		name_es: "Mozambique",
		dial_code: "+258",
		code: "MZ"
	},
	{
		name_en: "Myanmar",
		name_es: "Birmania",
		dial_code: "+95",
		code: "MM"
	},
	{
		name_en: "Namibia",
		name_es: "Namibia",
		dial_code: "+264",
		code: "NA"
	},
	{
		name_en: "Nauru",
		name_es: "Nauru",
		dial_code: "+674",
		code: "NR"
	},
	{
		name_en: "Nepal",
		name_es: "Nepal",
		dial_code: "+977",
		code: "NP"
	},
	{
		name_en: "Netherlands",
		name_es: "Holanda",
		dial_code: "+31",
		code: "NL"
	},
	{
		name_en: "Netherlands Antilles",
		name_es: "Antillas Holandesas",
		dial_code: "+599",
		code: "AN"
	},
	{
		name_en: "New Caledonia",
		name_es: "Nueva Caledonia",
		dial_code: "+687",
		code: "NC"
	},
	{
		name_en: "New Zealand",
		name_es: "Nueva Zelanda",
		dial_code: "+64",
		code: "NZ"
	},
	{
		name_en: "Nicaragua",
		name_es: "Nicaragua",
		dial_code: "+505",
		code: "NI"
	},
	{
		name_en: "Niger",
		name_es: "Niger",
		dial_code: "+227",
		code: "NE"
	},
	{
		name_en: "Nigeria",
		name_es: "Nigeria",
		dial_code: "+234",
		code: "NG"
	},
	{
		name_en: "Niue",
		name_es: "Niue",
		dial_code: "+683",
		code: "NU"
	},
	{
		name_en: "NorfolkIsland",
		name_es: "IslaNorfolk",
		dial_code: "+672",
		code: "NF"
	},
	{
		name_en: "NorthernMarianaIslands",
		name_es: "IslasMarianasdelNorte",
		dial_code: "+1670",
		code: "MP"
	},
	{
		name_en: "Norway",
		name_es: "Noruega",
		dial_code: "+47",
		code: "NO"
	},
	{
		name_en: "Oman",
		name_es: "Omán",
		dial_code: "+968",
		code: "OM"
	},
	{
		name_en: "Pakistan",
		name_es: "Pakistán",
		dial_code: "+92",
		code: "PK"
	},
	{
		name_en: "Palau",
		name_es: "Palaos",
		dial_code: "+680",
		code: "PW"
	},
	{
		name_en: "Panama",
		name_es: "Panamá",
		dial_code: "+507",
		code: "PA"
	},
	{
		name_en: "Papua New Guinea",
		name_es: "Papúa Nueva Guinea",
		dial_code: "+675",
		code: "PG"
	},
	{
		name_en: "Paraguay",
		name_es: "Paraguay",
		dial_code: "+595",
		code: "PY"
	},
	{
		name_en: "Peru",
		name_es: "Perú",
		dial_code: "+51",
		code: "PE"
	},
	{
		name_en: "Philippines",
		name_es: "Filipinas",
		dial_code: "+63",
		code: "PH"
	},
	{
		name_en: "Pitcairn",
		name_es: "Islas Pitcairn",
		dial_code: "+872",
		code: "PN"
	},
	{
		name_en: "Poland",
		name_es: "Polonia",
		dial_code: "+48",
		code: "PL"
	},
	{
		name_en: "Portugal",
		name_es: "Portugal",
		dial_code: "+351",
		code: "PT"
	},
	{
		name_en: "Puerto Rico",
		name_es: "Puerto Rico",
		dial_code: "+1939",
		code: "PR"
	},
	{
		name_en: "Qatar",
		name_es: "Qatar",
		dial_code: "+974",
		code: "QA"
	},
	{
		name_en: "Romania",
		name_es: "Rumania",
		dial_code: "+40",
		code: "RO"
	},
	{
		name_en: "Russia",
		name_es: "Rusia",
		dial_code: "+7",
		code: "RU"
	},
	{
		name_en: "Rwanda",
		name_es: "Ruanda",
		dial_code: "+250",
		code: "RW"
	},
	{
		name_en: "Réunion",
		name_es: "Reunion",
		dial_code: "+262",
		code: "RE"
	},
	{
		name_en: "Saint Barthélemy",
		name_es: "San Bartolome",
		dial_code: "+590",
		code: "BL"
	},
	{
		name_en: "Saint Helena, Ascension and Tristan Da Cunha",
		name_es: "Santa Elena, Ascensión y Tristán de Acuña",
		dial_code: "+290",
		code: "SH"
	},
	{
		name_en: "Saint Kitts and Nevis",
		name_es: "San Cristóbal y Nieves",
		dial_code: "+1869",
		code: "KN"
	},
	{
		name_en: "Saint Lucia",
		name_es: "Santa Lucía",
		dial_code: "+1758",
		code: "LC"
	},
	{
		name_en: "Saint Martin",
		name_es: "Isla de San Martín",
		dial_code: "+590",
		code: "MF"
	},
	{
		name_en: "Saint Pierre and Miquelon",
		name_es: "San Pedro y Miquelon",
		dial_code: "+508",
		code: "PM"
	},
	{
		name_en: "Saint Vincent and the Grenadines",
		name_es: "San Vicente y las Granadinas",
		dial_code: "+1784",
		code: "VC"
	},
	{
		name_en: "Samoa",
		name_es: "Samoa",
		dial_code: "+685",
		code: "WS"
	},
	{
		name_en: "San Marino",
		name_es: "San Marino",
		dial_code: "+378",
		code: "SM"
	},
	{
		name_en: "Sao Tome and Principe",
		name_es: " Santo Tomé y Príncipe",
		dial_code: "+239",
		code: "ST"
	},
	{
		name_en: "Saudi Arabia",
		name_es: "Arabia Saudita",
		dial_code: "+966",
		code: "SA"
	},
	{
		name_en: "Senegal",
		name_es: "Senegal",
		dial_code: "+221",
		code: "SN"
	},
	{
		name_en: "Serbia",
		name_es: "Serbia",
		dial_code: "+381",
		code: "RS"
	},
	{
		name_en: "Seychelles",
		name_es: "Seychelles",
		dial_code: "+248",
		code: "SC"
	},
	{
		name_en: "Sierra Leone",
		name_es: "Sierra Leona",
		dial_code: "+232",
		code: "SL"
	},
	{
		name_en: "Singapore",
		name_es: "Singapur",
		dial_code: "+65",
		code: "SG"
	},
	{
		name_en: "Slovakia",
		name_es: "Eslovaquia",
		dial_code: "+421",
		code: "SK"
	},
	{
		name_en: "Slovenia",
		name_es: "Eslovenia",
		dial_code: "+386",
		code: "SI"
	},
	{
		name_en: "Solomon Islands",
		name_es: "Islas Salomón",
		dial_code: "+677",
		code: "SB"
	},
	{
		name_en: "Somalia",
		name_es: "Somalia",
		dial_code: "+252",
		code: "SO"
	},
	{
		name_en: "South Africa",
		name_es: "Sudáfrica",
		dial_code: "+27",
		code: "ZA"
	},
	{
		name_en: "South Sudan",
		name_es: "Sudán del Sur",
		dial_code: "+211",
		code: "SS"
	},
	{
		name_en: "Spain",
		name_es: "España",
		dial_code: "+34",
		code: "ES"
	},
	{
		name_en: "Sri Lanka",
		name_es: "Sri Lanka",
		dial_code: "+94",
		code: "LK"
	},
	{
		name_en: "State of Palestine",
		name_es: "Estado de Palestina",
		dial_code: "+970",
		code: "PS"
	},
	{
		name_en: "Sudan",
		name_es: "Sudán",
		dial_code: "+249",
		code: "SD"
	},
	{
		name_en: "Suriname",
		name_es: "Surinam",
		dial_code: "+597",
		code: "SR"
	},
	{
		name_en: "Svalbard and Jan Mayen",
		name_es: "Svalbard y Jan Mayen",
		dial_code: "+47",
		code: "SJ"
	},
	{
		name_en: "Swaziland",
		name_es: "Suazilandia",
		dial_code: "+268",
		code: "SZ"
	},
	{
		name_en: "Sweden",
		name_es: "Suecia",
		dial_code: "+46",
		code: "SE"
	},
	{
		name_en: "Switzerland",
		name_es: "Suiza",
		dial_code: "+41",
		code: "CH"
	},
	{
		name_en: "Syrian Arab Republic",
		name_es: "Siria",
		dial_code: "+963",
		code: "SY"
	},
	{
		name_en: "Taiwan, Province of China",
		name_es: "Taiwán",
		dial_code: "+886",
		code: "TW"
	},
	{
		name_en: "Tayikistan",
		name_es: "Tayikistán",
		dial_code: "+992",
		code: "TJ"
	},
	{
		name_en: "Tanzania, United Republic of",
		name_es: "Tanzania",
		dial_code: "+255",
		code: "TZ"
	},
	{
		name_en: "Thailand",
		name_es: "Tailandia",
		dial_code: "+66",
		code: "TH"
	},
	{
		name_en: "Timor-Leste",
		name_es: "Timor Oriental",
		dial_code: "+670",
		code: "TL"
	},
	{
		name_en: "Togo",
		name_es: "Togo",
		dial_code: "+228",
		code: "TG"
	},
	{
		name_en: "Tokelau",
		name_es: "Tokelau",
		dial_code: "+690",
		code: "TK"
	},
	{
		name_en: "Tonga",
		name_es: "Tonga",
		dial_code: "+676",
		code: "TO"
	},
	{
		name_en: "Trinidad and Tobago",
		name_es: "Trinidad y Tobago",
		dial_code: "+1868",
		code: "TT"
	},
	{
		name_en: "Tunisia",
		name_es: "Túnez",
		dial_code: "+216",
		code: "TN"
	},
	{
		name_en: "Turkey",
		name_es: "Turquía",
		dial_code: "+90",
		code: "TR"
	},
	{
		name_en: "Turkmenistan",
		name_es: "Turkmenistán",
		dial_code: "+993",
		code: "TM"
	},
	{
		name_en: "Turks and Caicos Islands",
		name_es: "Islas Turcas y Caicos",
		dial_code: "+1649",
		code: "TC"
	},
	{
		name_en: "Tuvalu",
		name_es: "Tuvalu",
		dial_code: "+688",
		code: "TV"
	},
	{
		name_en: "Uganda",
		name_es: "Uganda",
		dial_code: "+256",
		code: "UG"
	},
	{
		name_en: "Ukraine",
		name_es: "Ucrania",
		dial_code: "+380",
		code: "UA"
	},
	{
		name_en: "United Arab Emirates",
		name_es: "Emiratos Árabes Unidos",
		dial_code: "+971",
		code: "AE"
	},
	{
		name_en: "United Kingdom",
		name_es: "Reino Unido",
		dial_code: "+44",
		code: "GB"
	},
	{
		name_en: "United States",
		name_es: "Estados Unidos",
		dial_code: "+1",
		code: "US"
	},
	{
		name_en: "Uruguay",
		name_es: "Uruguay",
		dial_code: "+598",
		code: "UY"
	},
	{
		name_en: "Uzbekistan",
		name_es: "Uzbekistán",
		dial_code: "+998",
		code: "UZ"
	},
	{
		name_en: "Vanuatu",
		name_es: "Vanuatu",
		dial_code: "+678",
		code: "VU"
	},
	{
		name_en: "Venezuela, Bolivarian Republic of",
		name_es: "Venezuela",
		dial_code: "+58",
		code: "VE"
	},
	{
		name_en: "Vietnam",
		name_es: "Vietnam",
		dial_code: "+84",
		code: "VN"
	},
	{
		name_en: "Virgin Islands, British",
		name_es: "Islas Vírgenes Británicas",
		dial_code: "+1284",
		code: "VG"
	},
	{
		name_en: "Virgin Islands, U.S.",
		name_es: "Islas Vírgenes de los Estados Unidos",
		dial_code: "+1340",
		code: "VI"
	},
	{
		name_en: "Wallis and Futuna",
		name_es: "Wallis y Futuna",
		dial_code: "+681",
		code: "WF"
	},
	{
		name_en: "Yemen",
		name_es: "Yemen",
		dial_code: "+967",
		code: "YE"
	},
	{
		name_en: "Zambia",
		name_es: "Zambia",
		dial_code: "+260",
		code: "ZM"
	},
	{
		name_en: "Zimbabwe",
		name_es: "Zimbabue",
		dial_code: "+263",
		code: "ZW"
	},
	{
		name_en: "Åland Islands",
		name_es: "Åland",
		dial_code: "+358",
		code: "AX"
	}
];
var data = {
	countries: countries
};

var defaultProps$J = {
  loading: false,
  logo: '',
  policy: '',
  terms: ''
};
var options = /*#__PURE__*/data.countries.map(function (_ref) {
  var name_en = _ref.name_en,
    code = _ref.code;
  return {
    label: name_en,
    id: code
  };
});
var RegisterForm = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    disabled = _ref2.disabled,
    state = _ref2.state,
    loading = _ref2.loading,
    logo = _ref2.logo,
    errors = _ref2.errors,
    policy = _ref2.policy,
    terms = _ref2.terms,
    handleLoginClick = _ref2.handleLoginClick,
    handleRegister = _ref2.handleRegister,
    handleChange = _ref2.handleChange;
  var _useState = useState(false),
    showPassword = _useState[0],
    setShowPassword = _useState[1];
  var _useState2 = useState({
      email: false,
      password: false
    }),
    initialized = _useState2[0],
    setInitialized = _useState2[1];
  var breakpoint = useBreakpoint();
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var email = state.email,
      password = state.password,
      country = state.country,
      acceptTerms = state.acceptTerms;
    handleRegister({
      email: email,
      password: password,
      country: country,
      acceptTerms: acceptTerms
    });
  };
  return React.createElement("div", {
    className: "max-w-[580px] " + className
  }, React.createElement(Header$1, {
    className: "mb-[60px]",
    title: "Create account",
    logo: logo
  }), React.createElement(Card, {
    className: "p-5",
    ref: ref
  }, (errors == null ? void 0 : errors.form) && React.createElement("div", {
    className: "pb-8"
  }, React.createElement(Alert, {
    variant: "error"
  }, React.createElement("span", {
    className: "text-error"
  }, errors.form))), React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(Input, {
    id: "email",
    error: errors == null ? void 0 : errors.email,
    label: "Email",
    placeholder: "Enter your email address",
    surface: "zero",
    type: "email",
    is_initialized: initialized.email,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        email: true
      }));
    },
    value: state.email,
    onChange: function onChange(event) {
      return handleChange(event.target.id, event.target.value);
    }
  }), React.createElement(Input, {
    id: "password",
    helper_box_text: React.createElement("span", {
      className: "space-y-2"
    }, ['At least 8 characters', 'Upper & lowercase letters', 'At least 2 numbers', 'At least 1 symbol'].map(function (s) {
      return React.createElement(Typography, {
        key: s,
        size: "xs",
        variant: "secondary"
      }, s);
    })),
    containerClasses: "pt-5",
    error: errors == null ? void 0 : errors.password,
    label: "Password",
    placeholder: "Create new password",
    surface: "zero",
    is_initialized: initialized.password,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        password: true
      }));
    },
    type: showPassword ? 'text' : 'password',
    value: state.password,
    onChange: function onChange(event) {
      return handleChange(event.target.id, event.target.value);
    }
  }), React.createElement("div", {
    className: "pt-5 pl-5"
  }, React.createElement(Toggle, {
    id: "show-password",
    label: "Show password",
    surface_level: "zero",
    active: showPassword,
    onChange: function onChange() {
      return setShowPassword(!showPassword);
    },
    variant: "checkbox"
  })), React.createElement(Select, {
    id: "country",
    className: "pt-5",
    current: state.country,
    options: options,
    label: "Country of residence",
    placeholder: "Select your country of residence",
    setCurrent: function setCurrent(option) {
      handleChange('country', option);
    }
  }), React.createElement(Card, {
    id: "toggle-card",
    surface: "two",
    className: "mt-8 mb-5 " + (breakpoint > 505 ? 'px-5 py-[10px]' : 'p-5')
  }, React.createElement(Toggle, {
    id: "accept-terms",
    active: state.acceptTerms || false,
    onChange: function onChange() {
      return handleChange('acceptTerms', !state.acceptTerms);
    },
    label: React.createElement(React.Fragment, null, "I have read and accept the", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      href: terms,
      rel: "noreferrer",
      target: "_blank"
    }, "terms & conditions"), ' ', "and", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      href: policy,
      rel: "noreferrer",
      target: "_blank"
    }, "privacy policy"), "."),
    variant: "checkbox"
  })), React.createElement(Button, {
    fullwidth: true,
    id: "register-button",
    disabled: disabled,
    loading: loading,
    type: "submit"
  }, "Create account"))), React.createElement("div", {
    className: "flex justify-center space-x-2 mt-5"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Already have an account?"), React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleLoginClick
  }, "Log in")));
});
RegisterForm.displayName = 'RegisterForm';
RegisterForm.defaultProps = defaultProps$J;

var ResetPasswordStage;
(function (ResetPasswordStage) {
  ResetPasswordStage["Email"] = "email";
  ResetPasswordStage["Password"] = "password";
})(ResetPasswordStage || (ResetPasswordStage = {}));
var defaultProps$K = {
  errors: undefined,
  helper_text: undefined,
  loading: false,
  disabled: false
};
var ResetPassword = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    handleClick = _ref.handleClick,
    state = _ref.state,
    handleChange = _ref.handleChange,
    errors = _ref.errors,
    disabled = _ref.disabled,
    loading = _ref.loading,
    handleResendCode = _ref.handleResendCode,
    handleLogin = _ref.handleLogin,
    handleCreateAccount = _ref.handleCreateAccount,
    logo = _ref.logo;
  var _useState = useState(false),
    show_password = _useState[0],
    setShowPassword = _useState[1];
  var _useState2 = useState({
      code: false,
      email: false,
      password: false
    }),
    initialized = _useState2[0],
    setInitialized = _useState2[1];
  return React.createElement("div", {
    className: "max-w-[580px] " + className
  }, React.createElement(Header$1, {
    title: "Reset password",
    logo: logo
  }), state.stage === ResetPasswordStage.Email ? React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "mb-[60px] text-center mt-2"
  }, "Enter your email below and we will send you instructions to reset your password.") : React.createElement("div", {
    className: "mb-[60px] mt-2 text-center"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "We have sent the verification code to the provided email."), React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Please enter the verification code and the new password below.")), React.createElement(Card, {
    className: "p-5",
    ref: ref
  }, state.stage === ResetPasswordStage.Password && React.createElement(Input, {
    placeholder: "Enter verification code",
    containerClasses: "pb-5",
    surface: "zero",
    id: "verification-code",
    label: "Verification code",
    type: "number",
    is_initialized: initialized.code,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        code: true
      }));
    },
    error: errors == null ? void 0 : errors.code,
    value: state.code,
    onChange: function onChange(e) {
      return handleChange('code', e.target.value);
    }
  }), state.stage === ResetPasswordStage.Email ? React.createElement(Input, {
    placeholder: "Enter email address",
    containerClasses: "pb-5",
    surface: "zero",
    id: "email",
    label: "Email",
    type: "email",
    is_initialized: initialized.email,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        email: true
      }));
    },
    error: errors == null ? void 0 : errors.email,
    value: state.email,
    onChange: function onChange(e) {
      return handleChange('email', e.target.value);
    }
  }) : React.createElement(Input, {
    surface: "zero",
    id: "password",
    helper_box_text: React.createElement("span", {
      className: "space-y-2"
    }, ['At least 8 characters', 'Upper & lowercase letters', 'At least 2 numbers', 'At least 1 symbol'].map(function (s) {
      return React.createElement(Typography, {
        key: s,
        size: "xs",
        variant: "secondary"
      }, s);
    })),
    containerClasses: "pb-5",
    label: "New password",
    type: show_password ? 'text' : 'password',
    placeholder: "New password",
    value: state.password,
    error: errors == null ? void 0 : errors.password,
    is_initialized: initialized.password,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        password: true
      }));
    },
    onChange: function onChange(e) {
      return handleChange('password', e.target.value);
    }
  }), state.stage === ResetPasswordStage.Password && React.createElement("div", {
    className: "pb-5"
  }, React.createElement(Toggle, {
    label: "Show password",
    surface_level: "zero",
    active: show_password,
    onChange: function onChange() {
      return setShowPassword(!show_password);
    },
    variant: "checkbox"
  })), React.createElement("div", {
    className: "pt-3"
  }, React.createElement(Button, {
    onClick: function onClick() {
      return handleClick();
    },
    className: "w-full",
    loading: loading,
    disabled: disabled
  }, state.stage === ResetPasswordStage.Password ? 'Set new password' : 'Reset password'))), state.stage === ResetPasswordStage.Password ? React.createElement("div", {
    className: "text-center mt-5"
  }, React.createElement(Typography, {
    onClick: handleResendCode,
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer"
  }, "Resend code")) : React.createElement("div", {
    className: "flex justify-between mt-5"
  }, React.createElement(Typography, {
    onClick: handleCreateAccount,
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer"
  }, "Create account"), React.createElement(Typography, {
    onClick: handleLogin,
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer"
  }, "Log in")));
});
ResetPassword.displayName = 'ResetPassword';
ResetPassword.defaultProps = defaultProps$K;

var defaultProps$L = {
  as: 'div',
  className: '',
  email: '',
  error: '',
  id: 'verify-email',
  loading: false,
  title: '',
  value: ''
};
var VerifyEmail = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    email = _ref.email,
    error = _ref.error,
    id = _ref.id,
    loading = _ref.loading,
    title = _ref.title,
    value = _ref.value,
    handleChange = _ref.handleChange,
    handleResendCode = _ref.handleResendCode;
  return React.createElement(Component, {
    className: "max-w-[580px] " + className
  }, React.createElement(Card, {
    className: "p-8 space-y-8",
    "data-testid": id,
    ref: ref
  }, title && React.createElement(Typography, {
    as: "h1",
    allBold: true,
    size: "4xl"
  }, title), React.createElement(Typography, {
    size: "sm"
  }, React.createElement("span", null, "We have sent a verification code to", React.createElement("span", {
    className: "font-bold"
  }, " ", email), ".", React.createElement("br", null), " Please enter the verification code below.")), React.createElement(Input, {
    id: id + "-input",
    className: "w-full",
    error: error,
    label: "Verification code",
    loading: loading,
    maxLength: 6,
    placeholder: "Enter verification code",
    surface: "zero",
    type: "text",
    value: value,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  })), React.createElement("div", {
    className: "flex justify-center mt-5 space-x-2"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Did not receive the verification code?"), React.createElement(Typography, {
    className: "text-accent cursor-pointer hover:underline",
    size: "sm",
    variant: "custom",
    onClick: handleResendCode
  }, "Resend code")));
});
VerifyEmail.displayName = 'VerifyEmail';
VerifyEmail.defaultProps = defaultProps$L;

var defaultProps$M = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined
};
var Branding = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    loading = _ref.loading,
    progress = _ref.progress,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_text = _ref.continue_btn_text,
    state = _ref.state,
    errors = _ref.errors,
    handleChange = _ref.handleChange,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    subtitle: "Brand your farm to attract investors.",
    title: "Branding",
    skip_btn_text: skip_btn_text,
    continue_btn_text: continue_btn_text,
    handleSkipBtnClick: handleSkipClick,
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick();
    },
    continue_btn_disabled: state.farm_name === '' || state.farm_image === '' || disabled
  }, React.createElement(Input, {
    containerClasses: "mt-[32px]",
    surface: "zero",
    placeholder: "Enter farm name",
    error: errors == null ? void 0 : errors.farm_name,
    id: "farm-name-input",
    label: "Farm name",
    type: "text",
    value: state.farm_name,
    onChange: function onChange(e) {
      return handleChange('farm_name', e.target.value);
    }
  }), React.createElement("div", {
    className: "mt-5 flex justify-between items-end"
  }, React.createElement(Input, {
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter image URL",
    id: "farm-image-input",
    label: "Farm image (999x999 pixels)",
    type: "text",
    error: errors == null ? void 0 : errors.farm_image,
    value: state.farm_image,
    onChange: function onChange(e) {
      return handleChange('farm_image', e.target.value);
    }
  }), !is_mobile && React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('farm_image', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "copy-btn"
  }))));
});
Branding.displayName = 'Branding';
Branding.defaultProps = defaultProps$M;

var APPROVAL_TIME_DAYS = 1;
var defaultProps$N = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined,
  skip_btn_text: 'Back'
};
var Composition = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    errors = _ref.errors,
    Component = _ref.as,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    buttons_info_array = _ref.buttons_info_array,
    className = _ref.className,
    loading = _ref.loading,
    progress = _ref.progress,
    apy_value = _ref.apy_value,
    reward_value = _ref.reward_value,
    cut_off_value = _ref.cut_off_value,
    ticker = _ref.ticker,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var minDate = useMemo(function () {
    return dayjs().add(APPROVAL_TIME_DAYS, 'days').format('YYYY-MM-DDTHH:mm');
  }, []);
  var maxDate = useMemo(function () {
    return dayjs().add(30 + APPROVAL_TIME_DAYS, 'days').format('YYYY-MM-DDTHH:mm');
  }, []);
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    skip_btn_text: skip_btn_text,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: state.farm_capacity === '' || state.reward_amount === '' || state.lock_term === '' || state.start_date === '' || state.selected_plan_option === undefined || disabled,
    subtitle: "Design the farm entirely to your specification.",
    title: "Farm composition",
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick();
    },
    handleSkipBtnClick: handleSkipClick
  }, React.createElement(Input, {
    error: errors == null ? void 0 : errors.reward_amount,
    containerClasses: "mt-[32px]",
    surface: "zero",
    tooltip: "The total amount of reward tokens to be distributed in this farm.",
    placeholder: (breakpoint > 400 ? 'Enter reward token amount' : 'Enter amount') + " ",
    id: "reward-amount-input",
    label: "Reward tokens",
    type: "number",
    value: state.reward_amount,
    onChange: function onChange(e) {
      return handleChange('reward_amount', e.target.value);
    },
    unit: ticker,
    max_btn: false
  }), React.createElement(Input, {
    error: errors == null ? void 0 : errors.farm_capacity,
    containerClasses: "mt-5",
    surface: "zero",
    placeholder: "Enter farm capacity",
    id: "farm-capacity-input",
    label: "Capacity",
    tooltip: "Maximum amount of tokens that can be locked in this pool by investors.",
    type: "number",
    unit: ticker,
    max_btn: false,
    value: state.farm_capacity,
    onChange: function onChange(e) {
      return handleChange('farm_capacity', e.target.value);
    }
  }), React.createElement(Input, {
    error: errors == null ? void 0 : errors.start_date,
    containerClasses: "mt-5",
    surface: "zero",
    placeholder: "Enter farm start date",
    id: "start-date-input",
    tooltip: "Date your farm becomes public, subject to approval. Approval may take 24-48 hours.",
    label: "Start date",
    type: "datetime-local",
    value: state.start_date,
    onChange: function onChange(e) {
      return handleChange('start_date', e.target.value);
    },
    min: minDate,
    max: maxDate
  }), React.createElement(Input, {
    error: errors == null ? void 0 : errors.lock_term,
    containerClasses: "mt-5",
    surface: "zero",
    placeholder: "Enter lock term",
    id: "lock-term-input",
    label: "Lock term",
    tooltip: "Amount of days tokens will be locked before investors can withdraw. Max. 1/2 of the farm\u2019s life time.",
    unit: "Days",
    max_btn: false,
    type: "number",
    value: state.lock_term,
    onChange: function onChange(e) {
      return handleChange('lock_term', e.target.value);
    }
  }), React.createElement(SquareButtons, {
    className: "pt-5",
    buttons_info_array: buttons_info_array,
    label: 'Farm life time',
    tooltip: "Total amount of days the farm will be providing rewards to all participants. Can be extended at any time.",
    selected: state.selected_plan_option,
    setSelected: function setSelected(val) {
      return handleChange('selected_plan_option', val);
    }
  }), React.createElement(Card, {
    surface: "two",
    className: "p-5 mt-8 mb-8"
  }, React.createElement(DataLines, {
    variant: "default",
    values: [{
      value: apy_value
    }],
    label: "Minimum APY"
  }), React.createElement(DataLines, {
    variant: "default",
    className: "pt-5",
    values: [{
      value: reward_value
    }],
    label: "Daily reward"
  }), React.createElement(DataLines, {
    variant: "default",
    className: "pt-5",
    values: [{
      value: cut_off_value
    }],
    label: "Staking cut-off",
    tooltip: "Investors will no longer be able to stake more in the farm past this date. The date can be pushed further at any time by extending the farm\u2019s life time."
  })), React.createElement(Alert, {
    variant: "note"
  }, React.createElement(React.Fragment, null, React.createElement("span", {
    className: "flex space-x-2"
  }, React.createElement("span", null, " \u2022"), React.createElement("span", null, "To ensure fair conditions for all participants, minimum APY cannot be reduced after the farm is created.")), React.createElement("br", null), React.createElement("span", {
    className: "flex space-x-2"
  }, React.createElement("span", null, " \u2022"), React.createElement("span", null, "You can extend the farm\u2019s lifetime at any time, however, it will require additional reward tokens to maintain the minimum APY.")), React.createElement("br", null), React.createElement("span", {
    className: "flex space-x-2"
  }, React.createElement("span", null, " \u2022"), React.createElement("span", null, "Adding more reward tokens will require to extend the farm\u2019s life-time.")))));
});
Composition.displayName = 'Composition';
Composition.defaultProps = defaultProps$N;

var defaultProps$O = {
  as: FormWrapper,
  className: '',
  continue_btn_disabled: false,
  loading: false,
  progress: undefined,
  skip_btn_text: 'Back',
  skip_btn_disabled: false
};
var Deploy = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    Component = _ref.as,
    className = _ref.className,
    list_item_arr = _ref.list_item_arr,
    loading = _ref.loading,
    progress = _ref.progress,
    policy_url = _ref.policy_url,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_disabled = _ref.continue_btn_disabled,
    skip_btn_disabled = _ref.skip_btn_disabled,
    terms_url = _ref.terms_url,
    handleContinueClick = _ref.handleContinueClick,
    handleSkipClick = _ref.handleSkipClick,
    handleFarmSummary = _ref.handleFarmSummary;
  var breakpoint = useBreakpoint();
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: continue_btn_disabled,
    skip_btn_disabled: skip_btn_disabled,
    loading: loading,
    progress: progress,
    title: "Deploy the farm",
    skip_btn_text: skip_btn_text,
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick();
    },
    handleSkipBtnClick: handleSkipClick
  }, React.createElement(Card, {
    surface: "two",
    className: "px-5 py-4 mt-8"
  }, React.createElement(ListItem, {
    label_text: "Farm summary",
    info_text: "View the farm\u2019s full summary.",
    button_text: "View",
    variant: "button",
    handleClick: handleFarmSummary
  })), React.createElement(Card, {
    id: "toggle-card",
    surface: "two",
    className: "my-5 " + (breakpoint > 505 ? 'px-5 py-[12px]' : 'p-5')
  }, React.createElement(Toggle, {
    id: "accept-terms",
    active: state.checked,
    onChange: function onChange() {
      return handleChange('checked', !state.checked);
    },
    label: React.createElement(React.Fragment, null, "I agree to", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      rel: "noreferrer",
      target: "_blank",
      href: terms_url
    }, "Terms"), ' ', "&", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      href: policy_url,
      rel: "noreferrer",
      target: "_blank"
    }, "Privacy Conditions"), "."),
    variant: "checkbox"
  })), React.createElement(ListItemUnit, {
    surface: "two",
    list_item_arr: list_item_arr
  }), React.createElement(Alert, {
    className: "mt-8",
    variant: "note"
  }, "All fees are processed on the BNB Chain (BEP-20)."));
});
Deploy.displayName = 'Deploy';
Deploy.defaultProps = defaultProps$O;

var defaultProps$P = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined,
  select_disabled: false
};
var FarmSetup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    errors = _ref.errors,
    handleChange = _ref.handleChange,
    Component = _ref.as,
    className = _ref.className,
    loading = _ref.loading,
    chain_options = _ref.chain_options,
    progress = _ref.progress,
    select_disabled = _ref.select_disabled,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_text = _ref.continue_btn_text,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    skip_btn_text: skip_btn_text,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: state.token === '' || !state.chain_option || disabled,
    subtitle: is_mobile ? React.createElement("span", null, "Creating a staking farm is a fast and easy way to attract new eyes and engage with investors, while locking your project tokens away from the market.") : React.createElement("span", null, "Creating a staking farm is a fast and easy way to attract new eyes", ' ', React.createElement("br", null), " and engage with investors, while locking your project tokens away ", React.createElement("br", null), " from the market."),
    title: "Farm Setup",
    handleContinueBtnClick: handleContinueClick,
    handleSkipBtnClick: handleSkipClick
  }, React.createElement(Select, {
    disabled: select_disabled,
    options: chain_options,
    current: state.chain_option,
    setCurrent: function setCurrent(o) {
      return handleChange('option', o);
    },
    className: "mt-8",
    surface: "zero",
    placeholder: "Binance Smart Chain",
    label: "Blockchain",
    tooltip: "Currently we only support Binance Smart Chain, but hope to support many more EVM compatable chains soon."
  }), React.createElement("div", {
    className: "mt-5 flex justify-between items-end"
  }, React.createElement(Input, {
    error: errors == null ? void 0 : errors.token,
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter token contract address",
    id: "token-contract-input",
    label: "Token contract address",
    type: "text",
    value: state.token,
    onChange: function onChange(e) {
      return handleChange('token', e.target.value);
    }
  }), React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return window.navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('token', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "copy-btn"
  }))));
});
FarmSetup.displayName = 'FarmSetup';
FarmSetup.defaultProps = defaultProps$P;

var defaultProps$Q = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined,
  disabled: false
};
var Manage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    state = _ref.state,
    setState = _ref.setState,
    list_item_arr = _ref.list_item_arr,
    alert_message = _ref.alert_message,
    alert_title = _ref.alert_title,
    continue_btn_text = _ref.continue_btn_text,
    buttons_info_array = _ref.buttons_info_array,
    className = _ref.className,
    loading = _ref.loading,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled,
    alert_variant = _ref.alert_variant;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    continue_btn_text: continue_btn_text,
    title: "Manage farm",
    continue_btn_disabled: state === undefined || disabled,
    handleContinueBtnClick: handleContinueClick
  }, alert_message && alert_variant && React.createElement(Alert, {
    className: "mt-8",
    title: alert_title,
    variant: alert_variant
  }, alert_message), React.createElement(SquareButtons, {
    className: "pt-8 pb-8",
    buttons_info_array: buttons_info_array,
    label: "Extend farm\u2019s life time",
    tooltip: "Total amount of days the farm will be providing rewards to all participants. This will add additional days to your current farm life time.",
    selected: state,
    setSelected: setState
  }), React.createElement(ListItemUnit, {
    surface: "two",
    list_item_arr: list_item_arr
  }));
});
Manage.displayName = 'Manage';
Manage.defaultProps = defaultProps$Q;

var defaultProps$R = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined
};
var ParticipationFees = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    loading = _ref.loading,
    progress = _ref.progress,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled;
  var _useState = useState({
      wallet_address: '',
      fee_percentage: ''
    }),
    state = _useState[0],
    setState = _useState[1];
  var handleChange = function handleChange(name, val) {
    var _extends2;
    return setState(_extends({}, state, (_extends2 = {}, _extends2[name] = val, _extends2)));
  };
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: state.wallet_address === '' || state.fee_percentage === '' || disabled,
    skip_btn_text: skip_btn_text,
    subtitle: "Split the cost of the farm with the participants. Leave blank if you don\u2019t want to collect fees.",
    title: "Participation Fees",
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick(state.wallet_address, state.fee_percentage);
    },
    handleSkipBtnClick: handleSkipClick
  }, React.createElement("div", {
    className: "mt-[32px] flex justify-between items-end"
  }, React.createElement(Input, {
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter wallet address",
    id: "wallet-address-input",
    label: "Wallet address to send the fees to",
    type: "text",
    value: state.wallet_address,
    onChange: function onChange(e) {
      return handleChange('wallet_address', e.target.value);
    }
  }), React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('wallet_address', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "copy-btn"
  }))), React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    placeholder: "Enter fee percent",
    id: "fee-percentage-input",
    label: "Fee percentage",
    type: "number",
    value: state.fee_percentage,
    onChange: function onChange(e) {
      return handleChange('fee_percentage', e.target.value);
    },
    unit: "percent",
    max_btn: false,
    tooltip: "some tooltip some tooltip some tooltip"
  }));
});
ParticipationFees.displayName = 'ParticipationFees';
ParticipationFees.defaultProps = defaultProps$R;

var defaultProps$S = {
  as: Modal,
  className: '',
  id: 'farm-summary',
  items: [],
  show: false
};
var Summary = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    id = _ref.id,
    items = _ref.items,
    show = _ref.show,
    onClose = _ref.onClose;
  return React.createElement(Component, {
    className: "space-y-8 " + className,
    "data-testid": id,
    ref: ref,
    show: show,
    title: "Farm summary",
    onClose: onClose
  }, items && items.map(function (item, id) {
    return React.createElement("div", {
      className: "text-left",
      key: id
    }, React.createElement("div", {
      className: "flex items-center justify-between mb-5"
    }, React.createElement(Typography, {
      allBold: true,
      size: "2xl"
    }, item.title), item.onEdit && React.createElement(Typography, {
      className: "text-accent cursor-pointer",
      size: "sm",
      variant: "custom",
      onClick: item.onEdit
    }, "Edit")), React.createElement(ListItemUnit, {
      list_item_arr: item.list,
      surface: "two"
    }));
  }));
});
Summary.displayName = 'Summary';
Summary.defaultProps = defaultProps$S;

var defaultProps$T = {
  className: '',
  id: 'farm-stats-summary',
  items: []
};
var StatsSummary = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    items = _ref.items,
    handleFarmSummary = _ref.handleFarmSummary;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Card, {
    id: id,
    ref: ref,
    surface: "one",
    className: "max-w-[580px] p-5 xs:p-8 " + className
  }, React.createElement(Typography, {
    allBold: true,
    size: is_mobile ? '3xl' : '4xl',
    className: "text-center"
  }, "Stats & summary"), React.createElement(Card, {
    surface: "two",
    className: "px-5 py-4 my-8"
  }, React.createElement(ListItem, {
    label_text: "Full summary",
    info_text: "View the farm\u2019s full summary.",
    button_text: "View",
    variant: "button",
    handleClick: handleFarmSummary
  })), React.createElement(ListItemUnit, {
    list_item_arr: items,
    surface: "two"
  }));
});
StatsSummary.displayName = 'StatsSummary';
StatsSummary.defaultProps = defaultProps$T;

// import PropTypes from "prop-types";
var ProductType;
(function (ProductType) {
  ProductType["Farm"] = "farm";
  ProductType["Staking"] = "staking";
  ProductType["Vesting"] = "vesting";
})(ProductType || (ProductType = {}));

var defaultProps$U = {
  as: 'div',
  className: '',
  isEmpty: false,
  isLoading: false,
  product: {
    id: '',
    branding: {
      image: '',
      name: ''
    },
    chain: {
      image: '',
      name: ''
    },
    plan: {
      className: '',
      end_date: '',
      expiry: '',
      name: '',
      start_date: ''
    },
    showButton: false,
    status: {
      className: '',
      subText: '',
      text: 'Active'
    },
    type: ProductType.Farm
  }
};
var ListContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    children = _ref.children,
    id = _ref.id,
    isEmpty = _ref.isEmpty,
    isLoading = _ref.isLoading,
    product = _ref.product,
    handleItemClick = _ref.handleItemClick;
  var breakpoint = useBreakpoint();
  return React.createElement(React.Fragment, null, React.createElement(Card, {
    as: as,
    className: ['p-5', 'z-10', 'md:px-5', 'md:py-4', 'relative', !isLoading && !isEmpty ? 'cursor-pointer' : '', className].join(' '),
    id: id,
    ref: ref,
    surface: isEmpty || isLoading || breakpoint > 992 ? 'one' : 'two',
    onClick: handleItemClick
  }, !isEmpty ? !isLoading ? React.createElement(React.Fragment, null, children) : React.createElement(Grid, {
    className: "gap-4 md:gap-0",
    role: "status"
  }, React.createElement(Grid.Item, {
    className: "animate-pulse col-span-4"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-28"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-28"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 justify-self-end md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 justify-self-end md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-28"
  }))) : React.createElement(Grid, null, React.createElement(Grid.Item, {
    className: "col-span-4 md:col-span-12"
  }, React.createElement(React.Fragment, null, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, "Looks like you didn\u2019t create any properties yet."), React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Start by selecting a property type above. All your properties will be listed here."))))), React.createElement(Card, {
    as: as,
    id: id,
    ref: ref,
    className: "relative -top-5 md:hidden",
    onClick: handleItemClick
  }, !isLoading && !isEmpty ? React.createElement("div", {
    className: "pt-10 px-5 pb-5"
  }, React.createElement(Grid, {
    className: "gap-1"
  }, React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Blockchain")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right"
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, product == null ? void 0 : product.chain.name)), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Status")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right"
  }, React.createElement(Typography, {
    allBold: true,
    className: product == null ? void 0 : product.status.className,
    size: "sm",
    variant: "custom"
  }, product == null ? void 0 : product.status.text), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, product == null ? void 0 : product.status.subText)), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Plan")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right"
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, product == null ? void 0 : product.plan.name), React.createElement(Typography, {
    className: product == null ? void 0 : product.plan.className,
    size: "xs",
    variant: "custom"
  }, product == null ? void 0 : product.plan.expiry))), product != null && product.showButton ? React.createElement(Button, {
    fullwidth: true,
    className: "mt-5"
  }, "Extend plan") : null) : null));
});
ListContainer.displayName = 'ListContainer';
ListContainer.defaultProps = defaultProps$U;

var defaultProps$V = {
  as: 'div',
  clssName: ''
};
var ListHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    Component = _ref.as;
  return React.createElement(Component, {
    className: "hidden px-5 md:block " + className,
    "data-testid": id,
    ref: ref
  }, React.createElement(Grid, {
    role: "grid"
  }, React.createElement(Grid.Item, {
    className: "col-span-4"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Name")), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Blockchain")), React.createElement(Grid.Item, {
    className: "col-span-2 ml-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Status")), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Plan")), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, ' '))));
});
ListHeader.displayName = 'ListHeader';
ListHeader.defaultProps = defaultProps$V;

var defaultProps$W = {
  as: 'div',
  className: '',
  isLoading: false,
  product: {
    id: '',
    branding: {
      image: '',
      name: ''
    },
    chain: {
      image: '',
      name: ''
    },
    plan: {
      expiry: '',
      end_date: '',
      name: '',
      className: '',
      start_date: ''
    },
    showButton: false,
    status: {
      subText: '',
      text: 'Active',
      className: ''
    },
    type: ProductType.Farm
  }
};
var ProductListItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    isLoading = _ref.isLoading,
    product = _ref.product,
    handleItemClick = _ref.handleItemClick,
    Component = _ref.as;
  var breakpoint = useBreakpoint();
  return React.createElement(Component, {
    className: ['low-border', 'rounded-lg', 'cursor-pointer', 'bg-surface-level-one', 'md:px-5', 'md:py-4', className].join(' '),
    "data-testid": product == null ? void 0 : product.id,
    onClick: handleItemClick,
    ref: ref
  }, React.createElement(Grid, {
    role: "grid"
  }, React.createElement(Grid.Item, {
    className: ['p-5', 'col-span-4', 'rounded-lg', 'inline-flex', 'items-center', 'bg-surface-level-two', 'md:p-0', 'md:rounded-none', 'md:bg-transparent'].join(' ')
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-three h-7 rounded-lg w-28 md:bg-surface-level-two"
  }) : React.createElement(React.Fragment, null, React.createElement(ProductBadge, {
    surface: breakpoint < 992 ? 'three' : 'two',
    variant: product == null ? void 0 : product.type
  }), React.createElement(Typography, {
    allBold: true,
    className: "ml-3"
  }, product == null ? void 0 : product.branding.name))), React.createElement(Grid.Item, {
    className: "col-span-2 mt-5 ml-5 self-center md:hidden"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-21"
  }) : React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Network")), React.createElement(Grid.Item, {
    className: "col-span-2 ml-auto mt-5 mr-5 self-center md:inline-flex md:items-center md:ml-0 md:mr-2 md:mt-0"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  }) : React.createElement(React.Fragment, null, React.createElement("span", {
    className: "hidden mr-2 md:block"
  }, React.createElement("img", {
    alt: "chain-logo",
    src: product == null ? void 0 : product.chain.image
  })), React.createElement(Typography, {
    allBold: breakpoint < 992,
    size: "sm"
  }, product == null ? void 0 : product.chain.name))), React.createElement(Grid.Item, {
    className: "col-span-2 ml-5 self-center md:hidden"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-21"
  }) : React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Status")), React.createElement(Grid.Item, {
    className: "col-span-2 ml-auto mr-5 mt-1 self-center text-right md:ml-2 md:mr-0 md:mt-0 md:text-left"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  }) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    allBold: breakpoint < 992,
    className: product == null ? void 0 : product.status.className,
    size: "sm",
    variant: "custom"
  }, product == null ? void 0 : product.status.text), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, product == null ? void 0 : product.status.subText))), React.createElement(Grid.Item, {
    className: "col-span-2 mb-5 ml-5 self-center md:hidden"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-21"
  }) : React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Plan")), React.createElement(Grid.Item, {
    className: "col-span-2 mb-5 ml-auto mr-5 mt-1 self-center text-right md:m-0 md:text-left"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  }) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    allBold: breakpoint < 992,
    size: "sm"
  }, product == null ? void 0 : product.plan.name), React.createElement(Typography, {
    className: product == null ? void 0 : product.plan.className,
    size: "xs",
    variant: "custom"
  }, product == null ? void 0 : product.plan.expiry))), React.createElement(Grid.Item, {
    className: "col-span-4 px-5 md:col-span-2 md:ml-auto md:p-0"
  }, !isLoading && product != null && product.showButton ? React.createElement(Button, {
    className: "mb-5 md:mb-0",
    fullwidth: breakpoint < 992
  }, "Extend plan") : null)));
});
var Empty = function Empty(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "low-border p-5 rounded-lg bg-surface-level-one"
  }, children);
};
ProductListItem.displayName = 'ProductListItem';
ProductListItem.defaultProps = defaultProps$W;
var index = /*#__PURE__*/Object.assign(ProductListItem, {
  Empty: Empty
});

var defaultProps$X = {
  as: 'div',
  isEmpty: false,
  isLoading: false,
  items: [],
  variant: 'conn-none',
  is_always_mobile: false
};
var PoolContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _mobItems$multiplier, _mobItems$lockTerm, _mobItems$lockTerm2;
  var as = _ref.as,
    className = _ref.className,
    children = _ref.children,
    id = _ref.id,
    isEmpty = _ref.isEmpty,
    isLoading = _ref.isLoading,
    mobItems = _ref.mobItems,
    variant = _ref.variant,
    handleConnect = _ref.handleConnect,
    handlePoolClick = _ref.handlePoolClick,
    is_always_mobile = _ref.is_always_mobile;
  var breakpoint = useBreakpoint();
  return React.createElement("div", {
    className: "border-none rounded-lg " + (is_always_mobile ? 'bg-surface-level-two' : 'bg-surface-level-one')
  }, React.createElement(Card, {
    as: as,
    className: ['p-5', 'relative', 'z-10', is_always_mobile ? '' : 'md:px-5', is_always_mobile ? '' : 'md:py-4', !isEmpty && !isLoading ? 'cursor-pointer' : '', className].join(' '),
    id: id,
    ref: ref,
    surface: !is_always_mobile && breakpoint >= 992 || isEmpty || isLoading ? 'one' : is_always_mobile ? 'three' : 'two',
    onClick: handlePoolClick
  }, !isEmpty ? !isLoading ? React.createElement(React.Fragment, null, children) : React.createElement(Grid, {
    className: "gap-4 md:gap-0",
    role: "status"
  }, React.createElement(Grid.Item, {
    className: "animate-pulse col-span-4 md:col-span-4"
  }, React.createElement("div", {
    className: "flex gap-1"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-11 rounded-lg w-20"
  }), React.createElement("div", {
    className: "bg-surface-level-two h-11 rounded-lg w-20"
  }))), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-1 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-1 hidden ml-8 md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden ml-16 md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden justify-self-end md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-28"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 justify-self-end md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 justify-self-end md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded-lg w-28"
  }))) : React.createElement(Grid, {
    role: "listbox"
  }, React.createElement(React.Fragment, null, function () {
    switch (variant) {
      case 'conn-none':
        return React.createElement(React.Fragment, null, React.createElement(Grid.Item, {
          className: "col-span-2 md:col-span-6"
        }, React.createElement(Typography, {
          allBold: true,
          size: "sm"
        }, "Connect wallet to see your staked pools")), React.createElement(Grid.Item, {
          className: "col-span-2 justify-self-end md:col-span-6"
        }, React.createElement(Button, {
          onClick: handleConnect
        }, "Connect wallet")));
      case 'pool-none':
        return React.createElement(React.Fragment, null, React.createElement(Grid.Item, {
          className: "col-span-4 md:col-span-12"
        }, React.createElement(React.Fragment, null, React.createElement(Typography, {
          allBold: true,
          size: "sm"
        }, "It looks like there are no active pools at this time"))));
      case 'stake-full':
        return React.createElement(React.Fragment, null, React.createElement(Grid.Item, {
          className: "col-span-4 md:col-span-12"
        }, React.createElement(React.Fragment, null, React.createElement(Typography, {
          allBold: true,
          size: "sm"
        }, "Looks like you are staking in all active pools"), React.createElement(Typography, {
          variant: "secondary",
          size: "sm"
        }, 'What a whale 🐋'))));
      case 'stake-none':
        return React.createElement(React.Fragment, null, React.createElement(Grid.Item, {
          className: "col-span-4 md:col-span-12"
        }, React.createElement(React.Fragment, null, React.createElement(Typography, {
          allBold: true,
          size: "sm"
        }, "Looks like you haven\u2032t staked yet"), React.createElement(Typography, {
          variant: "secondary",
          size: "sm"
        }, "Stake in pools below to get your Investor Tier and start earning passive income"))));
      default:
        return null;
    }
  }()))), React.createElement("div", {
    id: id,
    className: "" + (is_always_mobile ? '' : 'md:hidden'),
    onClick: handlePoolClick
  }, !isEmpty && !isLoading ? React.createElement("div", {
    className: "border border-border border-t-0 border-opacity-[0.03] p-5 rounded-b-lg"
  }, React.createElement(Grid, {
    className: "gap-1",
    is_always_mobile: is_always_mobile
  }, React.createElement(Grid.Item, {
    className: "col-span-2 " + (is_always_mobile ? '' : 'md:col-span-4')
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Boost")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right " + (is_always_mobile ? '' : 'md:col-span-4')
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, mobItems == null ? void 0 : (_mobItems$multiplier = mobItems.multiplier) == null ? void 0 : _mobItems$multiplier.amount)), React.createElement(Grid.Item, {
    className: "col-span-2 " + (is_always_mobile ? '' : 'md:col-span-4')
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, mobItems != null && mobItems.userStake ? 'Unlock' : 'Lock Term')), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right " + (is_always_mobile ? '' : 'md:col-span-4')
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, mobItems != null && mobItems.userStake ? mobItems == null ? void 0 : (_mobItems$lockTerm = mobItems.lockTerm) == null ? void 0 : _mobItems$lockTerm.lockEndDate : mobItems == null ? void 0 : (_mobItems$lockTerm2 = mobItems.lockTerm) == null ? void 0 : _mobItems$lockTerm2.value)), (mobItems == null ? void 0 : mobItems.userStake) && React.createElement(React.Fragment, null, React.createElement(Grid.Item, {
    className: "col-span-2 " + (is_always_mobile ? '' : 'md:col-span-4')
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Your Stake")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right " + (is_always_mobile ? '' : 'md:col-span-4')
  }, mobItems == null ? void 0 : mobItems.userStake.map(function (stake) {
    return React.createElement(Typography, {
      allBold: true,
      key: JSON.stringify(stake),
      size: "sm"
    }, stake.amount, " ", stake.symbol);
  }))))) : null));
});
PoolContainer.displayName = 'PoolContainer';
PoolContainer.defaultProps = defaultProps$X;

var defaultProps$Y = {
  as: 'div',
  variant: 'active'
};
var PoolHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    variant = _ref.variant,
    Component = _ref.as;
  return React.createElement(Component, {
    className: "md:space-y-4 " + className,
    "data-testid": id,
    ref: ref
  }, React.createElement(Grid, {
    className: "md:px-5"
  }, React.createElement(Grid.Item, {
    className: "hidden md:block md:col-span-4"
  }, React.createElement(Typography, {
    className: "float-left",
    size: "xs",
    variant: "secondary"
  }, "Composition")), React.createElement(Grid.Item, {
    className: "hidden md:block md:col-span-1"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "Reward rate")), React.createElement(Grid.Item, {
    className: "hidden md:block md:col-span-1 md:ml-8"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "NFT boost")), React.createElement(Grid.Item, {
    className: "hidden md:block md:col-span-2 md:ml-16"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "Lock term")), React.createElement(Grid.Item, {
    className: "hidden md:block md:col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "Total Staked")), React.createElement(Grid.Item, {
    className: "hidden md:block lg:col-span-2 lg:justify-self-end"
  }, variant === 'staked' && React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "Your stake"))));
});
PoolHeader.displayName = 'PoolHeader';
PoolHeader.defaultProps = defaultProps$Y;

var defaultProps$Z = {
  as: 'div',
  is_always_mobile: false
};
var PoolItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _capacity$2, _capacity$3;
  var id = _ref.id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    capacity = _ref.capacity,
    lockTerm = _ref.lockTerm,
    multiplierChip = _ref.multiplierChip,
    reward = _ref.reward,
    stakingChip = _ref.stakingChip,
    userStake = _ref.userStake,
    is_always_mobile = _ref.is_always_mobile,
    Component = _ref.as;
  return React.createElement(Component, {
    className: "" + className,
    "data-testid": id,
    ref: ref
  }, React.createElement(Grid, {
    role: "grid",
    is_always_mobile: is_always_mobile
  }, React.createElement(Grid.Item, {
    className: "col-span-4 mb-4 " + (is_always_mobile ? '' : 'md:mb-0')
  }, React.createElement(StakingChips, Object.assign({}, stakingChip, {
    is_always_mobile: is_always_mobile
  }))), React.createElement(Grid.Item, {
    className: "col-span-2 mb-1 " + (is_always_mobile ? '' : 'md:hidden md:mb-0')
  }, React.createElement(Typography, {
    className: "" + (is_always_mobile ? '' : 'md:hidden'),
    size: "sm",
    variant: "secondary"
  }, "Reward")), React.createElement(Grid.Item, {
    className: "col-span-2 " + (is_always_mobile ? '' : 'md:col-span-1')
  }, React.createElement("div", {
    className: "hidden " + (is_always_mobile ? '' : 'md:block md:pb-1.5')
  }, React.createElement(Typography, {
    allBold: true,
    as: "h3",
    size: "2xl"
  }, reward == null ? void 0 : reward.value), React.createElement(Typography, {
    className: "leading-[8px]",
    size: "xs",
    variant: "secondary"
  }, reward == null ? void 0 : reward.label)), React.createElement("div", {
    className: "text-right " + (is_always_mobile ? '' : 'md:hidden')
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, reward == null ? void 0 : reward.value, " ", reward == null ? void 0 : reward.label))), React.createElement(Grid.Item, {
    className: "col-span-2 hidden " + (is_always_mobile ? '' : 'md:block md:col-span-1 md:ml-8')
  }, React.createElement(MultiplierChip, Object.assign({}, multiplierChip))), React.createElement(Grid.Item, {
    className: "col-span-2 hidden " + (is_always_mobile ? '' : 'md:block md:ml-16')
  }, lockTerm != null && lockTerm.lockEndDate ? React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "sm"
  }, lockTerm == null ? void 0 : lockTerm.lockEndDate), React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, lockTerm == null ? void 0 : lockTerm.value)) : React.createElement(Typography, {
    size: "sm"
  }, lockTerm == null ? void 0 : lockTerm.value)), React.createElement(Grid.Item, {
    className: "col-span-2 " + (is_always_mobile ? '' : 'md:hidden')
  }, React.createElement(Typography, {
    className: "" + (is_always_mobile ? '' : 'md:hidden'),
    size: "sm",
    variant: "secondary"
  }, "Total Staked")), React.createElement(Grid.Item, {
    className: "col-span-2 " + (is_always_mobile ? '' : 'md:col-span-2')
  }, capacity == null ? void 0 : capacity.map(function (c, idx) {
    var _capacity$;
    return React.createElement("div", {
      key: JSON.stringify(c) + idx
    }, React.createElement("div", {
      className: "font-bold text-right " + (is_always_mobile ? '' : 'md:font-normal md:text-left')
    }, React.createElement(Typography, {
      size: "sm"
    }, c == null ? void 0 : c.staked)), React.createElement("div", {
      className: "hidden " + (is_always_mobile ? '' : 'md:block')
    }, !isNaN((_capacity$ = capacity[0]) == null ? void 0 : _capacity$.percentFilled) && React.createElement(Progress, {
      label: true,
      className: "w-full " + (is_always_mobile ? '' : 'md:w-36'),
      percent: c == null ? void 0 : c.percentFilled
    })));
  })), React.createElement(Grid.Item, {
    className: "col-span-4 mt-1 " + (is_always_mobile ? '' : 'md:hidden md:mt-0')
  }, capacity && !isNaN((_capacity$2 = capacity[0]) == null ? void 0 : _capacity$2.percentFilled) && React.createElement(Progress, {
    label: true,
    className: "w-full " + (is_always_mobile ? '' : 'md:w-36'),
    percent: (_capacity$3 = capacity[0]) == null ? void 0 : _capacity$3.percentFilled
  })), userStake && React.createElement(Grid.Item, {
    className: "hidden " + (is_always_mobile ? '' : 'md:block md:col-span-2 md:justify-self-end md:text-right')
  }, userStake.map(function (stake, idx) {
    return React.createElement(Typography, {
      key: JSON.stringify(stake) + idx,
      size: "sm"
    }, stake.amount, " ", stake.symbol);
  }))));
});
PoolItem.displayName = 'PoolItem';
PoolItem.defaultProps = defaultProps$Z;

var defaultProps$_ = {};
var ProductCardList = function ProductCardList(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    product_card_list_arr = _ref.product_card_list_arr;
  return React.createElement("div", {
    id: id,
    className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 " + className
  }, product_card_list_arr.map(function (_ref2) {
    var handleClick = _ref2.handleClick,
      variant = _ref2.variant,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      chipText = _ref2.chipText;
    return React.createElement(ProductCard, {
      key: JSON.stringify(title),
      chipText: chipText,
      subtitle: subtitle,
      title: title,
      variant: variant,
      handleClick: handleClick
    });
  }));
};
ProductCardList.displayName = 'ProductCardList';
ProductCardList.defaultProps = defaultProps$_;

var defaultProps$$ = {
  as: Modal
};
var RefundModal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    show = _ref.show,
    onClose = _ref.onClose,
    refund_data_arr = _ref.refund_data_arr,
    refund_project_name = _ref.refund_project_name,
    handleCancelClick = _ref.handleCancelClick,
    handleContinueClick = _ref.handleContinueClick,
    handleInfoClick = _ref.handleInfoClick,
    info_text = _ref.info_text,
    label_text = _ref.label_text,
    info_button_text = _ref.info_button_text,
    continue_btn_text = _ref.continue_btn_text,
    loading = _ref.loading;
  return React.createElement(Component, {
    ref: ref,
    title: refund_project_name,
    desc: "Request refund & recover invested funds back to your wallet.",
    show: show,
    onClose: onClose,
    noClose: true,
    is_fixed_height: false
  }, React.createElement(Card, {
    surface: "two",
    className: "p-5 mt-8 space-y-5 text-left"
  }, refund_data_arr.map(function (_ref2, idx) {
    var values = _ref2.values,
      label = _ref2.label,
      tooltip = _ref2.tooltip;
    return React.createElement(DataLines, {
      key: label + idx,
      label: label,
      variant: "default",
      values: values,
      tooltip: tooltip,
      id: label + idx
    });
  })), React.createElement(Card, {
    surface: "two",
    className: "px-5 py-4 mt-8"
  }, React.createElement(ListItem, {
    label_text: label_text,
    info_text: info_text,
    button_text: info_button_text,
    variant: "button",
    handleClick: handleInfoClick
  })), React.createElement("div", {
    className: "flex flex-row-reverse pt-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    className: "px-4 xs:px-[40px] min-w-[169px]",
    onClick: handleContinueClick,
    loading: loading,
    disabled: loading
  }, continue_btn_text), React.createElement(Button, {
    id: "skip-btn",
    className: "bg-surface-level-one border-none text-secondary pr-5",
    variant: "custom",
    onClick: handleCancelClick
  }, "Cancel")));
});
RefundModal.displayName = 'RefundModal';
RefundModal.defaultProps = defaultProps$$;

var defaultProps$10 = {
  as: 'div'
};
var VerticleDatalineCentered = function VerticleDatalineCentered(_ref) {
  var label = _ref.label,
    value = _ref.value;
  return React.createElement("div", {
    className: "w-full text-center"
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true
  }, value), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, label));
};
var StatsCards = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var Component = _ref2.as,
    tier_info = _ref2.tier_info,
    total_stake = _ref2.total_stake,
    handleUpgradeTier = _ref2.handleUpgradeTier,
    total_invested = _ref2.total_invested,
    events_participated = _ref2.events_participated,
    className = _ref2.className;
  return React.createElement("div", {
    className: "overflow-x-auto"
  }, React.createElement(Component, {
    className: "grid grid-cols-3 gap-5 min-w-max " + className,
    ref: ref
  }, React.createElement(Card, {
    className: "w-[320px] md:w-[380px] p-5"
  }, React.createElement(TierLevel, {
    label: true,
    image_url: tier_info.img_url,
    is_max_tier: tier_info.is_max_tier,
    text: tier_info.tier_name,
    tier_color: tier_info.tier_color,
    multiplier: tier_info.multiplier
  }), React.createElement(DataLines, {
    top_size: "2xl",
    is_top_bold: true,
    bottom_size: "xs",
    className: "mt-5",
    variant: "verticle",
    label: "TOTAL STAKE",
    values: [{
      value: total_stake
    }]
  }), React.createElement(Button, {
    className: "w-full mt-5",
    onClick: handleUpgradeTier
  }, "Upgrade tier")), React.createElement(Card, {
    className: "w-[320px] md:w-[380px] p-5"
  }, React.createElement("div", {
    className: "w-full flex justify-center py-[34px]"
  }, React.createElement(Media, {
    size: 15,
    variant: "invested"
  })), React.createElement(VerticleDatalineCentered, {
    label: "TOTAL INVESTED",
    value: total_invested
  })), React.createElement(Card, {
    className: "w-[320px] md:w-[380px] p-5"
  }, React.createElement("div", {
    className: "w-full flex justify-center py-[34px]"
  }, React.createElement(Media, {
    size: 15,
    variant: "events"
  })), React.createElement(VerticleDatalineCentered, {
    value: events_participated,
    label: "EVENTS PARTICIPATED IN"
  }))));
});
StatsCards.displayName = 'StatsCards';
StatsCards.defaultProps = defaultProps$10;

var UpgradeTierStage;
(function (UpgradeTierStage) {
  UpgradeTierStage["Tier"] = "tier";
  UpgradeTierStage["Pools"] = "pools";
})(UpgradeTierStage || (UpgradeTierStage = {}));
var defaultProps$11 = {
  stage: UpgradeTierStage.Tier,
  min_value: 1
};
var UpgradeTierDrawer = function UpgradeTierDrawer(_ref) {
  var show = _ref.show,
    handleClose = _ref.handleClose,
    current_tier_info = _ref.current_tier_info,
    tier_info = _ref.tier_info,
    value = _ref.value,
    setValue = _ref.setValue,
    pool_arr = _ref.pool_arr,
    stage = _ref.stage,
    setStage = _ref.setStage,
    upgrade_text = _ref.upgrade_text,
    min_value = _ref.min_value;
  return React.createElement(SideDrawer, {
    show: show,
    handleClose: handleClose
  }, stage === UpgradeTierStage.Pools ? React.createElement("button", {
    onClick: function onClick() {
      return setStage(UpgradeTierStage.Tier);
    }
  }, React.createElement(Media, {
    variant: "arrow-left",
    className: "h-[17px] w-[18px] text-primary",
    size: 0
  })) : React.createElement("button", {
    onClick: handleClose
  }, React.createElement(Media, {
    variant: "cross",
    className: "h-[14px] w-[14px] text-primary",
    size: 0
  })), React.createElement(Typography, {
    className: "mt-[30px] mb-[19px]",
    size: "2xl",
    allBold: true
  }, stage === UpgradeTierStage.Pools ? 'Choose a pool to upgrade' : 'Current'), stage === UpgradeTierStage.Pools ? React.createElement("div", {
    className: "space-y-4 pt-[10px]"
  }, pool_arr.map(function (pool) {
    var _pool$multiplierChip;
    return React.createElement(PoolContainer, {
      mobItems: _extends({}, pool, {
        multiplier: (_pool$multiplierChip = pool.multiplierChip) == null ? void 0 : _pool$multiplierChip.multiplier
      }),
      key: JSON.stringify(pool),
      handlePoolClick: pool.handleClick,
      is_always_mobile: true
    }, React.createElement(PoolItem, Object.assign({}, pool, {
      is_always_mobile: true
    })));
  })) : React.createElement("div", null, React.createElement(Card, {
    surface: "two",
    className: "p-5"
  }, React.createElement(TierLevel, {
    variant: "lg",
    image_url: current_tier_info.img_url,
    text: current_tier_info.tier_name,
    is_max_tier: current_tier_info.is_max_tier,
    multiplier: current_tier_info.multiplier,
    tier_color: current_tier_info.tier_color,
    label: true
  }), React.createElement(Typography, {
    className: "mt-5",
    variant: "secondary",
    size: "sm"
  }, upgrade_text)), React.createElement(Typography, {
    className: "mt-8 mb-[19px]",
    size: "2xl",
    allBold: true
  }, "Upgrade"), React.createElement("div", {
    className: "space-y-5"
  }, tier_info.slice(0).reverse().map(function (_ref2) {
    var img_url = _ref2.img_url,
      tier_name = _ref2.tier_name,
      is_max_tier = _ref2.is_max_tier,
      multiplier = _ref2.multiplier,
      tier_color = _ref2.tier_color,
      diff_to_tier = _ref2.diff_to_tier,
      upgrade_refund_info_arr = _ref2.upgrade_refund_info_arr,
      handleClick = _ref2.handleClick;
    return React.createElement(Card, {
      surface: "two",
      key: tier_name + "-" + img_url,
      className: "p-5"
    }, React.createElement(TierLevel, {
      variant: "lg",
      image_url: img_url,
      text: tier_name,
      is_max_tier: is_max_tier,
      multiplier: multiplier,
      tier_color: tier_color,
      label: true
    }), React.createElement("div", {
      className: "space-y-[10px] pt-5 mb-[10px]"
    }, upgrade_refund_info_arr.map(function (info) {
      return React.createElement(Typography, {
        key: info,
        variant: "secondary",
        size: "sm"
      }, info);
    })), tier_name === 'Diamond' && React.createElement("div", {
      className: "w-full pt-[10px]"
    }, React.createElement(Adjust, {
      min: min_value,
      value: value,
      setValue: setValue
    })), React.createElement(Button, {
      onClick: handleClick,
      className: "bg-surface-level-three w-full mt-[10px] h-[42px]",
      variant: "custom",
      id: tier_name + "-btn"
    }, React.createElement(Typography, {
      allBold: true,
      variant: "primary",
      size: "sm"
    }, "Stake ", diff_to_tier, " DCB to upgrade")));
  }))));
};
UpgradeTierDrawer.displayName = 'UpgradeTierDrawer';
UpgradeTierDrawer.defaultProps = defaultProps$11;

var defaultProps$12 = {
  loading: false,
  disabled: false
};
var setup_tab_options = [{
  title: 'Compounding',
  id: '0'
}, {
  title: 'Dynamic',
  id: '1'
}];
var SetupForm = function SetupForm(_ref) {
  var loading = _ref.loading,
    disabled = _ref.disabled,
    handleClick = _ref.handleClick,
    select_current = _ref.select_current,
    setSelectCurrent = _ref.setSelectCurrent,
    options = _ref.options,
    handleChange = _ref.handleChange,
    state = _ref.state,
    alert_text = _ref.alert_text;
  return React.createElement("div", {
    className: "pt-5"
  }, options && React.createElement(Select, {
    current: select_current,
    setCurrent: setSelectCurrent,
    surface: "zero",
    placeholder: "Staking contract name",
    options: options,
    label: "Staking contract"
  }), React.createElement("div", {
    className: "mt-5 flex justify-between items-end"
  }, React.createElement(Input, {
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter fee wallet address",
    tooltip: "some tooltip some tooltip some tooltip some tooltip some tooltip some tooltip",
    id: "wallet-addr-input",
    label: "Fee wallet address",
    type: "text",
    value: state.wallet_addr,
    onChange: function onChange(e) {
      return handleChange('wallet_addr', e.target.value);
    }
  }), React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('wallet_addr', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "copy-btn"
  }))), React.createElement(Input, {
    containerClasses: "w-full my-5",
    surface: "zero",
    placeholder: "Enter fee percentage",
    unit: "percent",
    id: "fee-percentage-input",
    label: "Fee percentage",
    tooltip: "some tooltip some tooltip some tooltip some tooltip some tooltip some tooltip",
    max_btn: false,
    type: "text",
    value: state.fee_percentage,
    onChange: function onChange(e) {
      return handleChange('fee_percentage', e.target.value);
    }
  }), alert_text && React.createElement(Alert, {
    variant: "note"
  }, alert_text), React.createElement(Button, {
    id: "button",
    onClick: handleClick,
    className: "mt-5 w-full",
    disabled: disabled,
    loading: loading
  }, "Save changes"));
};
var FeeSetupForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(Card, {
    className: "max-w-[580px] p-5 " + props.className,
    ref: ref
  }, React.createElement(Tabs, {
    variant: "limited",
    options: setup_tab_options,
    current: props.tab_current,
    setCurrent: function setCurrent(id) {
      return props.setTabCurrent(id);
    },
    background_color: "bg-surface-level-zero"
  }), React.createElement(SetupForm, Object.assign({}, props)));
});
FeeSetupForm.displayName = 'FeeSetupForm';
FeeSetupForm.defaultProps = defaultProps$12;

var _excluded$f = ["as", "className", "mediaClassName", "setMobileNavOpen", "id", "options", "tier_info", "mobile_nav_open"];
var defaultProps$13 = {
  as: 'div',
  mediaClassName: '',
  id: 'account-dropdown'
};
var AccountDropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    mediaClassName = _ref.mediaClassName,
    setMobileNavOpen = _ref.setMobileNavOpen,
    id = _ref.id,
    options = _ref.options,
    tier_info = _ref.tier_info,
    mobile_nav_open = _ref.mobile_nav_open,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.MD;
  var init = useIntitialised();
  var handleMenuClick = is_mobile ? function () {
    return setMobileNavOpen(!mobile_nav_open);
  } : undefined;
  var mobile_icon = mobile_nav_open ? 'cross' : 'burger';
  return React.createElement(Menu, Object.assign({
    as: as,
    className: "h-11 " + className + " relative inline-block text-left",
    ref: ref
  }, rest), function (_ref2) {
    var open = _ref2.open;
    return React.createElement(React.Fragment, null, React.createElement(Menu.Button, {
      className: ['h-11', 'border', 'inline-flex', 'items-center', 'text-primary', 'border-border', 'border-opacity-[0.03]', 'bg-surface-level-two', 'hover:bg-surface-level-three', 'rounded-full'].join(' '),
      "data-testid": id,
      onClick: handleMenuClick
    }, tier_info ? React.createElement("img", {
      src: tier_info.tier_img_url,
      alt: "tier",
      className: "w-10 h-10 mr-[9px] ml-[1px]"
    }) : React.createElement(Avatar, {
      className: "mr-[9px] ml-[1px]"
    }), init && React.createElement(Media, {
      className: "mr-[13px]",
      size: 4,
      variant: "" + (is_mobile ? mobile_icon : open ? 'chevron-up' : 'chevron-down')
    }) || React.createElement("div", {
      className: "w-4"
    })), React.createElement(Transition, {
      as: as,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95"
    }, React.createElement(Menu.Items, {
      className: "hidden md:inline absolute low-border mt-1 origin-top-right right-0 rounded-lg focus:outline-none bg-surface-level-two " + (tier_info ? 'min-w-[315px]' : 'min-w-[280px]')
    }, tier_info && React.createElement(TierCard, {
      surface: "three",
      className: "m-4",
      tier_info: tier_info
    }), options.map(function (_ref3) {
      var name = _ref3.name,
        icon = _ref3.icon,
        onOptionClick = _ref3.onOptionClick,
        is_mobile = _ref3.is_mobile,
        right_btn_text = _ref3.right_btn_text,
        rightBtnHandleClick = _ref3.rightBtnHandleClick;
      return !is_mobile && React.createElement(Menu.Item, {
        "data-testid": id + "-" + name.split(' ').join('').toLocaleLowerCase(),
        key: name
      }, function (_ref4) {
        var active = _ref4.active;
        return React.createElement("div", {
          className: "w-full flex justify-between items-center rounded-lg " + (active && 'bg-surface-level-three')
        }, React.createElement("button", {
          onClick: onOptionClick,
          className: "p-4 w-full"
        }, React.createElement("div", {
          className: ['space-x-4', 'flex', 'items-center', 'w-full'].join(' ')
        }, icon && React.createElement(Media, {
          className: "h-[18px] w-[18px] " + mediaClassName,
          variant: icon,
          size: 0
        }), React.createElement(Typography, {
          size: "sm",
          variant: "secondary"
        }, name))), rightBtnHandleClick && React.createElement("button", {
          className: "px-4 text-right",
          onClick: rightBtnHandleClick
        }, React.createElement(Typography, {
          size: "sm",
          variant: "custom",
          className: "text-accent hover:underline cursor-pointer"
        }, right_btn_text)));
      });
    }))));
  });
});
AccountDropdown.displayName = 'AccountDropdown';
AccountDropdown.defaultProps = defaultProps$13;

var defaultProps$14 = {
  as: 'div'
};
var SideDrawer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    as = _ref.as,
    show = _ref.show,
    className = _ref.className,
    handleClose = _ref.handleClose;
  var _useState = useState(false),
    inside_card = _useState[0],
    setInsideCard = _useState[1];
  return React.createElement(Transition, {
    show: show,
    as: as,
    ref: ref,
    className: "min-w-screen fixed left-0 top-0 flex justify-center items-center inset-0 z-50 outline-none focus:outline-none overflow-auto " + className,
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    style: {
      backgroundColor: 'rgba(17, 6, 34, 0.8)'
    },
    onMouseDown: function onMouseDown() {
      if (!inside_card) {
        handleClose();
      }
    }
  }, React.createElement(Transition.Child, {
    className: "w-full max-w-screen sm:max-w-sm relative ml-auto my-auto shadow-lg bg-surface-level-one min-h-screen border-l-2 border-white border-opacity-5 p-4",
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "translate-x-full",
    id: "side-modal",
    onMouseEnter: function onMouseEnter() {
      return setInsideCard(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInsideCard(false);
    }
  }, children));
});
SideDrawer.displayName = 'SideDrawer';
SideDrawer.defaultProps = defaultProps$14;

var defaultProps$15 = {};
var UserProfile = function UserProfile(_ref) {
  var account_details_arr = _ref.account_details_arr,
    customer_details_arr = _ref.customer_details_arr,
    security_details_arr = _ref.security_details_arr,
    verified_wallet_details_arr = _ref.verified_wallet_details_arr,
    className = _ref.className;
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5"
  }, "Your account"), React.createElement(ListItemUnit, {
    list_item_arr: account_details_arr
  }), customer_details_arr && React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5 pt-[60px]"
  }, "Customer details"), React.createElement(ListItemUnit, {
    list_item_arr: customer_details_arr
  })), verified_wallet_details_arr && React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5 pt-[60px]"
  }, "Verified wallet"), React.createElement(ListItemUnit, {
    list_item_arr: verified_wallet_details_arr
  })), security_details_arr && React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5 pt-[60px]"
  }, "Security"), React.createElement(ListItemUnit, {
    list_item_arr: security_details_arr
  })));
};
UserProfile.displayName = 'UserProfile';
UserProfile.defaultProps = defaultProps$15;

export { Accordion$1 as Accordion, AccountDropdown, AccountProgress, Adjust, Alert, Avatar, Branding, BreakPoint, Button, Card, Carousel, Chart, Chip, Color, Composition, DataLines, Deploy, DepositWithdraw, Drawer, Dropdown, FarmSetup, FeeSetupForm, Footer, FormWrapper, Grid, GridItem, Header, HelperBox, Input, ListContainer, ListHeader, ListItem, ListItemUnit, Loader, LoginFooter, LoginForm, LoginStage, Manage, Media, MessageCard, Modal, MultiplierChip, Onboarding, ParticipationFees, PoolContainer, PoolHeader, PoolItem, PortfolioItem, ProductBadge, ProductCard, ProductCardList, index as ProductListItem, Progress, ProjectCard, RefundModal, RegisterForm, ResetPassword, ResetPasswordStage, Select, Setup, SetupForm, SideDrawer, SortSearch, SquareButtons, StakingAnalytics, StakingChips, StatsCards, StatsSummary, Steps, Summary, Tabs, TierCard, TierLevel, Toggle, Tooltip, Typography, UpgradeTierDrawer, UpgradeTierStage, UserProfile, VerifyEmail, VerticleDatalineCentered, daw_tab_options, setup_tab_options, shortenHex, useBreakpoint, useClasses, useIntitialised };
//# sourceMappingURL=ui.esm.js.map
